import React, { useState, useEffect, useRef } from "react";
import {
  Button,
  Col,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
  ModalHeader,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  FormGroup,
  Label,
  Input,
  FormFeedback
} from "reactstrap";

import { Client, Databases, Query } from "appwrite";
import getFrenchTag from "../../helpers/local_text_helper";
import { withTranslation } from "react-i18next";
import {
  createLog,
  fetchFBAccessToken,
  fetchFBPagesList,
  fetchFBPostsList,
  fetchWHCompteInfo,
  formatWABDate,
  formatWHDate,
  getConversations,
  getStripeSubscriptionPlanPriceId,
  getTotalConversations,
  updateUserData,
  getDedicatedDate,
  formatDateHours
} from "../../helpers/api_helper";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import PlusOutlined from "../../assets/images/icons/PlusOutlined";
import CrossOutlined from "../../assets/images/icons/CrossOutlined";
import SearchOutlined from "../../assets/images/icons/SearchOutlined";
import EditFilled from "../../assets/images/icons/EditFilled";
import TrashFilled from "../../assets/images/icons/TrashFilled";
import Icons from "../../static/icons";
import CustomToast from "../../components/Common/customToast/CustomToast";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import CalculatorModal from "../../components/Common/CalculatorModal/CalculatorModal";
import { useMixpanel } from "../../Hooks/useMixpanel";

import classnames from "classnames";
import CheckCircleRounded from "../../assets/images/icons/CheckCircleRounded";

import errorSm from "../../assets/images/error.png";
import { useFacebook } from "react-facebook";
import axios from "axios";

import "./styles.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import {
  Badge,
  Form,
  Container,
  Toast,
  ToastHeader,
  ToastBody,
  InputGroup,
  InputGroupText,
  UncontrolledTooltip,
  Toolbar,
  EmojiSuggestions,
  EmojiSelect,
  Collapse
} from "reactstrap";

//import { loadAuth2 } from 'gapi-script';
import { gapi, loadAuth2 } from "gapi-script";
import gmailApi from "react-gmail";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import avatar_1 from "../../assets/images/users/avatar-1.jpg";
import avatar_2 from "../../assets/images/users/avatar-2.jpg";
import avatar_3 from "../../assets/images/users/avatar-3.jpg";
import avatar_4 from "../../assets/images/users/avatar-4.jpg";
import avatar_5 from "../../assets/images/users/avatar-5.jpg";
import avatar_6 from "../../assets/images/users/avatar-6.jpg";
import avatar_7 from "../../assets/images/users/avatar-7.jpg";
import gmail_icon from "../../assets/images/mail-server-gmail_48.png";
import outlook_icon from "../../assets/images/mail-server-outlook_48.png";
import mail_custom_icon from "../../assets/images/mail-server-custom_48.png";
//import '../../assets/css/icons.min.css';
import "../../assets/css/app.min.css";
import ReadEmailView from "../E-mail/ReadEmail";
import Editor, { createEditorStateWithText } from "draft-js-plugins-editor";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { queries } from "@testing-library/react";
import EmailList from "../E-mail/EmailList";

import love from "../../assets/images/love.gif";
import like from "../../assets/images/like.gif";
import hate from "../../assets/images/hate.gif";
import neutral from "../../assets/images/neutral.gif";
// const { ImapFlow } = require('imapflow');
import aiButtonicon from "./../../assets/images/icons8-bot-48.png";
import logo_smartas_1 from "./../../assets/images/companies/img-3.png";
import synibox_icon_state_pink from "./../../assets/images/icons-infos-pink.png";
import synibix_icon_buble_chat from "./../../assets/images/companies/synibix_icon_buble_chat.png";
import logo_shopify from "./../../assets/images/logo_shopify.png";
import logo_prestashop from "./../../assets/images/logo_prestashop_white.png";
import getBoxLocalName from "../../helpers/box_local_text_helper";
import {
  copyMailPromise,
  createBoxPromise,
  deleteMailPromise,
  getCollections,
  moveMailPromise,
  searchShopifyOrder,
  createAiTextImprovementFunctionExecution,
  updateCompanyTokenUsage,
  createAIResponseExecution,
  sendMailPromise,
  sendMailDirect,
  SMARTAS,
  getLanguageVersion,
  formatDate,
  fetchSingleMail,
  getSentMessages
} from "../../helpers/api_helper";

import { useDispatch } from "react-redux";
import { element } from "prop-types";
import CheckGestalt from "../../assets/images/icons/CheckGestalt";
import ConversationComponent from "../E-mail/components/EmailListComponent";
import MetaConversationComponent from "./components/MetaListComponent";
import MetaPostComponent from "./components/MetaListPostsComponent";
import ExternalLinkDuocolor from "../../assets/images/icons/ExternalLinkDuocolor";
import DollarDuocolor from "../../assets/images/icons/DollarDuocolor";
import CheckCircleMono from "../../assets/images/icons/CheckCircleMono";
import TruckFilled from "../../assets/images/icons/TruckFilled";
import { fetchClientInfos } from "../../store/actions";

import maaiaIconInfoPink from "../../assets/images/icons-infos-pink.png";
import maaiaIconInfoPurple from "../../assets/images/icons-infos-purple.png";
import "draft-js/dist/Draft.css";

import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import createEmojiPlugin from "draft-js-emoji-plugin";
import EmailRedact from "../E-mail/EmailRedact";
import ReadMessage from "./components/ReadMessage";
import Commentaire from "./Commentaire";
import FacebookSettings from "./FacebookSettings";
import EmailFilled from "../../assets/images/icons/EmailFilled";
import IcTwotoneWechat from "../../assets/images/icons/IcTwotoneWechat";
import HugeiconsComment from "../../assets/images/icons/HugeiconsComment";
import { select } from "redux-saga/effects";
import { Tooltip } from "bootstrap/dist/js/bootstrap.bundle.min.js";
import InfoMono from "../../assets/images/icons/InfoMono";
import { tr } from "date-fns/locale";
import CallFilled from "../../assets/images/icons/CallFilled";

const MessagesPage = (props) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [toastMessage, setToastMessage] = useState({});
  // const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(false);
  // const [client_data, setCompanyInfos] = useState(undefined);
  const [wh_comptes, setWHComptes] = useState(undefined);
  const [wh_selected_comptes, setWHSelectedComptes] = useState([]);
  const [wh_selected_compte, setWHSelectedCompte] = useState(undefined);
  const [site_infos_more, setSiteInfosMore] = useState("");
  const [modal_list, setmodal_list] = useState(false);
  const [modal_list_edit, setmodal_list_edit] = useState(false);
  const [modal_topics, setModal_topics] = useState(false);
  const [modal_delete_confirm, setModal_DeleteConfirm] = useState(false);
  // let setMyNewList = [];
  // const [topicList, setTopicList] = useState([]);
  const [ressourcesList, setRessourcesList] = useState(undefined);
  const [topics_to_show, setTopicsToShow] = useState([]);
  const [topics_to_delete, setTopicsToDelete] = useState(undefined);
  // const [itemStates, setItemStates] = useState(Array(myList.length).fill({ spanVisible: false, buttonDisabled: false, element_loading: false }));
  const [itemStates, setItemStates] = useState([]);
  const [tooltip, setTooltip] = useState(undefined);
  const [show_calculator, showCalculator] = useState(false);
  const [resourceMessage, setResourceMessage] = useState(undefined);

  const [isWhConnected, setIsWhConnected] = useState(undefined);
  const [isInstagramConnected, setIsInstagramConnected] = useState(undefined);
  const [isShopifyConnected, setIsShopifyConnected] = useState(undefined);
  const [pageDropdown, setPageDropdown] = useState(false);
  const [selectedPage, setSelectedPage] = useState(undefined);
  const [commentActions, setCommentActions] = useState({});
  const [visibleDropdown, setVisibleDropdown] = useState(false);
  const [selectedWHCompteDropdown, setselectedWHCompteDropdown] =
    useState(false);
  const [isFilterDropdown, setIsFilterDropdown] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [isLogoutLoading, setIsLogoutLoading] = useState(false);
  //const [businessIds, setBusinessIds] = useState(undefined);
  const [conversationsList, setMessageList] = useState(undefined);
  const [convStoreList, setConvStoreList] = useState(undefined);
  const [totalAll, setTotalAll] = useState(0);
  const [totalTreated, setTotalTreated] = useState(0);
  const [totalUntreated, setTotalUntreated] = useState(0);
  const [totalMessenger, settotalMessenger] = useState(0);
  const [totalWhatsapp, setTotalWhatsapp] = useState(0);
  const [totalEmail, setTotalEmail] = useState(0);
  const [totalShopify, setTotalShopify] = useState(0);
  const [totalInstagram, setTotalInstagram] = useState(0);
  const [origin, setOrigin] = useState(undefined);
  const [filter, setFilter] = useState(undefined);
  const [tags, setTags] = useState(undefined);

  const [isGlobalLoading, setIsGlobalLoading] = useState(true);
  const [convsLoading, setConvsLoading] = useState(true);

  const [recherche, setRecherche] = useState("");
  const conversationsRef = useRef(undefined);

  // Email const
  const dispatch = useDispatch();

  const { mixPanelTrack } = useMixpanel();

  const [isColumnVisible, setColumnVisibility] = useState(true);
  const [btnprimary1, setBtnprimary1] = useState(false);
  const [btnprimary2, setBtnprimary2] = useState(false);

  const [fullMessage, setFullMessage] = useState(undefined);
  const [sentMessage, setSentMessage] = useState(undefined);

  const [folderbtn, setfolderbtn] = useState(false);
  // const [the_folder, setMailBox] = useState("INBOX");
  const [allowedMessages, setAllowedMessages] = useState([]);
  // const [user_prefs, setUserPrefs] = useState(undefined);
  const [tagbtn, settagbtn] = useState(false);
  const [menubtn, setmenubtn] = useState(false);
  const [showDeletionToast, setDeletionToast] = useState(false);
  const [timeCount, setTimeCount] = useState(10);
  const [isSignedIn, setIsSignedIn] = useState(false);
  // const [messages, setMessages] = useState([]);
  // const [boxes, setBoxes] = useState([]);
  const [messageInfos, setMessageInfos] = useState({});
  const [messagesTagsList, setMessagesTagsList] = useState({});
  const [messagesStateList, setMessagesStateList] = useState({});
  const [messageOrderInfos, setMessageOrderInfos] = useState({});
  // const [error, setError] = useState(undefined);
  // const [loading, setLoading] = useState(false);
  // const [boxes_loading, setBoxesLoading] = useState(false);
  const [request, setRequest] = useState(true);
  // const [client_data, setCompanyInfos] = useState();
  const [modal_backdrop, setModalVisibility] = useState(false);
  const [create_box_modal_visibility, setCreateBoxModalVisibility] =
    useState(false);
  const [modal_dossier, setmodal_dossier] = useState(false);
  const [type, setType] = useState("");
  const [mailActionLoading, setMailActionLoading] = useState(undefined);
  const [emailMoveOrCopyLoading, setEmailMoveOrCopyLoading] = useState(false);
  //const timer = setTimeout(() => { }, 20000);
  const [currentColor, setCurrentColor] = useState("blue");
  const pageSize = 15;
  // const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [totalMails, setTotalMails] = useState(0);
  // const startIndex = (currentPage - 1) * pageSize;
  // const endIndex = startIndex + pageSize;
  const [showReadEmailView, setShowReadEmailView] = useState(false);
  const [selectedConv, setSelectedConv] = useState(undefined); // État pour stocFexpker le message sélectionné
  const [previousselectedMessage, setPreviousSelectedMessage] =
    useState(undefined);
  const [selectedConvNext, setSelectedConvNext] = useState(undefined);
  const [selectedMessageNextIndex, setSelectedConvNextIndex] =
    useState(undefined);
  const [multiSelectedMessage, setMultiSelectedMessage] = useState([]);
  const [messageToDelete, setMessageToDelete] = useState(undefined); // État pour stocFexpker le message sélectionné
  const [dossierName, setDossierName] = useState("");
  // const [currentEmployee, setCurrentEmployee] = useState(undefined);
  // const [ownerInfos, setOwnerInfos] = useState({});
  // const [getMessages, setGetMessages] = useState([]);
  const [decompte, setDecompte] = useState(10);
  const [startCountdown, setStartCountdown] = useState(false);
  const [actionPerformed, setActionPerformed] = useState(false);
  const [displaySearchBar, setDisplaySearchBar] = useState(false);
  const [create_message_modal_visibility, setCreateMessageModalVisibility] =
    useState(false);
  const [to_email, setToEmail] = useState(undefined);

  const [instruction_text, setInstructionText] = useState(""); // État pour stocFexpker le message sélectionné
  const [copie, setCopie] = useState("");
  const [objet, setObjet] = useState("");
  const [destinataire, setDestinataire] = useState("");
  const selectedConvRef = useRef(undefined);

  //  const [topicList, setTopicList] = useState([]);
  // ...
  const handleChangeColor = (color) => {
    const root = document.documentElement;
    root?.style.setProperty("--bs-blue", color ? color : "red");
    console.log("applyed color");
    // root?.style.setProperty("--text-color", darkTheme ? "#fff" : "#262833");
    //   setCurrentColor(color);
  };

  const emojiPlugin = createEmojiPlugin();
  const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
  const text = "";
  const toolbarPlugin = createToolbarPlugin();
  const { Toolbar } = toolbarPlugin;
  const plugins = [toolbarPlugin, emojiPlugin];

  // modal
  const [moveToModal, setMoveToModal] = useState(false);
  const [moveToIsConfirmed, setMoveToIsConfirmed] = useState(false);
  const [folder, setFolder] = useState();
  const [actionLoading, setActionLoading] = useState();

  const [alertList, setAlertList] = useState({});

  const customOrder = [
    "inbox",
    "sent",
    "treated",
    "untreated",
    "starred",
    "archive",
    "draft",
    "trash"
  ];

  const [completeMessages, setCompleteMessages] = useState({});

  const [aiImprovmentsDisabled, setAiImprovmentsDisabled] = useState({
    value: false,
    reason: ""
  });
  const [aiSuggestionDisabled, setAiSuggestionDisabled] = useState({
    value: false,
    reason: ""
  });
  const [messageTreatmentStatus, setMessageTreatmentStatus] = useState(false);
  const [email_suggested_text, setEmailSuggestedText] = useState("");

  const [ai_action_menu, setAiActionMenu] = useState(false);

  const [instruction_request, setInstructionRequestValue] = useState(false);
  const [send_email_request, setSendEmailRequestValue] = useState(false);

  // New Editor
  const [customEditorState, setCustomEditorState] = useState(
    createEditorStateWithText(text)
  );
  const editorRef = useRef(null);

  // Commentaires
  const [fb_selected_pages, setFBSelectedPages] = useState([]);
  const [fb_selected_page, setFBSelectedPage] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [isFbConnected, setIsFbConnected] = useState(undefined);
  const [fb_pages, setFBPages] = useState(undefined);
  const [fb_posts_loading, setFBPostsLoading] = useState(false);
  const [fb_selected_posts, setFBSelectedPosts] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [isRefreshLoading, setIsRefreshLoading] = useState(false);

  const toggleVerticalIcon = (tab) => {
    if (verticalActiveTabWithIcon !== tab) {
      setverticalActiveTabWithIcon(tab);
    }
  };

  const [verticalActiveTabWithIcon, setverticalActiveTabWithIcon] =
    useState("1");

  const [convTabWithIcon, setConvTabWithIcon] = useState("3");

  const [no_configured_mailbox, setNoConfiguredMailbox] = useState(false);

  const [error, setError] = useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const isFirstRender = useRef(true);

  const toggleConvIcon = (tab) => {
    if (convTabWithIcon !== tab) {
      setConvTabWithIcon(tab);
    }
  };

  function onFbConnected(val) {
    // toggleVerticalIcon(val === true ? "2" : "3");
    setIsFbConnected(val);
  }

  const handleClick = (val, mod) => {
    // Remplacez cela par la valeur que vous souhaitez passer
    navigate(`/settings`, {
      replace: true,
      state: { tab: val, modal: mod ?? "" }
    });
  };

  // if (loading) {
  //     console.log("toto is: already loading", loading);
  // } else {

  // };

  async function updateCompanyInfos(data) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      {
        company_data: data.map((item) => JSON.stringify(item, null, 4))
      }
    );
    return promise.then(
      async function (response) {
        console.log(response); // Success
        return response;
      },
      function (error) {
        onDeleteLoadingChanged(false);
        setToastMessage({
          header: props.t("Echec"),
          body: error.message,
          key: "danger"
        });
        toggleToast();
        console.log(error); // Failure
        return null;
      }
    );
  }

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };

  const onLoadingChanged = (val) => {
    setLoading(val);
  };

  const onLoginLoadingChanged = (val) => {
    isLoginLoading(val);
  };

  const onSetOrigin = (val) => {
    setOrigin(val);
  };

  const onSetFilter = (val) => {
    setFilter(val);
  };
  const onSetTags = (val) => {
    setTags(val);
  };

  useEffect(() => {
    getClientData();
  }, []);

  useEffect(() => {
    if (state?.id) {
      fetchConversations(undefined, undefined, undefined, state.id, true);
    } else if (isFirstRender.current) {
      // Lors de la première exécution, on empêche l'effet
      fetchConversations(origin, filter, tags, recherche);
      isFirstRender.current = false; // On réinitialise le flag
    }
    // if (selectRS === "whatsapp") {
    //   fetchConversations("whatsapp", true);
    // } else if ((selectRS === "email", true)) {
    //   fetchConversations("email", true);
    // } else if ((selectRS === "messenger", true)) {
    //   fetchConversations("messenger", true);
    // } else {
    //   fetchConversations("instagram", true);
    // }
    const client = new Client();

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const realtime = client;
    const databaseId = "default";
    const collectionId = "conversations";

    // S'abonner aux événements Realtime

    const unsubscribe = realtime.subscribe(
      `databases.${databaseId}.collections.${collectionId}.documents`,
      (response) => {
        console.log("Receive event: ", response);
        if (response.events.some((event) => event.includes("create"))) {
          console.log("Document created:", response.payload);
          createConversation(response.payload);
        }
        if (response.events.some((event) => event.includes("update"))) {
          console.log("Document updated:", response.payload);
          updateRealTimeConversation(response.payload);
        }
        if (response.events.some((event) => event.includes("delete"))) {
          console.log("Document deleted:", response.payload);
          deleteConversation(response.payload);
        }

        // switch (response.events[5]) {
        //   case `databases.${databaseId}.collections.${collectionId}.documents.*.create`:
        //     fetchConversations(
        //       origin,
        //       filter,
        //       tags,
        //       recherche,
        //       true,
        //       response.payload
        //     );
        //     break;

        //   case `databases.${databaseId}.collections.${collectionId}.documents.*.update`:
        //     fetchConversations(
        //       origin,
        //       filter,
        //       tags,
        //       recherche,
        //       true,
        //       response.payload
        //     );
        //     break;
        //   case `databases.${databaseId}.collections.${collectionId}.documents.*.delete`:
        //     fetchConversations(
        //       origin,
        //       filter,
        //       tags,
        //       recherche,
        //       true,
        //       response.payload
        //     );
        //     break;

        //   default:
        //     break;
        // }
      }
    );

    // Nettoyer l'abonnement lors du démontage du composant
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (parentDivRef.current) {
      const parentDiv = parentDivRef.current;

      const handleScroll = () => {
        // Vérifiez si l'élément div atteint la fin de la liste
        if (
          parentDiv.scrollTop + parentDiv.clientHeight >=
          parentDiv.scrollHeight
        ) {
          console.log("handleScroll Launch next page");
          refreshConversations();
        }
      };

      parentDiv.addEventListener("scroll", handleScroll);

      // Nettoyer l'écouteur d'événement lors du démontage du composant
      return () => {
        parentDiv.removeEventListener("scroll", handleScroll);
      };
    }
  }, [isRefreshLoading, conversationsList]);

  const [deleteLoading, setDeleteLoading] = useState({});
  const [addLoading, setAddLoading] = useState(false);

  const onDeleteLoadingChanged = (item) => {
    setDeleteLoading(item);
  };

  function onWhConnected(val) {
    toggleVerticalIcon(val === true ? "1" : "4");
    setIsWhConnected(val);
  }

  function onShopifyConnected(val) {
    setIsShopifyConnected(val);
  }

  function onInstagramConnected(val) {
    setIsInstagramConnected(val);
  }

  async function handleLogin() {
    setIsLoginLoading(true);

    try {
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
      window.location.href = `https://meta-app.semecloud.tech/auth/connect/meta?userId=${user_id}&companyId=${localStorage.getItem(
        "companyId"
      )}`;
    } catch (error) {
      console.log(error);
    }
    setIsLoginLoading(false);

    // TODO Get autorization code when login: https://your-redirect-uri.com/?code=AUTHORIZATION_CODE&state=UNIQUE_STRING
    // TODO Get access token with post method : https://graph.facebook.com/v21.0/oauth/access_token params(client_id, redirect_uri, client_secret, code)
    // const response = await axios.get(url, data, { headers });
    // const api = await init();

    // // const response = await api.login();
    // const FB = await api.getFB(); // Get original FB object

    // FB.login(
    //   function (response) {
    //     console.log(response);
    //     if (response.authResponse) {
    //       handleFBLoginSuccess(response.authResponse);
    //     }
    //   },
    //   {
    //     config_id: "575923421469247",
    //     response_type: "code",
    //     override_default_response_type: true
    //   }
    // );
  }

  async function handleLogout() {
    setIsLogoutLoading(true);
    const data = {
      compannyId: localStorage.getItem("companyId")
    };
    try {
      const response = await axios.post(
        "https://meta-app.semecloud.tech/auth/disconnect",
        data
      );
      console.log({ logoutResponse: response });
      setIsWhConnected(false);
      setIsLogoutLoading(false);
      setToastMessage({
        header: props.t("Succès"),
        body: props.t("Déconnexion effectuée"),
        key: "success"
      });
    } catch (error) {
      console.log({ logoutResponse: error });
      setIsLogoutLoading(false);
      setToastMessage({
        header: props.t("Echec"),
        body: error.message,
        key: "danger"
      });
    }
  }

  async function handleFBLoginSuccess(auth) {
    onLoginLoadingChanged(true);
    const code = auth.code;

    try {
      const access_token_response = await fetchFBAccessToken(code);

      await updateUserData(localStorage.getItem("companyId"), {
        fb_user_id: access_token_response.user_id,
        fb_access_token: access_token_response.access_token
      });

      const response = await fetchFBPagesList(
        access_token_response.access_token,
        access_token_response.user_id
      );

      setIsWhConnected(true);
      setWHComptes(
        response.pages.map((page) => {
          return {
            id: page.id,
            name: page.name,
            category: page.category,
            access_token: page.access_token
          };
        })
      );
      onLoginLoadingChanged(false);
    } catch (error) {
      onLoginLoadingChanged(false);
    }
  }

  const onGlobalLoadingChanged = (val) => {
    setIsGlobalLoading(val);
  };

  const onConvsLoading = (val) => {
    setConvsLoading(val);
  };

  const getClientData = async function () {
    onGlobalLoadingChanged(true);
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      const promise = databases.getDocument(
        "default",
        "client_infos",
        localStorage.getItem("companyId")
      );

      promise.then(
        async function (response) {
          console.log("getClientData", response);
          const clientInfos = response;
          checkConnectionState(clientInfos);
          onGlobalLoadingChanged(false);
        },
        function (error) {
          onGlobalLoadingChanged(false);
          console.log(error);
          return null;
        }
      );
    } catch (error) {
      console.log(error);
      onGlobalLoadingChanged(false);
    }
  };

  async function checkConnectionState(clientInfos) {
    if (
      clientInfos.whatsappConnections &&
      clientInfos.whatsappConnections.length > 0
    ) {
      onWhConnected(true);
    } else {
      onWhConnected(false);
    }
    if (clientInfos.fb_access_token) {
      onFbConnected(true);
    } else {
      onFbConnected(false);
    }
    if (clientInfos.shopify_store_url) {
      onShopifyConnected(true);
    } else {
      onShopifyConnected(false);
    }
    if (
      clientInfos.instagramConnections &&
      clientInfos.instagramConnections.length > 0
    ) {
      onInstagramConnected(true);
    } else {
      onInstagramConnected(false);
    }

    onConvsLoading(false);
  }

  const fetchConversations = async (
    origin,
    filter,
    tags,
    search,
    refresh,
    convPayload
  ) => {
    console.log({ fetchConversatio: { origin, filter, tags } });
    try {
      if (!refresh) {
        onConversationList(undefined);
        onConvsLoading(true);
      }

      setError(undefined);

      const conv = await getConversations(
        origin,
        filter,
        tags,
        search,
        pageSize,
        undefined
      );
      onConversationList(conv);
      onConvsLoading(false);

      console.log({ conv: conv });

      if (conv && conv.length > 0) {
        if (selectedConv && convPayload) {
          if (selectedConv.$id === convPayload.$id) {
            goToMessageReadView(convPayload);
          }
        } else {
          goToMessageReadView(conv[0]);
          setSelectedConvNext(conv[1]);
          setSelectedConvNextIndex(1);
        }
      } else if (conv && conv.length === 0 && showReadEmailView) {
        setShowReadEmailView(false);
        onSelectedConv(undefined);
      }

      console.log("fetchOriginTotalConversation", filter, origin, tags);

      if (filter) {
        fetchOriginTotalConversation(filter);
      } else {
        fetchBoxTotalConversation(tags ? undefined : origin, tags);
      }

      // if (origin) {
      //   fetchBoxTotalConversation(origin);
      // }

      // if (tags) {
      //   fetchBoxTotalConversation(origin);
      // }
      // if (!filter && !origin && !tags) {
      //   fetchBoxTotalConversation(origin);
      // }
    } catch (error) {
      setError(error);
      setConvsLoading(false);
      console.log({ getConversationsError: error });
    }
  };

  const createConversation = async (convPayload) => {
    if (conversationsRef.current && conversationsRef.current.length > 0) {
      const convs = [convPayload, ...conversationsRef.current];
      onConversationList(convs);
    } else {
      onConversationList([convPayload]);
      goToMessageReadView(convPayload);
    }
  };

  const updateRealTimeConversation = async (convPayload) => {
    console.log({ "Document updated existant: ": conversationsRef.current });
    if (conversationsRef.current) {
      const index = conversationsRef.current.findIndex(
        (item) => item.$id === convPayload.$id
      );
      console.log({ "Document updated existant index: ": index });
      if (index > -1) {
        conversationsRef.current[index] = convPayload;
        onConversationList([...conversationsRef.current]);
        if (
          selectedConvRef.current &&
          selectedConvRef.current.$id === convPayload.$id
        ) {
          goToMessageReadView(convPayload);
        }
      }
    }
  };

  const deleteConversation = async (convPayload) => {
    if (conversationsRef.current) {
      const index = conversationsRef.current.findIndex(
        (item) => item.$id === convPayload.$id
      );
      if (index > -1) {
        conversationsRef.current.splice(index, 1);
        onConversationList([...conversationsRef.current]);
      }
    }
  };

  const fetchBoxTotalConversation = async (origin, tag) => {
    console.log("fetchBoxTotalConversation");

    onTotalAll(0);
    onTotalTreated(0);
    onTotalUntreated(0);
    const allTotal = await getTotalConversations(
      origin,
      filter,
      recherche,
      tag
    );
    const treateds = await getTotalConversations(
      origin,
      "treated",
      recherche,
      tag
    );
    const untreateds = await getTotalConversations(
      origin,
      "untreated",
      recherche,
      tag
    );
    if (allTotal) {
      onTotalAll(allTotal);
    }
    if (treateds) {
      onTotalTreated(treateds);
    }
    if (untreateds) {
      onTotalUntreated(untreateds);
    }
  };

  function onConversationList(convs) {
    setMessageList(convs);
    conversationsRef.current = convs;
  }

  function onTotalAll(val) {
    setTotalAll(val);
  }

  function onTotalTreated(val) {
    setTotalTreated(val);
  }

  function onTotalUntreated(val) {
    setTotalUntreated(val);
  }

  const fetchOriginTotalConversation = async (filter) => {
    console.log("fetchOriginTotalConversation");

    setTotalWhatsapp(0);
    settotalMessenger(0);
    setTotalEmail(0);
    setTotalInstagram(0);
    const allWhatsapp = await getTotalConversations(
      "whatsapp",
      filter,
      recherche,
      tags
    );
    const allMessenger = await getTotalConversations(
      "messenger",
      filter,
      recherche,
      tags
    );
    const allEmail = await getTotalConversations(
      "email",
      filter,
      recherche,
      tags
    );

    const allShopfy = await getTotalConversations(
      "shopify",
      filter,
      recherche,
      tags
    );

    const allInstagram = await getTotalConversations(
      "instagram",
      filter,
      recherche,
      tags
    );

    if (allEmail) {
      setTotalEmail(allEmail);
    }
    if (allShopfy) {
      setTotalShopify(allShopfy);
    }
    if (allWhatsapp) {
      setTotalWhatsapp(allWhatsapp);
    }
    if (allMessenger) {
      settotalMessenger(allMessenger);
    }
    if (allInstagram) {
      setTotalInstagram(allInstagram);
    }
  };

  const refreshConversations = async () => {
    try {
      setIsRefreshLoading(true);
      const conv = await getConversations(
        origin,
        filter,
        tags,
        recherche,
        pageSize,
        conversationsList
      );
      console.log({ refreshConversations: conv });
      if (conv) {
        if (conversationsList) {
          conversationsList.push(...conv);
          onConversationList(conversationsList);
        }
      }
      setIsRefreshLoading(false);
    } catch (error) {
      setIsRefreshLoading(false);
      console.log({ refreshConversationsError: error });
    }
  };

  // const getMailConversations = async (origin) => {
  //   try {
  //     setMessageList(undefined);
  //     onConvsLoading(true);
  //     if (businessIds) {
  //       let all_convs = [];
  //       const conv = await getConversations(origin);
  //       all_convs = [...conv];
  //       setMessageList(all_convs);
  //       onConvsLoading(false);
  //       console.log({ all_convs: all_convs });

  //       if (all_convs.length > 0) {
  //         // fetchAllEmailConversations(email_conversations);
  //         const firstMessage = all_convs[0];
  //         if (
  //           (!selectedMessage && !messageToDelete) ||
  //           (!selectedMessage &&
  //             messageToDelete &&
  //             !messageToDelete.includes(firstMessage.$id)) ||
  //           (state && state.id)
  //         ) {
  //           goToMessageReadView(firstMessage);
  //           console.log({ selectedMessage, selectedMessageNext });
  //           setSelectedMessageNext(all_convs[1]);
  //           setSelectedMessageNextIndex(1);
  //         }
  //       } else if (all_convs.length === 0 && showReadEmailView) {
  //         setShowReadEmailView(false);
  //         setSelectedMessage(undefined);
  //       }
  //     }
  //   } catch (error) {
  //     console.log({ getWABConversations: error });
  //   }
  // };

  // Email methods
  // Comparaison personnalisée
  const equalityFunction = (prev, next) => {
    return (
      prev.messages === next.messages &&
      prev.error === next.error &&
      prev.loading === next.loading &&
      prev.boxes_loading === next.boxes_loading &&
      prev.boxes === next.boxes &&
      prev.currentPage === next.currentPage &&
      prev.totalPages === next.totalPages &&
      prev.currentBox === next.currentBox &&
      prev.isSearch === next.isSearch &&
      prev.folders_fetchError === next.folders_fetchError
    );
  };

  const equalityFunction2 = (prev, next) => {
    return (
      prev.boxes === next.boxes &&
      prev.folders_fetchError === next.folders_fetchError
    );
  };

  const { client_data, currentEmployee, topicList } = useSelector((state) => {
    const theClientData = state.GeneralStateRedux.client_data;
    let theTopicList = [];
    let theCurrentEmployee;
    if (theClientData) {
      const employees = theClientData.collaborators ?? [];
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;

      // const employees = employeesList.map((element) => JSON.parse(element));
      const emp = employees.filter((element) => element.id === user_id);
      if (emp && emp.length > 0) {
        // setCurrentEmployee(currentEmployee[0]);
        theCurrentEmployee = emp[0];
      }

      const parsedCompanyData = theClientData.company_data.map((item) => {
        try {
          return JSON.parse(item);
        } catch (error) {
          console.error("Erreur de parsing JSON :", error);
          return null;
        }
      });

      theTopicList = parsedCompanyData;
    }

    return {
      client_data: theClientData,
      topicList: theTopicList,
      currentEmployee: theCurrentEmployee
    };
  });

  function findMostCommonDelimiter(folders) {
    console.log("findMostCommonDelimiter", folders);

    let mostCommonDelim = ".";
    if (folders && folders.length > 0) {
      mostCommonDelim = folders[0].delim;
    }
    console.log("findMostCommonDelimiter delim", mostCommonDelim);

    return mostCommonDelim;
  }

  function reorderFolders(the_folders_redux) {
    // Filtrer les dossiers en retirant le dossier parent "SMARTAS"
    const filteredList = the_folders_redux.filter((item) => {
      const name = item.name.toUpperCase();
      return (
        name === "INBOX" ||
        (name !== "SMARTAS" &&
          name !== "INBOX.SMARTAS" &&
          (name.startsWith("SMARTAS") || name.startsWith("INBOX.SMARTAS")))
      );
    });

    // Trier les dossiers : INBOX en premier, puis sous-dossiers SMARTAS, puis le reste
    const sortedList = filteredList.sort((a, b) => {
      const folderA = a.name.toUpperCase();
      const folderB = b.name.toUpperCase();

      // Placer "INBOX" en premier
      if (folderA === "INBOX") return -1;
      if (folderB === "INBOX") return 1;

      // Ensuite les dossiers "SMARTAS", en ignorant le dossier parent "SMARTAS"
      if (folderA.startsWith("SMARTAS")) return -1;
      if (folderB.startsWith("SMARTAS")) return 1;

      return 0; // Maintenir l'ordre pour les autres dossiers
    });

    // Séparer en dossiers de type SMARTAS et autres
    const maiaFolders = sortedList.filter((item) => {
      const name = item.name.toLowerCase();
      return ["inbox", "sent", "treated", "untreated"].some((keyword) =>
        name.includes(keyword)
      );
    });

    const otherFolders = sortedList.filter(
      (item) => !maiaFolders.includes(item)
    );

    // Combiner les dossiers SMARTAS en premier, puis les autres
    const finalSort = [...maiaFolders, ...otherFolders];

    // Ajouter des dossiers par défaut s'ils n'existent pas
    const objectsToAdd = [
      { name: "Sent" },
      { name: "Treated" },
      { name: "Untreated" },
      { name: "Starred" },
      { name: "Archive" },
      { name: "Drafts" },
      { name: "Trash" }
    ];

    objectsToAdd.forEach((newObj) => {
      const isObjectExist = finalSort.some((existingItem) =>
        existingItem.name.includes(newObj.name)
      );
      if (!isObjectExist) {
        finalSort.push(newObj);
      }
    });

    return finalSort;
  }

  const [updateAlertloading, setUpdateAlertloading] = useState(false);

  // const onBoxChanged = (value) => {
  //   setMailBox(value);
  // };

  const onFolderChanged = (value) => {
    setFolder(value);
  };

  const onMailActionLoading = (value) => {
    setMailActionLoading(value);
  };

  const onMoveToConfirmed = () => {
    setMoveToIsConfirmed(true);
  };
  function tog_Modal(folder) {
    setMoveToModal(!moveToModal);

    if (folder) {
      setFolder(folder);
    }
  }

  let timeoutId;
  let seconds = 10;

  async function getAlerts(messageId) {
    try {
      if (!localStorage.getItem("companyId")) {
        return;
      }

      const client = new Client();
      const databases = new Databases(client, "default");
      client
        .setEndpoint(process.env.REACT_APP_DATABASEURL)
        .setProject(process.env.REACT_APP_PROJECTID);

      const response = await databases.listDocuments("default", "alert", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("active", true),
        Query.equal("client_message_id", messageId),
        Query.limit(100),
        Query.orderDesc("$createdAt")
      ]);
      // console.log("getAlert", { messageId, alerts: response.documents });
      return response.documents;
    } catch (error) {
      console.error("Failed to fetch alert data:", error);
      throw error; // Vous pouvez relancer l'erreur ou gérer l'erreur de manière appropriée ici
    }
  }
  async function getMessageInfos(messageID) {
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      // console.log("Fetching message info for " + messageID);
      const response = await databases.listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("conversation_id", messageID)
      ]);
      // console.log("response.documents.length is ", response.documents.length);
      return response.documents.length > 0 ? response.documents[0] : undefined;
    } catch (error) {
      console.log(error); // Echec
      // console.log("Failed to fetch message info:", error);
      return undefined;
    }
  }

  async function getMessageTags(messageID) {
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    return databases
      .listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.select(["contact_reasons"]),
        Query.equal("conversation_id", messageID)
      ])
      .then(
        function (response) {
          var tags = [];
          for (let index = 0; index < response.documents.length; index++) {
            const element = response.documents[index];
            tags = [...tags, ...element.contact_reasons];
          }
          return tags;
        },
        function (error) {
          console.log(error); // Echec
          console.log("Failed to fetch message info:", error);
          return [];
        }
      );
  }

  function getFormatedAddress(address) {
    const city =
      address.city && address.city.names ? address.city.names.fr : "";

    const country = address.country ? address.country : "";
    return city + " " + country;
  }

  // const customOrder = [
  //   "maia.inbox",
  //   "maia.sent",
  //   "maia.treated",
  //   "maia.untreated",
  //   "maia.starred",
  //   "maia.archive",
  //   "maia.draft",
  //   "maia.trash",
  // ];

  const stringToColour = (str) => {
    let hash = 0;
    str.split("").forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += value.toString(16).padStart(2, "0");
    }

    // Vérifiez si la couleur générée est dans la plage de jaune
    if (/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colour)) {
      const hexValue = colour.replace("#", "");
      const r = parseInt(hexValue.slice(0, 2), 16);
      const g = parseInt(hexValue.slice(2, 4), 16);
      const b = parseInt(hexValue.slice(4, 6), 16);

      // YELLOW
      if (r >= 200 && g >= 200 && b < 100) {
        colour = "#FF5733";
      }

      // WHITE
      const whiteThreshold = 200;
      if (r >= whiteThreshold && g >= whiteThreshold && b >= whiteThreshold) {
        colour = "#333333";
      }
    }

    // return colour;
    return "#5E44FE";
  };
  // Fonction de traduction basée sur un switch
  /*
  const translateContactReasons = (reasons) => {
    const translatedReasons = reasons.map((reason) => {
      switch (reason) {
        case "product":
          return "Informations sur le produit";
        case "product_price":
          return "Prix du produit";
        case "refund":
          return "Remboursement";
         default:
          return reason;
      }
    }); 
     settranslatedReasons(translatedReasons);
   };*/

  // const onLoading = (val) => {
  //   setLoading(val);
  // };

  // const onBoxesLoading = (val) => {
  //   setBoxesLoading(val);
  // };
  /*
  const client = new ImapFlow({
    host: 'mail.integracom.fr',
    port: 993,
    secure: true,
    auth: {
        user: 'a.anihouvi@integracom.fr',
        pass: 'KdbgsKCo).taIUGH'
    }
});
*/

  /*
const getIMAPMails = async () => {
  // Wait until client connects and authorizes
  await client.connect();

  // Select and lock a mailbox. Throws if mailbox does not exist
  let lock = await client.getMailboxLock('INBOX');
  try {
      // fetch latest message source
      // client.mailbox includes information about currently selected mailbox
      // "exists" value is also the largest sequence number available in the mailbox
      let message = await client.fetchOne(client.mailbox.exists, { source: true });
      console.log(message.source.toString());

      // list subjects for all messages
      // uid value is always included in FETCH response, envelope strings are in unicode.
      for await (let message of client.fetch('1:*', { envelope: true })) {
          console.log(`${message.uid}: ${message.envelope.subject}`);
      }
  } finally {
      // Make sure lock is released, otherwise next `getMailboxLock()` never returns
      lock.release();
  }

  // log out and close connection
  await client.logout();
};
*/

  /*
  const signOut = async () => {
    var auth2 = gapi.auth2.getAuthInstance();
    await auth2.signOut();
    console.log("User signed out.");
    if (!auth2.isSignedIn.get()) {
      setIsSignedIn(auth2.isSignedIn.get());

      setToastMessage(
        "Vous avez révoqué la synchronisation à votre boite e-mail."
      );
      toggleToast();
    }
  };
  const handleSignIn = async () => {
    try {
      const auth = await loadAuth2(gapi, CLIENT_ID, SCOPES);
      // const auth2 = await loadAuth2(gapi, process.env.REACT_APP_CLIENT_ID, '')

      if (!auth.isSignedIn.get()) {
        await auth.signIn();
      }
      setIsSignedIn(auth.isSignedIn.get());
      // Si l'utilisateur est connecté, obtenez l'accès à l'API Gmail.
      if (auth.isSignedIn.get()) {
        const googleUser = auth.currentUser.get();
        const accessToken = googleUser.getAuthResponse().access_token;
        // Utilisez `accessToken` pour accéder à l'API Gmail.
        console.log(`Access token: ${accessToken}`);
        getMessages();
      }
    } catch (error) {
      console.error(error);
    }
  };


  const loadGmailEmailsIfConnected = async () => {
    try {
      const auth = await loadAuth2(gapi, CLIENT_ID, SCOPES);
      // const auth2 = await loadAuth2(gapi, process.env.REACT_APP_CLIENT_ID, '')

      setIsSignedIn(auth.isSignedIn.get());
      // Si l'utilisateur est connecté, obtenez l'accès à l'API Gmail.
      if (auth.isSignedIn.get()) {
        const googleUser = auth.currentUser.get();
        const accessToken = googleUser.getAuthResponse().access_token;
        // Utilisez `accessToken` pour accéder à l'API Gmail.
        console.log(`Access token: ${accessToken}`);
        getMessages();
      }
    } catch (error) {
      console.error(error);
    }
  };

    const getMessages = async () => {
    setTimeout(async () => {
      const res = await gmailApi.getMessages(false, 15);
      var data = gmailApi.normalizeData(res);
      setMessages(data);
      // var body = gmailApi.getBody(res);
      //  console.log("body is");
      //  console.log(body);
    }, 2000);
  };
  */

  /*
  const onUserPrefsChange = (val) => {
    setUserPrefs(val);
  };
  */

  const { freeTranslationLimit, userPlan } = useSelector((state) => ({
    userPlan: state.subscription.userPlan,

    freeTranslationLimit: state.subscription.freeTranslationLimit
  }));

  async function incrementAttr() {
    if (!client_data) {
      return;
    }

    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    let promise;
    if (client_data.free_translation_count < freeTranslationLimit) {
      promise = databases.updateDocument(
        "default",
        "client_infos",
        localStorage.getItem("companyId"),
        {
          free_translation_count:
            (client_data.free_translation_count || 0) +
            SMARTAS.MAIL_COST[userPlan]
        }
      );
    } else {
      promise = databases.updateDocument(
        "default",
        "client_infos",
        localStorage.getItem("companyId"),
        {
          consumed_email_count:
            (client_data.consumed_email_count || 0) +
            SMARTAS.MAIL_COST[userPlan] / 4
        }
      );
    }

    promise.then(
      async function (response) {
        var data = response;
        console.log({ CompanyInfos: response });
        dispatch(fetchClientInfos());
        // setCompanyInfos(data);
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id: client_data.$id,
          reason: "Text translation"
        };
        let payload = {
          event: "credit_consumed",
          author_id: user_id,
          company_id: client_data.$id,
          log_data: JSON.stringify(logData)
        };
        createLog(payload, mixPanelTrack);
        dispatch(fetchClientInfos());
      },
      function (error) {
        console.log(error); // Failure
      }
    );
  }

  async function incrementAttrByValue(value, reason) {
    if (!client_data) {
      return;
    }

    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      {
        consumed_email_count: (client_data.consumed_email_count || 0) + value
      }
    );

    promise.then(
      async function (response) {
        var data = response;
        console.log({ CompanyInfos: response });
        dispatch(fetchClientInfos());
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id: client_data.$id,
          reason
        };
        let payload = {
          event: "credit_consumed",
          author_id: user_id,
          company_id: client_data.$id,
          log_data: JSON.stringify(logData)
        };
        createLog(payload, mixPanelTrack);
        dispatch(fetchClientInfos());
      },
      function (error) {
        console.log(error); // Failure
      }
    );
  }

  function togModalVisibility() {
    setModalVisibility(!modal_backdrop);
  }
  function togModalDossierVisibility() {
    setmodal_dossier(!modal_dossier);
  }

  const stopDeletionCountdown = () => {
    setStartCountdown(false); // Arrête le décompte lorsque le décompte atteint 0
    setDecompte(10);
    setMessageToDelete(null);
  };

  async function triggerTimeout() {
    await new Promise((resolve) => setTimeout(resolve, 5000));
    setActionPerformed(false);
  }

  useEffect(() => {
    let interval;

    if (startCountdown) {
      interval = setInterval(() => {
        setDecompte((prevDecompte) => prevDecompte - 1);
      }, 1000);
    }

    return () => clearInterval(interval); // Nettoyer l'intervalle lors du démontage du composant
  }, [startCountdown]);

  useEffect(() => {
    // onLoading(true);
    if (!localStorage.getItem("selected_mail_box")) {
      if (client_data && client_data.mailBox.length > 0) {
        localStorage.setItem("selected_mail_box", client_data.mailBox[0].email);
      } else {
        setNoConfiguredMailbox(true);
        return;
      }
    }
  }, []);

  /*
  const fetchAllEmailConversations = async (email_conv) => {
    console.log("fetchAllEmailConversations");

    let fullMessagesList = localStorage.getItem(
      `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`
    );

    if (!fullMessagesList) {
      fullMessagesList = {};
    } else {
      fullMessagesList = JSON.parse(fullMessagesList);
    }
    // console.log("fetchSingleMail length", Object.keys(fullMessagesList)?.length);

    for (let c_index = 0; c_index < email_conv[getBoxFromUrl()].length; c_index++) {
      const message = email_conv[getBoxFromUrl()][c_index];

      if (fullMessagesList[message.$id] && fullMessagesList[message.$id] !== "failed") {
        //  console.log("fetchSingleMail: mail exist", message.$id, fullMessagesList[message.$id], message.subject);
        setFullMessage(fullMessagesList);
        const fullMsg = fullMessagesList[message.$id];
        fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);
      }

      try {
        const fullMail = await fetchSingleMail(message.$id, client_data.$id, the_folder);
        // if (isCancelled.current) return;

        if (fullMail && fullMail.mails && fullMail.mails.length > 0) {
          console.log("fetchSingleMail Full mail for ===", { sub_1: message.subject, sub_2: fullMail.mails[0].subject });
          const fullMsg = fullMail.mails[0];
          fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);

          fullMessagesList[message.$id] = fullMail.mails[0];
          setFullMessage(fullMessagesList);
          localStorage.setItem(
            `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`,
            JSON.stringify(fullMessagesList)
          );
        } else {
          fullMessagesList[message.$id] = "failed";
          setFullMessage(fullMessagesList);
        }
      } catch (error) {
        // if (isCancelled.current) return;

        fullMessagesList[message.$id] = "failed";
        setFullMessage(fullMessagesList);
        console.log("catch fetchSingleMail", error);
      }
    }
  };
  */

  function fetchMessageOrders(messages) {
    console.log({ full_messages: messages, messageOrderInfos });

    if (selectedConv) {
      if (
        !messageOrderInfos ||
        (messageOrderInfos && !messageOrderInfos[selectedConv.$id])
      ) {
        // const messages = selectedMessage.related_messages ? [selectedMessage, ...selectedMessage.related_messages] : [selectedMessage];
        console.log({ fetchAgain: messageOrderInfos });

        // const orderPromises = messages.map((message) => fetchMessagesOrderInfos(message));
        const orderPromises = [selectedConv].map((conv) =>
          fetchMessagesOrderInfos(conv)
        );
        try {
          // Attendre que toutes les promesses soient résolues
          Promise.all(orderPromises).then((res) => {
            console.log("Orders fetched successfully", res);
          });
        } catch (error) {
          console.error("Error while fetching orders:", error);
        }
      }
    }
  }

  function cleanMessageId(messageId) {
    // Expression régulière pour capturer l'ID de message dans les chevrons <>
    const pattern = /<([^>]+)>/;
    // Enlever les caractères de retour à la ligne
    const cleanId = messageId.replace(/\r\n/g, "").trim();

    // Extraire la partie utile de l'ID de message
    const match = pattern.exec(cleanId);
    return match ? match[0] : cleanId;
  }

  /*
  const fetchMessageOrders = useCallback(() => {
    console.log("fetchMessageOrders");
    if (selectedMessage) {
      if (!messageOrderInfos[selectedMessage.$id]) {
        const messages = selectedMessage.related_messages 
          ? [selectedMessage, ...selectedMessage.related_messages] 
          : [selectedMessage];
        
        const orderPromises = messages.map((message) => fetchMessagesOrderInfos(message));
        
        Promise.all(orderPromises)
          .then((res) => {
            console.log("Orders fetched successfully", res);
            // Mise à jour de messageOrderInfos avec les nouvelles informations
            setMessageOrderInfos(prevInfos => ({
              ...prevInfos,
              [selectedMessage.$id]: res
            }));
          })
          .catch((error) => {
            console.error("Error while fetching orders:", error);
          });
      }
    }
  }, [selectedMessage, messageOrderInfos]);

  useEffect(() => {
    let intervalId;
    
    if (selectedMessage) {
      fetchMessageOrders();
      intervalId = setInterval(fetchMessageOrders, 5000); 
    }
    
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [selectedMessage, fetchMessageOrders]);
*/

  // function getMessageAssignation(message) {
  //   let messageId = "";
  //   if (typeof message.headers["message-id"] === "string") {
  //     messageId = message.headers["message-id"];
  //   } else if (Array.isArray(message.headers["message-id"])) {
  //     messageId = message.headers["message-id"][0];
  //   }
  //   messageId = cleanMessageId(messageId);
  //   let name = "-";

  //   if (client_data && messageInfos && messageInfos[messageId]) {
  //     const agents = client_data.agents.map((element) => JSON.parse(element));
  //     for (let i = 0; i < agents.length; i++) {
  //       if (agents[i].id === messageInfos[messageId].treated_by) {
  //         name =
  //           messageInfos[messageId].treated_by_ia === true ? (
  //             <div style={{ direction: "flex", alignItems: "end" }}>
  //               <span>{agents[i].agent_name}</span>
  //               <img
  //                 src={aiButtonicon}
  //                 alt="aiButton__icon"
  //                 style={{
  //                   width: "24px",
  //                   height: "24px",
  //                   paddingLeft: "5px"
  //                 }}
  //               />
  //             </div>
  //           ) : (
  //             <span>{agents[i].agent_name}</span>
  //           );
  //       }
  //     }
  //   }

  //   return name;
  // }

  function formaterDate(timestamp, with_year) {
    const date =
      timestamp.length < 13 ? parseInt(timestamp) * 1000 : parseInt(timestamp);
    const dateObj = new Date(date);
    const maintenant = new Date();
    const estAujourdhui = dateObj.toDateString() === maintenant.toDateString();
    const mois = dateObj.toLocaleString(props.i18n.language, {
      month: "short"
    });
    const jour = estAujourdhui ? "Aujourd'hui" : dateObj.getDate();
    const annee = dateObj.getFullYear().toString();
    const heures = dateObj.getHours().toString().padStart(2, "0");
    const minutes = dateObj.getMinutes().toString().padStart(2, "0");

    // Date en fonction de la langue
    const res =
      props.i18n.language === "fr"
        ? `${jour} ${mois}${with_year ? " " + annee : ""}`
        : `${mois} ${jour}${with_year ? " " + annee : ""}`;

    return estAujourdhui ? `${heures}:${minutes}` : res;
  }
  // function formatDate(dateString) {
  //   const options = { day: "2-digit", month: "short", year: "2-digit", hour: "2-digit", minute: "2-digit" };
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString(props.i18n.language + "-" + props.i18n.language.toUpperCase(), options);
  //   // return "";
  // }
  async function fetchMessagesOrderInfos(convers) {
    console.log({ conver_conv: convers, messageInfos });
    if (
      client_data &&
      ((messageInfos[convers.$id] &&
        messageInfos[convers.$id].order_number &&
        messageInfos[convers.$id].order_number.length > 0) ||
        // && !messageInfos[convers.$id].order_number.contains("<UNKNOWN>")
        (messageInfos[convers.$id] &&
          messageInfos[convers.$id].order_email &&
          messageInfos[convers.$id].order_email.length > 0))
      // && messageInfos[convers.$id].order_email.contains("<UNKNOWN>")
    ) {
      console.log(
        "Fetching messages order",
        messageInfos[convers.$id].order_number,
        messageInfos[convers.$id].order_email
      );
      // try {
      // const response = await
      const list_to_search =
        messageInfos[convers.$id] &&
        messageInfos[convers.$id].order_number &&
        messageInfos[convers.$id].order_number.length > 0
          ? // && !messageInfos[convers.$id].order_number.contains("<UNKNOWN>")
            messageInfos[convers.$id].order_number
          : messageInfos[convers.$id].order_email;

      const updated_orders = [];

      for (let i = 0; i < list_to_search.length; i++) {
        const search = list_to_search[i];

        const search_field =
          messageInfos[convers.$id].order_number &&
          messageInfos[convers.$id].order_number.length > 0
            ? // && !messageInfos[convers.$id].order_number.contains("<UNKNOWN>")
              "name"
            : "email";

        try {
          const response = await searchShopifyOrder(
            `${search}`,
            ["line_items", "billing_address", "payment_details"],
            client_data.shopify_token,
            client_data.shopify_store_url,
            search_field
          );
          console.log("searchShopifyOrder is ", {
            response: response,
            shopify_api_key: client_data.shopify_api_key,
            shopify_store_url: client_data.shopify_store_url
          });
          if (response.orders.length > 0) {
            // const updated_orders =
            //   messageOrderInfos && messageOrderInfos.length > 0 ? [...messageOrderInfos, response.orders[0]] : response.orders;
            updated_orders.push(...response.orders);
            console.log({ updated_orders });
            // setMessageOrderInfos((prev) => {
            //   return { ...prev, [convers.$id]: updated_orders };
            // });
          } else {
            // setMessageOrderInfos((prev) => {
            //   return { ...prev, [convers.$id]: undefined };
            // });
          }
        } catch (error) {
          // setMessageOrderInfos((prev) => {
          //   return { ...prev, [convers.$id]: undefined };
          // });
          console.log("searchShopifyOrder error ", {
            error: error,
            shopify_api_key: client_data.shopify_api_key,
            shopify_store_url: client_data.shopify_store_url
          });
        }
      }
      setMessageOrderInfos((prev) => {
        return {
          ...prev,
          [convers.$id]: updated_orders.length > 0 ? updated_orders : undefined
        };
      });
      // } catch (error) {

      // }
    } else {
      setMessageOrderInfos((prev) => {
        return { ...prev, [convers.$id]: undefined };
      });
    }
  }

  function onSelectedConv(conv) {
    setSelectedConv(conv);
    selectedConvRef.current = conv;
  }

  async function goToMessageReadView(message) {
    console.log("selectedMessage is", message);
    // if (multiSelectedMessage.length === 0) {
    onSelectedConv(message);

    setShowReadEmailView(true);
    //   }

    setMultiSelectedMessage([message.$id]);

    if (multiSelectedMessage.length === 1) {
      // setMultiSelectedMessage((prev) => {
      //   let updatedMultiSelectedMessage = [...prev];
      //   if (multiSelectedMessage.includes(message.$id)) {
      //     updatedMultiSelectedMessage = updatedMultiSelectedMessage.filter((messageId) => messageId !== message.$id);
      //   } else {
      //     updatedMultiSelectedMessage.push(message.$id);
      //   }
      //   return updatedMultiSelectedMessage;
      // });
      //   if (multiSelectedMessage[0] === message.$id) {
      //    }
    } else if (multiSelectedMessage.length === 0) {
      //   setMultiSelectedMessage([message.$id]);
    }

    // navigate("/read-email", {
    //   replace: false,
    //   state: { the_message: message, all_messages: messages, folder: the_folder ? the_folder : "INBOX" },
    // });
  }

  const showColumn = () => {
    setColumnVisibility(!isColumnVisible);
  };

  const closeMessageView = () => {
    console.log("closeMessageView");
    setShowReadEmailView(false);
    onSelectedConv(undefined);
  };

  // async function updateMessageData(message, proccessed, process_start_time) {
  //   console.log(`Start saving message data for ${message.$id}`);

  //   const client = new Client();

  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   try {
  //     let message_to_reply_id = "";
  //     if (typeof message.headers["message-id"] === "string") {
  //       message_to_reply_id = message.headers["message-id"];
  //     } else if (Array.isArray(message.headers["message-id"])) {
  //       // eslint-disable-next-line prefer-destructuring
  //       message_to_reply_id = message.headers["message-id"][0];
  //     }
  //     console.log("message date is", new Date(message.attributes.date).getTime().toString());
  //     console.log("new date is", Date.now().toString());
  //     const response = await databases.updateDocument("default", "message", message_to_reply_id, {
  //       message_process_date: process_start_time,
  //       message_process_end_date: Date.now().toString(),
  //       process_state: proccessed,
  //       treated_by_ia: false
  //     });

  //     console.log(`Successfully updated message data for ${message.$id}`);
  //     return response.$id;
  //   } catch (error) {
  //     console.log(`Failed updating message data for ${message.$id}. Error is: ${error}`);
  //     // throw error;
  //     return null;
  //   }
  // }

  const copyMail = async function (message_id, the_folder, destination_folder) {
    console.log("copyMail");
    onMailActionLoading("copy");

    const apiUrl = "https://mailbox.semecloud.tech/copy-mail";
    // const apiUrl = "http://localhost:55000/copy-mail";
    // axios
    //   .post(
    //     apiUrl,
    //     {
    //       company_id: client_data.$id,
    //       destination_folder: destination_folder,
    //       folder: the_folder,
    //       messageId: message_id,
    //     },

    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    copyMailPromise(message_id, the_folder, destination_folder)
      .then(async (response) => {
        console.log("Msg copied", response);
        onMailActionLoading(undefined);
        setActionPerformed({
          title: props.t("Copie effectuée !"),
          body: props.t("Email(s) copié(s) vers le dossier spécifié."),
          key: "success"
        });
        triggerTimeout();
      })
      .catch((error) => {
        // Handle the error
        onMailActionLoading(undefined);
        console.log("Failed copying msg", error);
      });
  };

  const moveMail = async function (
    message_id,
    folder,
    destination_folder,
    isDeletion
  ) {
    console.log("moveMail");
    onMailActionLoading(isDeletion ? "delete" : "move");

    try {
      const response = await moveMailPromise(
        message_id,
        folder,
        destination_folder
      );
      console.log("Msg moved", response);
      onMailActionLoading(undefined);
      if (isDeletion) {
        setActionPerformed({
          title: props.t("Suppression effectuée !"),
          body: props.t("Email(s) supprimé(s) avec succès"),
          key: "success"
        });
      } else {
        setActionPerformed({
          title: props.t("E-mail(s) déplacé(s)"),
          body: props.t("Email(s) déplacé(s) avec succès"),
          key: "success"
        });
      }

      triggerTimeout();
    } catch (error) {
      onMailActionLoading(undefined);
      console.error("Failed moving msg", error);
      throw error; // Rejette l'erreur pour que Promise.all la capture
    }
  };

  const deleteMail = async function (message_id, destination_box) {
    console.log("deleteMail", message_id, destination_box);

    onMailActionLoading("delete");
    setMultiSelectedMessage([]);

    const apiUrl = "https://mailbox.semecloud.tech/delete-mail";
    // const apiUrl = "http://localhost:55000/copy-mail";
    // axios
    //   .post(
    //     apiUrl,
    //     {
    //       company_id: client_data.$id,
    //       folder: destination_box,
    //       messageId: message_id,
    //     },
    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    deleteMailPromise(message_id, destination_box)
      .then(async (response) => {
        console.log("Msg deleted", response);
        onMailActionLoading(undefined);
        setDecompte(10);
        setActionPerformed({
          title: props.t("Suppression effectuée !"),
          body: props.t("Email(s) supprimé(s) avec succès"),
          key: "success"
        });
        triggerTimeout();
      })
      .catch((error) => {
        // Handle the error
        onMailActionLoading(undefined);
        console.log("Failed deleting msg", error);
      });
  };

  const deleteMailFromCache = () => {
    const msg = localStorage.getItem(
      `cached_messages_${localStorage.getItem(
        "companyId"
      )}_${localStorage.getItem("selected_mail_box")}`
    );
    console.log({ cached_messages_msg: msg });

    if (msg) {
      const messages_mapJSON = JSON.parse(msg);
      if (
        messages_mapJSON[getBoxFromUrl()] &&
        messages_mapJSON[getBoxFromUrl()].length > 0
      ) {
        const cached_messages_ = messages_mapJSON[getBoxFromUrl()].filter(
          (message) => !messageToDelete.includes(message.$id)
        );

        localStorage.setItem(
          `cached_messages_${localStorage.getItem(
            "companyId"
          )}_${localStorage.getItem("selected_mail_box")}`,
          JSON.stringify(cached_messages_)
        );
      }
    }
  };

  function goToMBoxPage(box) {
    // console.log("box props data is:", box);
    navigate(`/mailbox?box=${box}`, {
      replace: false,
      state: { box: box }
    });
  }

  function getMailboxIcon(boxName) {
    if (boxName.toLowerCase().includes(".inbox")) {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="auto"
          viewBox="0 0 26 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M12.2006 1.60367C10.053 1.60367 7.89827 1.63193 5.75062 1.59661C3.75132 1.56129 1.90745 3.05192 1.62487 5.16425C1.60367 5.34793 1.60367 5.53161 1.60367 5.71529C1.60367 8.2727 1.59661 10.823 1.60367 13.3804C1.60367 15.4574 2.97421 17.0964 5.02296 17.4638C5.29848 17.5132 5.58107 17.5062 5.86365 17.5062C8.45638 17.5062 11.042 17.5062 13.6348 17.5062C13.7902 17.5062 13.9527 17.5132 14.1081 17.5344C14.5249 17.591 14.8216 17.923 14.8216 18.3186C14.8216 18.7284 14.4966 19.0604 14.0728 19.0957C13.988 19.1028 13.8961 19.1028 13.8114 19.1028C11.1409 19.1028 8.4705 19.1028 5.80007 19.1028C2.87531 19.1099 0.558107 17.16 0.0706464 14.2706C0.0211939 13.9668 0 13.656 0 13.3522C0 10.8301 0 8.30802 0 5.78594C0.00706464 2.88237 1.97104 0.565171 4.83928 0.0706464C5.14306 0.0211939 5.44684 0 5.75768 0C10.0459 0 14.3412 0 18.6295 0C21.6178 0 24.0057 2.11939 24.3518 5.08654C24.4649 6.01907 24.373 6.95161 24.3942 7.88414C24.4013 8.15966 24.4013 8.42812 24.3942 8.70364C24.3801 9.1699 24.0763 9.50901 23.6383 9.53727C23.2285 9.56552 22.8824 9.25468 22.8188 8.80254C22.7623 8.39279 22.7976 7.97598 22.7976 7.55917C22.7905 6.90922 22.8047 6.25221 22.7905 5.60226C22.7552 3.36277 20.982 1.61074 18.7496 1.59661C18.7354 1.59661 18.7142 1.59661 18.7001 1.59661C16.5383 1.60367 14.3695 1.60367 12.2006 1.60367Z"
            fill="currentColor"
          />
          <path
            d="M20.5863 10.1448C23.1437 10.2225 25.4114 12.4338 25.2772 15.2667C25.15 18.1349 22.7551 20.1413 20.0988 20C17.2941 19.8516 15.316 17.5415 15.4008 14.9488C15.5068 11.8474 18.1419 9.97527 20.5863 10.1448ZM20.3461 18.4105C22.2111 18.4105 23.6876 16.941 23.6947 15.0759C23.6947 13.2109 22.2111 11.7132 20.3461 11.7132C18.5022 11.7132 16.9974 13.2109 16.9974 15.0547C16.9904 16.9269 18.4739 18.4105 20.3461 18.4105Z"
            fill="currentColor"
          />
          <path
            d="M12.1865 9.64324C11.8262 9.62205 11.4729 9.55847 11.1338 9.42424C8.84488 8.50583 6.55594 7.5945 4.26699 6.68316C3.85724 6.52067 3.67356 6.24515 3.69476 5.85659C3.71595 5.52456 3.94202 5.24197 4.27406 5.15013C4.50719 5.08655 4.72619 5.15719 4.93813 5.24197C7.12817 6.11799 9.32528 6.98694 11.5082 7.87708C11.9816 8.06783 12.4125 8.06783 12.8859 7.87708C15.0618 6.994 17.2518 6.12505 19.4348 5.2561C19.5902 5.19252 19.7386 5.12187 19.9152 5.12187C20.2684 5.12187 20.5793 5.34794 20.6782 5.67291C20.7771 6.01202 20.657 6.36525 20.3673 6.55599C20.2825 6.61251 20.1836 6.6549 20.0847 6.69729C17.8452 7.5945 15.6057 8.49171 13.3663 9.38892C12.9918 9.53727 12.5962 9.62205 12.1865 9.64324Z"
            fill="currentColor"
          />
          <path
            d="M22.5504 14.3483C22.5363 14.6167 22.4303 14.8287 22.2254 14.9982C21.5825 15.521 20.9397 16.0438 20.2897 16.5525C19.8376 16.9128 19.4137 16.8562 19.0534 16.4041C18.8132 16.1074 18.5801 15.8107 18.354 15.514C18.0502 15.1042 18.0926 14.6591 18.4529 14.3624C18.8061 14.0728 19.2583 14.1434 19.5903 14.539C19.8658 14.864 19.8658 14.864 20.2049 14.5955C20.5582 14.313 20.9043 14.0304 21.2576 13.7549C21.526 13.55 21.8298 13.5217 22.1265 13.6701C22.402 13.8043 22.5221 14.0586 22.5504 14.3483Z"
            fill="currentColor"
          />
        </svg>
      );
    } else if (boxName.toLowerCase().includes("draft")) {
      return (
        // <i className="mdi mdi-file-outline align-middle email-menu-icon me-1"></i>
        <svg
          width="17"
          height="auto"
          viewBox="0 0 17 20"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
          className="email-menu-icon me-1"
        >
          <path
            d="M0 11.4214C0 9.28231 0 7.14324 0 5.00417C0 3.89275 0.714884 3.04941 1.80955 2.85952C2.07205 2.81484 2.34013 2.83718 2.60262 2.84277C2.75901 2.84277 2.80927 2.7925 2.80927 2.63612C2.7981 2.234 2.79252 1.82629 2.93214 1.43534C3.2449 0.580828 4.01564 0.011155 4.94834 0.00556993C7.10975 -0.00560013 9.26557 -0.00560013 11.427 0.00556993C12.0078 0.00556993 12.5161 0.223386 12.9293 0.636679C14.0799 1.7872 15.236 2.93771 16.3865 4.09381C16.7998 4.50711 17.0064 5.00976 17.0064 5.59619C17.0064 8.74056 17.0064 11.8793 17.0064 15.0237C17.0064 16.2468 16.0793 17.1516 14.8562 17.1572C14.6942 17.1572 14.5378 17.1628 14.3759 17.1572C14.2474 17.1516 14.2027 17.2075 14.2027 17.3303C14.1972 17.604 14.2251 17.8721 14.1804 18.1458C13.9849 19.2628 13.1304 19.9944 11.9911 19.9944C8.89137 20 5.79168 19.9944 2.69199 19.9944C2.2396 19.9944 1.78721 20.0112 1.35158 19.838C0.547333 19.5197 0.0111701 18.7601 0.00558503 17.9C0 15.7442 0 13.5828 0 11.4214ZM4.07149 8.57859C4.07149 10.7121 4.08266 12.84 4.0659 14.9735C4.06032 15.5655 4.50712 15.9285 4.9986 15.9285C8.27143 15.9285 11.5443 15.9285 14.8171 15.9229C15.3868 15.9229 15.761 15.5431 15.761 14.9735C15.761 11.9352 15.761 8.90253 15.7665 5.86427C15.7665 5.65204 15.6884 5.60736 15.4985 5.60736C14.8953 5.61853 14.2865 5.61294 13.6833 5.60736C12.3262 5.59619 11.4214 4.68024 11.4214 3.32866C11.4214 2.71431 11.4158 2.10554 11.427 1.49119C11.427 1.31805 11.3711 1.2622 11.198 1.2622C9.12036 1.26779 7.04831 1.26779 4.97068 1.2622C4.80871 1.2622 4.65233 1.29571 4.51271 1.37949C4.19436 1.56938 4.07707 1.85422 4.07707 2.22283C4.07707 4.34514 4.07149 6.46187 4.07149 8.57859ZM1.23988 11.4046C1.23988 13.499 1.25105 15.599 1.23429 17.6934C1.22871 18.2407 1.55264 18.7434 2.27311 18.7378C4.75845 18.7154 7.24379 18.7266 9.73471 18.7266C10.5222 18.7266 11.3097 18.7322 12.0972 18.721C12.5663 18.7154 12.9126 18.3747 12.9349 17.9056C12.9405 17.7604 12.9405 17.6152 12.9405 17.4644C12.9405 17.1516 12.9405 17.1516 12.6333 17.1516C10.1145 17.1516 7.59006 17.1516 5.07121 17.1516C4.92041 17.1516 4.76403 17.1572 4.61324 17.1293C3.52974 16.9282 2.81486 16.0737 2.81486 14.9623C2.81486 11.5051 2.81486 8.0536 2.81486 4.59647C2.81486 4.06589 2.81486 4.06589 2.28986 4.06589C1.59173 4.06589 1.24546 4.40658 1.24546 5.1047C1.23988 7.21026 1.23988 9.31023 1.23988 11.4046ZM12.6836 2.22841C12.6836 2.66405 12.678 3.07734 12.6836 3.49621C12.6948 3.99328 13.0522 4.33955 13.5549 4.35073C13.9123 4.35631 14.2642 4.35631 14.6216 4.35073C14.683 4.35073 14.7668 4.38424 14.7947 4.31721C14.8171 4.25578 14.7333 4.21668 14.6942 4.172C14.091 3.56324 13.4823 2.96005 12.8791 2.35128C12.8288 2.3066 12.7953 2.25075 12.6836 2.22841Z"
            fill="currentColor"
          />
          <path
            d="M9.90227 11.3879C8.86345 11.3879 7.83022 11.3879 6.7914 11.3879C6.66295 11.3879 6.54008 11.3823 6.42279 11.3376C6.17146 11.2371 6.0095 10.9802 6.03184 10.7065C6.05418 10.4384 6.26082 10.1983 6.52332 10.1536C6.65178 10.1312 6.78582 10.1201 6.91986 10.1201C8.92488 10.1201 10.9299 10.1201 12.9349 10.1201C13.0411 10.1201 13.1416 10.1256 13.2477 10.1424C13.5996 10.1983 13.8174 10.4608 13.8006 10.7847C13.7839 11.1086 13.527 11.3599 13.1807 11.3767C12.907 11.3879 12.6389 11.3823 12.3653 11.3823C11.5443 11.3879 10.7233 11.3879 9.90227 11.3879Z"
            fill="currentColor"
          />
          <path
            d="M9.22647 12.9964C10.0586 12.9964 10.8964 12.9964 11.7286 12.9964C12.1419 12.9964 12.4211 13.2477 12.4267 13.6107C12.4323 13.9681 12.1419 14.2362 11.7342 14.2362C10.0531 14.2362 8.36638 14.2362 6.68529 14.2362C6.33901 14.2362 6.0821 14.024 6.02625 13.7168C5.97599 13.4208 6.15471 13.1304 6.45071 13.0299C6.54566 12.9964 6.6406 13.0019 6.74114 13.0019C7.57331 12.9964 8.39989 12.9964 9.22647 12.9964Z"
            fill="currentColor"
          />
          <path
            d="M7.94196 8.54508C7.52867 8.54508 7.12097 8.55067 6.70767 8.54508C6.18826 8.53391 5.88109 8.07594 6.09332 7.64589C6.21619 7.40015 6.42842 7.28845 6.68533 7.28845C7.52867 7.28287 8.37201 7.27728 9.21535 7.28845C9.60072 7.29404 9.88556 7.57887 9.87439 7.92515C9.8688 8.277 9.58396 8.5395 9.19301 8.54508C8.77414 8.55067 8.35526 8.54508 7.94196 8.54508Z"
            fill="currentColor"
          />
        </svg>
      );
    } else if (boxName.toLowerCase().includes("trash")) {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M9.0502 19.9942C8.08096 19.9942 7.11172 20 6.14248 19.9942C5.64335 19.9884 5.14422 19.9536 4.6567 19.8375C3.54237 19.5705 2.89234 18.8799 2.70081 17.7481C2.59054 17.1097 2.57313 16.4655 2.5325 15.827C2.44544 14.556 2.36419 13.285 2.28293 12.0197C2.2365 11.3175 2.19007 10.621 2.14945 9.91875C2.09721 9.10041 2.05078 8.28787 2.00435 7.46953C1.97533 7.01683 2.24231 6.6686 2.64277 6.64539C3.07226 6.61637 3.39727 6.90076 3.42629 7.35926C3.50174 8.46199 3.57138 9.56471 3.64103 10.6732C3.72228 11.8862 3.80934 13.0992 3.88479 14.3064C3.93703 15.0725 3.97765 15.8387 4.02989 16.599C4.0473 16.8717 4.07051 17.1445 4.11114 17.4173C4.21561 18.1196 4.54062 18.4214 5.2545 18.5026C5.54469 18.5316 5.82907 18.549 6.11927 18.549C8.07516 18.549 10.031 18.549 11.9811 18.549C12.2771 18.549 12.5731 18.5316 12.8691 18.5026C13.6236 18.4214 13.9718 18.0499 14.0357 17.2432C14.1169 16.0882 14.1866 14.9333 14.262 13.7783C14.3607 12.3273 14.4594 10.8764 14.5522 9.42542C14.5987 8.72316 14.6393 8.0267 14.6915 7.32443C14.7205 6.89495 15.0514 6.61056 15.4808 6.63958C15.8697 6.6628 16.1425 6.99942 16.1193 7.4231C16.0264 8.9321 15.9335 10.4411 15.8407 11.9501C15.7536 13.2908 15.6724 14.6373 15.5795 15.9779C15.5389 16.5525 15.5215 17.1329 15.4228 17.7075C15.2081 18.9379 14.5406 19.6286 13.3102 19.8723C12.8691 19.9594 12.4222 19.9942 11.9753 19.9942C10.9945 20 10.0252 19.9942 9.0502 19.9942Z"
            fill="currentColor"
          />
          <path
            d="M9.06181 0C9.71764 0.0174115 10.3793 -0.0406268 11.0351 0.0754498C11.9811 0.243761 12.5267 0.766106 12.7182 1.71213C12.8169 2.18804 12.8981 2.66396 12.9736 3.14568C12.9968 3.28497 13.0548 3.34881 13.1941 3.36042C13.7223 3.39524 14.2446 3.43006 14.7728 3.47069C15.6608 3.54034 16.5429 3.61579 17.4309 3.69704C17.8662 3.73767 18.1448 4.08009 18.11 4.49797C18.0752 4.88683 17.7269 5.17121 17.2974 5.13639C16.63 5.08416 15.9568 5.01451 15.2893 4.95647C14.5929 4.89843 13.8906 4.84039 13.1941 4.79977C11.2789 4.6953 9.3636 4.62565 7.44254 4.67208C6.00319 4.70691 4.56384 4.76494 3.13029 4.91584C2.37579 4.9971 1.62129 5.06674 0.860993 5.13639C0.396687 5.18282 0.0310454 4.89843 0.0020263 4.49216C-0.0269929 4.03366 0.257395 3.73186 0.744917 3.68543C1.76059 3.59257 2.77626 3.4881 3.79193 3.40104C4.14596 3.37203 4.49999 3.35461 4.85403 3.3372C5.02814 3.3314 5.12681 3.27916 5.15583 3.07603C5.21967 2.61753 5.30092 2.15902 5.39378 1.70633C5.62013 0.644225 6.28757 0.104469 7.37289 0.0290192C7.93586 -0.00580383 8.49883 0.0174115 9.06181 0ZM10.7972 3.26756C10.9422 3.26756 11.1512 3.25595 11.3601 3.27336C11.5052 3.28497 11.54 3.22693 11.5168 3.09925C11.4472 2.71619 11.3833 2.33314 11.3021 1.95009C11.2382 1.64829 11.0989 1.54382 10.7972 1.49739C10.2864 1.42194 9.76987 1.46257 9.25914 1.46257C8.62652 1.46257 7.9881 1.41613 7.35548 1.49158C7.01886 1.53221 6.88537 1.64829 6.81572 1.98491C6.74027 2.34475 6.68804 2.71039 6.61259 3.07023C6.58357 3.20952 6.63 3.26175 6.76349 3.25014C7.01886 3.23854 7.26842 3.22693 7.52379 3.22113C8.59169 3.20952 9.6596 3.20952 10.7972 3.26756Z"
            fill="currentColor"
          />
          <path
            d="M9.05594 11.184C8.31886 11.184 7.58177 11.184 6.84469 11.184C6.36297 11.184 6.03215 10.8938 6.02054 10.4759C6.00893 10.0638 6.36297 9.73883 6.84469 9.73883C8.31886 9.73303 9.79883 9.73883 11.273 9.73883C11.6619 9.73883 11.9288 9.91295 12.0449 10.2264C12.1552 10.5165 12.0797 10.7661 11.865 10.9809C11.7083 11.1376 11.511 11.1898 11.2904 11.1898C10.5417 11.184 9.79883 11.184 9.05594 11.184Z"
            fill="currentColor"
          />
          <path
            d="M9.0327 14.881C8.53357 14.881 8.03444 14.881 7.53532 14.881C7.11164 14.881 6.78662 14.5676 6.78662 14.173C6.78662 13.7783 7.11164 13.4649 7.53532 13.4649C8.55099 13.4649 9.56085 13.4649 10.5765 13.4649C10.9944 13.4649 11.3252 13.7899 11.3194 14.1846C11.3136 14.5734 10.9944 14.881 10.5823 14.8868C10.0658 14.881 9.54924 14.881 9.0327 14.881Z"
            fill="currentColor"
          />
        </svg>
      );
    } else if (boxName.toLowerCase().includes("untreated")) {
      return (
        <img
          src={maaiaIconInfoPink}
          alt="Synibox Icon Info Pink"
          className="me-1"
          style={{
            width: "20px",
            height: "20px"
          }}
        />
      );
    } else if (boxName.toLowerCase().includes("treated")) {
      return (
        <img
          src={maaiaIconInfoPurple}
          alt="Synibox Icon Info Purple"
          className="me-1"
          style={{
            width: "20px",
            height: "20px"
          }}
        />
      );
    } else if (boxName.toLowerCase().includes("spam")) {
      return (
        <i className="mdi mdi-chart-bar  align-middle email-menu-icon me-1"></i>
      );
    } else if (boxName.toLowerCase().includes("sent")) {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="auto"
          viewBox="0 0 26 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M12.2006 1.60367C10.053 1.60367 7.89827 1.63193 5.75062 1.59661C3.75132 1.56129 1.90745 3.05192 1.62487 5.16425C1.60367 5.34793 1.60367 5.53161 1.60367 5.71529C1.60367 8.2727 1.59661 10.823 1.60367 13.3804C1.60367 15.4574 2.97421 17.0964 5.02296 17.4638C5.29848 17.5132 5.58107 17.5062 5.86365 17.5062C8.45638 17.5062 11.042 17.5062 13.6348 17.5062C13.7902 17.5062 13.9527 17.5132 14.1081 17.5344C14.5249 17.591 14.8216 17.923 14.8216 18.3186C14.8216 18.7284 14.4966 19.0604 14.0728 19.0957C13.988 19.1028 13.8961 19.1028 13.8114 19.1028C11.1409 19.1028 8.4705 19.1028 5.80007 19.1028C2.87531 19.1099 0.558107 17.16 0.0706464 14.2706C0.0211939 13.9668 0 13.656 0 13.3522C0 10.8301 0 8.30802 0 5.78594C0.00706464 2.88237 1.97104 0.565171 4.83928 0.0706464C5.14306 0.0211939 5.44684 0 5.75768 0C10.0459 0 14.3412 0 18.6295 0C21.6178 0 24.0057 2.11939 24.3518 5.08654C24.4649 6.01907 24.373 6.95161 24.3942 7.88414C24.4013 8.15966 24.4013 8.42812 24.3942 8.70364C24.3801 9.1699 24.0763 9.50901 23.6383 9.53727C23.2285 9.56552 22.8824 9.25468 22.8188 8.80254C22.7623 8.39279 22.7976 7.97598 22.7976 7.55917C22.7905 6.90922 22.8047 6.25221 22.7905 5.60226C22.7552 3.36277 20.982 1.61074 18.7496 1.59661C18.7354 1.59661 18.7142 1.59661 18.7001 1.59661C16.5383 1.60367 14.3695 1.60367 12.2006 1.60367Z"
            fill="currentColor"
          />
          <path
            d="M20.5863 10.1448C23.1437 10.2225 25.4114 12.4338 25.2772 15.2667C25.15 18.1349 22.7551 20.1413 20.0988 20C17.2941 19.8516 15.316 17.5415 15.4008 14.9488C15.5068 11.8474 18.1419 9.97527 20.5863 10.1448ZM20.3461 18.4105C22.2111 18.4105 23.6876 16.941 23.6947 15.0759C23.6947 13.2109 22.2111 11.7132 20.3461 11.7132C18.5022 11.7132 16.9974 13.2109 16.9974 15.0547C16.9904 16.9269 18.4739 18.4105 20.3461 18.4105Z"
            fill="currentColor"
          />
          <path
            d="M12.1865 9.64324C11.8262 9.62205 11.4729 9.55847 11.1338 9.42424C8.84488 8.50583 6.55594 7.5945 4.26699 6.68316C3.85724 6.52067 3.67356 6.24515 3.69476 5.85659C3.71595 5.52456 3.94202 5.24197 4.27406 5.15013C4.50719 5.08655 4.72619 5.15719 4.93813 5.24197C7.12817 6.11799 9.32528 6.98694 11.5082 7.87708C11.9816 8.06783 12.4125 8.06783 12.8859 7.87708C15.0618 6.994 17.2518 6.12505 19.4348 5.2561C19.5902 5.19252 19.7386 5.12187 19.9152 5.12187C20.2684 5.12187 20.5793 5.34794 20.6782 5.67291C20.7771 6.01202 20.657 6.36525 20.3673 6.55599C20.2825 6.61251 20.1836 6.6549 20.0847 6.69729C17.8452 7.5945 15.6057 8.49171 13.3663 9.38892C12.9918 9.53727 12.5962 9.62205 12.1865 9.64324Z"
            fill="currentColor"
          />
          <path
            d="M22.5504 14.3483C22.5363 14.6167 22.4303 14.8287 22.2254 14.9982C21.5825 15.521 20.9397 16.0438 20.2897 16.5525C19.8376 16.9128 19.4137 16.8562 19.0534 16.4041C18.8132 16.1074 18.5801 15.8107 18.354 15.514C18.0502 15.1042 18.0926 14.6591 18.4529 14.3624C18.8061 14.0728 19.2583 14.1434 19.5903 14.539C19.8658 14.864 19.8658 14.864 20.2049 14.5955C20.5582 14.313 20.9043 14.0304 21.2576 13.7549C21.526 13.55 21.8298 13.5217 22.1265 13.6701C22.402 13.8043 22.5221 14.0586 22.5504 14.3483Z"
            fill="currentColor"
          />
        </svg>
      );
    } else {
      return (
        // <i className="mdi mdi-at align-middle email-menu-icon me-1"></i>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="auto"
          viewBox="0 0 26 20"
          fill="currentColor"
          className="email-menu-icon me-1"
        >
          <path
            d="M12.2006 1.60367C10.053 1.60367 7.89827 1.63193 5.75062 1.59661C3.75132 1.56129 1.90745 3.05192 1.62487 5.16425C1.60367 5.34793 1.60367 5.53161 1.60367 5.71529C1.60367 8.2727 1.59661 10.823 1.60367 13.3804C1.60367 15.4574 2.97421 17.0964 5.02296 17.4638C5.29848 17.5132 5.58107 17.5062 5.86365 17.5062C8.45638 17.5062 11.042 17.5062 13.6348 17.5062C13.7902 17.5062 13.9527 17.5132 14.1081 17.5344C14.5249 17.591 14.8216 17.923 14.8216 18.3186C14.8216 18.7284 14.4966 19.0604 14.0728 19.0957C13.988 19.1028 13.8961 19.1028 13.8114 19.1028C11.1409 19.1028 8.4705 19.1028 5.80007 19.1028C2.87531 19.1099 0.558107 17.16 0.0706464 14.2706C0.0211939 13.9668 0 13.656 0 13.3522C0 10.8301 0 8.30802 0 5.78594C0.00706464 2.88237 1.97104 0.565171 4.83928 0.0706464C5.14306 0.0211939 5.44684 0 5.75768 0C10.0459 0 14.3412 0 18.6295 0C21.6178 0 24.0057 2.11939 24.3518 5.08654C24.4649 6.01907 24.373 6.95161 24.3942 7.88414C24.4013 8.15966 24.4013 8.42812 24.3942 8.70364C24.3801 9.1699 24.0763 9.50901 23.6383 9.53727C23.2285 9.56552 22.8824 9.25468 22.8188 8.80254C22.7623 8.39279 22.7976 7.97598 22.7976 7.55917C22.7905 6.90922 22.8047 6.25221 22.7905 5.60226C22.7552 3.36277 20.982 1.61074 18.7496 1.59661C18.7354 1.59661 18.7142 1.59661 18.7001 1.59661C16.5383 1.60367 14.3695 1.60367 12.2006 1.60367Z"
            fill="currentColor"
          />
          <path
            d="M20.5863 10.1448C23.1437 10.2225 25.4114 12.4338 25.2772 15.2667C25.15 18.1349 22.7551 20.1413 20.0988 20C17.2941 19.8516 15.316 17.5415 15.4008 14.9488C15.5068 11.8474 18.1419 9.97527 20.5863 10.1448ZM20.3461 18.4105C22.2111 18.4105 23.6876 16.941 23.6947 15.0759C23.6947 13.2109 22.2111 11.7132 20.3461 11.7132C18.5022 11.7132 16.9974 13.2109 16.9974 15.0547C16.9904 16.9269 18.4739 18.4105 20.3461 18.4105Z"
            fill="currentColor"
          />
          <path
            d="M12.1865 9.64324C11.8262 9.62205 11.4729 9.55847 11.1338 9.42424C8.84488 8.50583 6.55594 7.5945 4.26699 6.68316C3.85724 6.52067 3.67356 6.24515 3.69476 5.85659C3.71595 5.52456 3.94202 5.24197 4.27406 5.15013C4.50719 5.08655 4.72619 5.15719 4.93813 5.24197C7.12817 6.11799 9.32528 6.98694 11.5082 7.87708C11.9816 8.06783 12.4125 8.06783 12.8859 7.87708C15.0618 6.994 17.2518 6.12505 19.4348 5.2561C19.5902 5.19252 19.7386 5.12187 19.9152 5.12187C20.2684 5.12187 20.5793 5.34794 20.6782 5.67291C20.7771 6.01202 20.657 6.36525 20.3673 6.55599C20.2825 6.61251 20.1836 6.6549 20.0847 6.69729C17.8452 7.5945 15.6057 8.49171 13.3663 9.38892C12.9918 9.53727 12.5962 9.62205 12.1865 9.64324Z"
            fill="currentColor"
          />
          <path
            d="M22.5504 14.3483C22.5363 14.6167 22.4303 14.8287 22.2254 14.9982C21.5825 15.521 20.9397 16.0438 20.2897 16.5525C19.8376 16.9128 19.4137 16.8562 19.0534 16.4041C18.8132 16.1074 18.5801 15.8107 18.354 15.514C18.0502 15.1042 18.0926 14.6591 18.4529 14.3624C18.8061 14.0728 19.2583 14.1434 19.5903 14.539C19.8658 14.864 19.8658 14.864 20.2049 14.5955C20.5582 14.313 20.9043 14.0304 21.2576 13.7549C21.526 13.55 21.8298 13.5217 22.1265 13.6701C22.402 13.8043 22.5221 14.0586 22.5504 14.3483Z"
            fill="currentColor"
          />
        </svg>
      );
    }
  }

  function onBoxeCreateModalVisibility() {
    setCreateBoxModalVisibility(!create_box_modal_visibility);
  }

  function onMessageCreateModalVisibility() {
    setCreateMessageModalVisibility(!create_message_modal_visibility);
  }

  const getColors = function (key) {
    if (key === "REFUNDED" || key === "PAID" || key === "FULFILLED") {
      return { backgroundColor: "#d7fee1", color: "#046c28" };
    } else if (
      key === "IN_PROGRESS" ||
      key === "ON_HOLD" ||
      key === "OPEN" ||
      key === "PARTIALLY_FULFILLED" ||
      key === "PENDING_FULFILLMENT" ||
      key === "RESTOCKED" ||
      key === "SCHEDULED" ||
      key === "PARTIALLY_PAID" ||
      key === "PARTIALLY_REFUNDED" ||
      key === "PENDING" ||
      key === "UNFULFILLED"
    ) {
      return { backgroundColor: "rgba(255, 164, 18, 0.3)", color: "#ffa412" };
    } else if (key === "VOIDED") {
      return { backgroundColor: "rgba(241, 9, 68, 0.3)", color: "#f10944" };
    }
  };

  function checkAuthorizations(message) {
    const all_related_messages_tags = messagesTagsList[message.$id] || [];
    let isAuthorized = false;
    if (
      client_data &&
      client_data.$id === JSON.parse(localStorage.getItem("authUser")).userId
    ) {
      return true;
    }
    for (let index = 0; index < all_related_messages_tags.length; index++) {
      if (
        currentEmployee &&
        currentEmployee.contact_reasons &&
        currentEmployee.contact_reasons.includes(
          all_related_messages_tags[index]
        )
      ) {
        isAuthorized = true;
      }
    }
    return isAuthorized;
  }

  // async function getCompanyEmployeesData(company_id) {
  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.listDocuments("default", "employee", [Query.equal("company_id", company_id)]);

  //   return promise.then(
  //     async function (response) {
  //       const employeeData = response.documents;
  //       if (employeeData.length > 0) {
  //         if (localStorage.getItem("authUser")) {
  //           const userId = JSON.parse(localStorage.getItem("authUser")).userId;
  //           const employeesList = employeeData[0].employees;
  //           const employees = employeesList.map((element) => JSON.parse(element));
  //           const currentEmployee = employees.filter((element) => element.id === userId);
  //           if (currentEmployee && currentEmployee.length > 0) {
  //             setCurrentEmployee(currentEmployee[0]);
  //           }
  //           if (employeeData[0].owner) {
  //             setOwnerInfos(JSON.parse(employeeData[0].owner));
  //           }
  //         }
  //       }

  //       return employeeData;
  //     },
  //     function (error) {
  //       console.log("Error listing company employees ", error);
  //       console.log(error); // Failure
  //       return null;
  //     }
  //   );
  // }

  async function getEmployeeLink() {
    var user_data_string = localStorage.getItem("authUser");

    if (!user_data_string) return;

    var user = JSON.parse(user_data_string);

    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.listDocuments("default", "employee_link", [
      Query.equal("employee_id", user.userId)
    ]);

    return promise.then(
      async function (response) {
        console.log("Employee link is ", response.documents);
        return response.documents;
      },
      function (error) {
        console.log("Error creating Employee link", error); // Failure
        return null;
      }
    );
  }

  const parentDivRef = useRef(null);

  const svgs = {
    close_icon: (
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.37 19.6142C19.0771 19.8983 18.778 20.038 18.4725 20.0334C18.1504 20.0115 17.8473 19.8542 17.5632 19.5613L12.9511 14.8068L8.27403 19.3437C7.98118 19.6278 7.68204 19.7675 7.3766 19.7629C7.07117 19.7582 6.78476 19.6181 6.5174 19.3425C6.25003 19.0668 6.11866 18.7763 6.12331 18.4709C6.12795 18.1654 6.2767 17.8707 6.56955 17.5866L11.2466 13.0497L6.78484 8.45016C6.48405 8.14008 6.33598 7.83232 6.34062 7.52688C6.34527 7.22145 6.50263 6.91834 6.81271 6.61755C7.10556 6.33347 7.39609 6.2021 7.6843 6.22346C7.98973 6.2281 8.29284 6.38546 8.59364 6.69554L13.0554 11.295L17.7324 6.75812C18.0252 6.47404 18.3244 6.33432 18.6298 6.33896C18.9353 6.34361 19.2217 6.48374 19.489 6.75937C19.7564 7.03499 19.8878 7.32552 19.8831 7.63096C19.8785 7.93639 19.7297 8.23115 19.4369 8.51523L14.7598 13.0522L19.372 17.8067C19.6561 18.0996 19.8041 18.4073 19.8162 18.73C19.8288 19.0187 19.68 19.3135 19.37 19.6142Z"
          fill="#2F384C"
        />
      </svg>
    ),
    info_icon: (
      <span
        className="pulse_red"
        style={{
          display: "flex",
          height: "20px",
          width: "20px",
          borderRadius: "100%"
        }}
      >
        <InfoMono width={"20px"} height={"20px"} />
      </span>
    )
  };

  const handleFileSelect = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      console.log("Fichier sélectionné :", file);
    };
    fileInput.click();
  };

  const onInstructionRequestChange = (value) => {
    setInstructionRequestValue(value);
  };
  const onSendEmailRequestChange = (value) => {
    setSendEmailRequestValue(value);
  };

  const onInstructionInputChange = (event) => {
    setInstructionText(event.target.value);
  };
  const updateEmailSuggestedText = (value) => {
    setEmailSuggestedText(value);
  };

  let message = null;
  const process_start_time = Date.now().toString();

  const the_folder = getBoxFromUrl();

  // if (props.the_message) {
  //   message = props.the_message;
  //   const the_folder = getBoxFromUrl();
  //   the_folder = props.folder;
  // } else if (state) {
  //   message = state.the_message;
  //   const the_folder = getBoxFromUrl();
  //   the_folder = state.folder;
  // }

  // async function getAiTextImprovement(theTask) {
  //   console.log("getAiTextImprovement called");
  //   // console.log("text to process is", getText());

  //   const messageToReply =
  //     !message.related_messages || message.related_messages.length === 0 ? message : message.related_messages[message.related_messages.length - 1];

  //   // let message_to_reply_id = "";
  //   // if (typeof messageToReply.headers["message-id"] === "string") {
  //   //   message_to_reply_id = messageToReply.headers["message-id"];
  //   // } else if (Array.isArray(messageToReply.headers["message-id"])) {
  //   //   message_to_reply_id = messageToReply.headers["message-id"][0];
  //   // }

  //   // const msg_language = messageInfos[message_to_reply_id].client_language;

  //   onInstructionRequestChange(true);
  //   onSendEmailRequestChange(true);

  //   const response = await createAiTextImprovementFunctionExecution({
  //     task: theTask,
  //     data: getText(),
  //     interlocutor_text:
  //       theTask === "translation" ? (messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text) : undefined,
  //   });
  //   console.log({ createAiTextImprovementFunctionExecution: response });

  //   if (response && response.responseBody) {
  //     //  updateCompanyTokenUsage(500, 2000);
  //     const data = JSON.parse(response.responseBody).ia_response;

  //     console.log("text response is", data);
  //     const jsonObject = {
  //       text: data,
  //     };
  //     const jsonString = JSON.stringify(jsonObject);

  //     addSimpleTextToEditor(JSON.parse(jsonString).text);
  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);

  //     updateEmailSuggestedText(data);

  //     var reason;
  //     switch (theTask) {
  //       case "styling":
  //         reason = "Text style improvement";
  //         break;
  //       case "translation":
  //         reason = "Text translation";
  //         break;
  //       case "grammar":
  //         reason = "Text style improvement";
  //         break;
  //       case "reduce":
  //         reason = "Text contraction";
  //         break;
  //       default:
  //         break;
  //     }
  //     props.incrementAttrByValue(0.25, reason);

  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     const company_id = localStorage.getItem("companyId");
  //     let logData = {
  //       eventCreatedAt: Date.now(),
  //       author_id: user_id,
  //       company_id,
  //     };
  //     let logdata = {
  //       event: "ia_autogen_request",
  //       author_id: user_id,
  //       company_id,
  //       log_data: JSON.stringify(logData),
  //     };
  //     createLog(logdata, mixPanelTrack);
  //   } else {
  //     const error =
  //       response && response.responseBody && JSON.parse(response.responseBody).error && JSON.parse(response.responseBody).error.message
  //         ? JSON.parse(response.responseBody).error.message
  //         : "Erreur inattendue";
  //     console.log("Failed getting AIResponse", error);

  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);
  //   }
  // }

  // async function getAIResponse() {
  //   const messageToReply =
  //     !message.related_messages || message.related_messages.length === 0 ? message : message.related_messages[message.related_messages.length - 1];

  //   console.log("getAIResponse called");
  //   console.log("input instruction is", instruction_text);
  //   console.log("messageToReply body is", messageToReply.body.text);

  //   onInstructionRequestChange(true);
  //   onSendEmailRequestChange(true);

  //   const response = await createAIResponseExecution({
  //     emails: [
  //       {
  //         email_id: messageToReply.$id,
  //         // email_subject: messageToReply.subject,
  //         email_body: messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text,
  //         email_sender: `${messageToReply.from} <${messageToReply.user_email}>`,
  //       },
  //     ],
  //     company_id: localStorage.getItem("companyId"),
  //   });

  //   console.log({ createAIResponseExecution: response });

  //   if (response && response.responseBody && JSON.parse(response.responseBody).result) {
  //     const data = JSON.parse(response.responseBody);
  //     console.log({ data });
  //     updateCompanyTokenUsage(
  //       data.token_email_response.prompt_tokens + data.token_analyse.prompt_tokens,
  //       data.token_email_response.completion_tokens + data.token_analyse.completion_tokens
  //     );

  //     console.log("text response is", data.result[messageToReply.$id].mail_response);
  //     const jsonObject = {
  //       text: data.result[messageToReply.$id].mail_response,
  //     };
  //     const jsonString = JSON.stringify(jsonObject);

  //     addSimpleTextToEditor(JSON.parse(jsonString).text);
  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);

  //     updateEmailSuggestedText(data.result[messageToReply.$id].mail_response);

  //     props.incrementAttrByValue(1, "Email reply");

  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     const company_id = localStorage.getItem("companyId");
  //     let logData = {
  //       eventCreatedAt: Date.now(),
  //       author_id: user_id,
  //       company_id,
  //       mail_id: messageToReply.$id,
  //       receiver: `${messageToReply.from} <${messageToReply.user_email}>`,
  //       subject: messageToReply.subject,
  //     };
  //     let logdata = {
  //       event: "ia_autogen_request",
  //       author_id: user_id,
  //       company_id,
  //       log_data: JSON.stringify(logData),
  //     };
  //     createLog(logdata, mixPanelTrack);
  //   } else {
  //     const error =
  //       response && response.responseBody && JSON.parse(response.responseBody).error && JSON.parse(response.responseBody).error.message
  //         ? JSON.parse(response.responseBody).error.message
  //         : "Erreur inattendue";
  //     console.log("Failed getting AIResponse", error);

  //     onInstructionRequestChange(false);
  //     onSendEmailRequestChange(false);
  //   }

  //   /*
  //   axios
  //     .post(
  //       "https://ai.semecloud.tech/email-reply",

  //       {
  //         emails: [
  //           {
  //             email_id: messageToReply.$id,
  //             // email_subject: messageToReply.subject,
  //             email_body: messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text,
  //             email_sender: `${messageToReply.from} <${messageToReply.user_email}>`,
  //           },
  //         ],
  //         company_id: localStorage.getItem("companyId"),
  //       },
  //     )
  //     .then((response) => {
  //       // Traiter les données de la réponse

  //       const data = response.result;
  //       updateCompanyTokenUsage(
  //         response.token_email_response.prompt_tokens + response.token_analyse.prompt_tokens,
  //         response.token_email_response.completion_tokens + response.token_analyse.completion_tokens,
  //       );

  //       console.log("instruction response is", data);

  //       console.log("text response is", data[messageToReply.$id].mail_response);
  //       const jsonObject = {
  //         text: data[messageToReply.$id].mail_response,
  //       };
  //       const jsonString = JSON.stringify(jsonObject);

  //       addSimpleTextToEditor(JSON.parse(jsonString).text);
  //       onInstructionRequestChange(false);
  //       onSendEmailRequestChange(false);

  //       updateEmailSuggestedText(data);
  //       // Créer le log
  //       var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //       const company_id = localStorage.getItem("companyId");
  //       let logData = {
  //         eventCreatedAt: Date.now(),
  //         author_id: user_id,
  //         company_id,
  //         mail_id: messageToReply.$id,
  //         receiver: `${messageToReply.from} <${messageToReply.user_email}>`,
  //         subject: messageToReply.subject,
  //       };
  //       let logdata = {
  //         event: "ia_autogen_request",
  //         author_id: user_id,
  //         company_id,
  //         log_data: JSON.stringify(logData),
  //       };
  //       createLog(logdata, mixPanelTrack);
  //     })
  //     .catch((error) => {
  //       console.log("Failed getting AIResponse", error);
  //       // Gérer l'erreur
  //       if (error.response) {
  //         // La requête a été reçue, mais le serveur a répondu avec un code d'erreur
  //         console.log("// La requête a été reçue, mais le serveur a répondu avec un code d'erreur");
  //         console.log(error.response.data);
  //         console.log(error.response.status);
  //         console.log(error.response.headers);
  //       } else if (error.request) {
  //         console.log("// La requête a été envoyée, mais aucune réponse n'a été reçue");
  //         console.log(error.request);
  //       } else {
  //         console.log("// Une erreur est survenue lors de la création de la requête");
  //         console.log("Erreur", error.message);
  //       }
  //       console.log(error.config);
  //       onInstructionRequestChange(false);
  //       onSendEmailRequestChange(false);
  //     });
  //     */
  // }

  const [detailsAccordion, setDetailsAccordion] = useState({
    infos: true,
    alerts: true,
    tags: true
  });

  const onToggleDetailsAccordion = (val, attr) => {
    setDetailsAccordion({ ...detailsAccordion, [attr]: val });
  };

  const [selected_alert, seletectAlert] = useState(undefined);
  const [modalInfo, setModalInfo] = useState({
    id: "", // Initialisez ces valeurs à vide
    statusText: "",
    information: "",
    date: ""
  });
  const [allAlerts, setAllAlerts] = useState([]);

  const onSeletectAlert = (val) => {
    seletectAlert(val);
  };
  // const onLoadingChanged = (val) => {
  //   setUpdateAlertloading(val);
  // };

  async function updateCompanyInfos(data) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      {
        company_data: data.map((item) => JSON.stringify(item, null, 4))
      }
    );
    return promise.then(
      async function (response) {
        console.log(response); // Success
        return response;
      },
      function (error) {
        //   onDeleteLoadingChanged(false);
        setToastMessage({
          header: props.t("Echec"),
          body: error.message,
          key: "danger"
        });
        toggleToast();
        console.log(error); // Failure
        return null;
      }
    );
  }
  async function updateAlert(alert_id) {
    console.log("updateAlert", alert_id);
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);
    try {
      await databases.updateDocument("default", "alert", alert_id, {
        active: false
      });
      console.log("Alert deleted successfully");
    } catch (error) {
      console.log("Error updating alert:", error);
    }
  }

  const formik = useFormik({
    initialValues: {
      status_field: "",
      information: ""
    },
    validationSchema: Yup.object({
      status_field: Yup.string().required("Veuillez sélectionner un tag."),
      information: Yup.string()
        .required("add-res_error_msg_2")
        .max(500, "add-res_error_msg_3")
    }),
    onSubmit: (values) => {
      handleModalUpdate();
    }
  });

  const handleModalUpdate = async () => {
    const newItem = {
      id: Date.now(),
      statusText: modalInfo.statusText,
      information: modalInfo.information,
      date: Date.now()
    };

    const updatedList = [...topicList, newItem];
    console.log({ updatedList });
    setModalInfo({
      id: "", // Initialisez ces valeurs à vide
      statusText: "",
      information: "",
      date: ""
    });

    onLoadingChanged(true);

    const response = await updateCompanyInfos(updatedList);
    if (!response) {
      onLoadingChanged(false);
      return;
    }

    await updateAlert(selected_alert.$id);

    // const newList = allAlerts.filter((alert) => alert.$id !== selected_alert.$id);
    // setAllAlerts(newList);

    tog_list();
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: response.$id,
      topic_tag: newItem.statusText,
      topic_id: newItem.id
    };
    let logdata = {
      event: "topic_added",
      author_id: user_id,
      company_id: response.$id,
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);
    console.log("response message: ", response);
    onLoadingChanged(false);
    toggleToast();
    setToastMessage({
      header: props.t("Succès"),
      body: props.t("Modifications effectuées"),
      key: "success"
    });
  };

  function tog_list(alert) {
    setmodal_list(!modal_list);
    if (modal_list) {
      if (!formik.isValid) {
        formik.resetForm(formik.initialValues);
      }
    }
  }

  const handleNavigation = (box) => {
    console.log("handleNavigation", box);

    // Navigue vers une nouvelle URL sans rafraîchir la page
    navigate(`/mailbox?folder=${box}`);
  };
  function getBoxFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get("folder") || "INBOX";
  }

  async function updateConversation(data, convId) {
    console.log("***********conversationData***********", data);
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const response = await databases.updateDocument(
      "default",
      "conversations",
      convId,
      data
    );
    return response;
    // promise.then(
    //   async function (response) {
    //     setToastMessage({
    //       header: props.t("Succès"),
    //       body: props.t("Modifications effectuées"),
    //       key: "success"
    //     });
    //     toggleToast();
    //     console.log(response);
    //     // Créer le log
    //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    //     let logData = {
    //   eventCreatedAt: Date.now(),
    //   author_id: user_id,
    //   company_id: company_id,
    //   agent_id: agentActive?.id
    // };
    // let logdata = {
    //   event: old_val ? "agent_disabled" : "agent_enabled",
    //   author_id: user_id,
    //   company_id: company_id,
    //   log_data: JSON.stringify(logData)
    // };
    // createLog(logdata, mixPanelTrack);
    //   },
    //   function (error) {
    //     onLoadingChanged(false);
    //     setToastMessage({
    //       header: props.t("Echec"),
    //       body: error.message,
    //       key: "danger"
    //     });
    //     toggleToast();
    //     console.log(error); // Failure
    //   }
    // );
  }

  async function actionConv(conv, action, cancel) {
    setActionLoading(true);
    console.log("actionConv");
    let updatedTags = {};
    if (cancel) {
      updatedTags = { tags: null };
    } else {
      updatedTags = {
        tags: action
      };
    }
    const response = await updateConversation(updatedTags, conv.$id);

    console.log("actionConv", response);

    if (response) {
      await fetchConversations(
        origin,
        filter,
        tags,
        undefined,
        true,
        undefined
      );

      // if (tags) {
      //   fetchConversations(undefined, undefined, action);
      // } else {
      //   console.log("actionConvTags", tags);
      //   fetchConversations(undefined, undefined, undefined);
      // }

      setToastMessage({
        header: props.t("Succès"),
        body: props.t("Opération effectuées"),
        key: "success"
      });
      toggleToast();
      console.log(response);
      // Créer le log
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
      let logData = {
        eventCreatedAt: Date.now(),
        author_id: user_id,
        conversation_id: conv.$id,
        company_id: localStorage.getItem("companyId")
      };
      let logdata = {
        event: "Starred conversation",
        author_id: user_id,
        company_id: localStorage.getItem("companyId"),
        log_data: JSON.stringify(logData)
      };
      createLog(logdata, mixPanelTrack);
    }
    setActionLoading(false);
  }

  return (
    <React.Fragment>
      <div className="settings-content" style={{ paddingLeft: "0" }}>
        <div
          className="position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: "9999999" }}
        >
          <CustomToast
            isOpen={toast}
            toggle={toggleToast}
            message={toastMessage}
          />
        </div>
        {/* <Row>
          <Col
            xs="12"
            xxl={11}
            xl={11}
            className="mx-auto"
            style={{
              marginTop: "60px"
            }}>
            <div className="ps-0 pe-0 page-title-box d-sm-flex align-items-center justify-content-between">
              <div className="d-flex flex-column" style={{ width: "fit-content" }}>
                <h4 className="page-title font-primary" style={{ fontSize: "14px" }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                    <path
                      d="M20.26 7.8a4.82 4.82 0 0 0-3.93-2.44a3.91 3.91 0 0 0-2.54 1.09a10.58 10.58 0 0 0-1.52 1.71a11 11 0 0 0-1.63-1.72a4.39 4.39 0 0 0-2.88-1.08A5 5 0 0 0 3.7 8A11.49 11.49 0 0 0 2 14a7 7 0 0 0 .18 1.64A4.44 4.44 0 0 0 2.71 17a3.23 3.23 0 0 0 3 1.6c1.25 0 2.19-.56 3.3-2a26.4 26.4 0 0 0 2.21-3.6l.63-1.12c.06-.09.11-.18.16-.27l.15.25l1.79 3A14.77 14.77 0 0 0 16 17.63a3.38 3.38 0 0 0 2.55 1a3 3 0 0 0 2.54-1.23a2.2 2.2 0 0 0 .18-.28a4.1 4.1 0 0 0 .31-.63l.12-.35A6.53 6.53 0 0 0 22 15a9 9 0 0 0 0-1a11.15 11.15 0 0 0-1.74-6.2zm-10.12 3.56c-.64 1-1.57 2.51-2.37 3.61c-1 1.37-1.51 1.51-2.07 1.51a1.29 1.29 0 0 1-1.15-.66a3.3 3.3 0 0 1-.39-1.7A9.74 9.74 0 0 1 5.54 9a2.8 2.8 0 0 1 2.19-1.47A3 3 0 0 1 10 8.74a14.07 14.07 0 0 1 1 1.31zm8.42 5.12c-.48 0-.85-.19-1.38-.83A34.87 34.87 0 0 1 14.82 12l-.52-.86c-.36-.61-.71-1.16-1-1.65a2.46 2.46 0 0 1 .17-.27c.94-1.39 1.77-2.17 2.8-2.17a3.12 3.12 0 0 1 2.49 1.66a10.17 10.17 0 0 1 1.37 5.34c-.04 1.31-.34 2.43-1.57 2.43z"
                      fill="#563BFF"
                    />
                  </svg>{" "}
                  {props.t("Chat")}
                </h4>
                <p
                  className="mb-0 mt-2 simple-text font-primary"
                  style={{
                    color: "#666969",
                    fontStyle: "normal",
                    fontWeight: "400",
                    fontSize: "14px"
                  }}>
                  {props.t("Avec Synibox, gérez les messages que les personnes envoient à votre WhatsApp")}
                </p>
              </div>
            </div>
          </Col>
        </Row> */}

        {/* <Row>
          <Col
            xs="12"
            xxl={12}
            xl={12}
            className="mx-auto"
            style={{
              marginTop: "60px",
              marginBottom: "30px"
            }}
          >
            <Card
              className="settings-menu"
              style={{
                display: "flex",
                backgroundColor: "transparent",
                boxShadow: "none",
                marginBottom: "0px",
                justifyContent: "center"
              }}
            >
              <CardBody style={{ padding: "0px", alignSelf: "center" }}>
                <Nav
                  pills
                  className="flex-row"
                  style={{ height: "fit-content", width: "fit-content" }}
                >
                  <NavItem>
                    <NavLink
                      id="v-pills-left-home-tab"
                      style={{ cursor: "pointer" }}
                      className={classnames(
                        {
                          active: verticalActiveTabWithIcon === "1"
                        },
                        "font-primary"
                      )}
                      onClick={() => {
                        toggleVerticalIcon("1");
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        <span>{props.t("Messages")} </span>
                      </div>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="v-pills-left-home-tab"
                      style={{ cursor: "pointer" }}
                      disabled={
                        isFbConnected === true && fb_selected_pages.length > 0
                          ? false
                          : true
                      }
                      className={classnames(
                        {
                          active: verticalActiveTabWithIcon === "2"
                        },
                        "font-primary"
                      )}
                      onClick={() => {
                        toggleVerticalIcon("2");
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        <span>{props.t("Commentaires")} </span>
                      </div>
                    </NavLink>
                  </NavItem>
                   <NavItem>
                    <NavLink
                      id="v-pills-left-home-tab"
                      style={{ cursor: "pointer" }}
                      className={classnames(
                        {
                          active: verticalActiveTabWithIcon === "3"
                        },
                        "font-primary"
                      )}
                      onClick={() => {
                        toggleVerticalIcon("3");
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        <svg
                          width="15"
                          height="15"
                          style={{ marginTop: "3px" }}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.1471 4.73876C19.19 4.18931 19.0044 3.6465 18.6339 3.23846C18.4238 3.00706 18.1159 2.82927 17.5 2.47368C16.8841 2.11809 16.5762 1.9403 16.2707 1.87406C15.7321 1.75725 15.1692 1.86787 14.7148 2.1798C14.4572 2.3567 14.2394 2.6378 13.8039 3.2C13.3831 3.74315 12.7031 4.0014 12.0161 4.00005C12.0107 4.00004 12.0054 4.00004 12 4.00004C11.9946 4.00004 11.9891 4.00004 11.9837 4.00005C11.2967 4.00142 10.6168 3.74321 10.1961 3.20015C9.76058 2.63795 9.54281 2.35684 9.28515 2.17995C8.8308 1.86802 8.26788 1.7574 7.72928 1.87421C7.42384 1.94045 7.11589 2.11824 6.5 2.47383C5.8841 2.82942 5.57615 3.00721 5.36607 3.23861C4.99561 3.64664 4.80995 4.18946 4.85291 4.7389C4.87727 5.05049 5.01183 5.37963 5.28093 6.0379C5.54099 6.67405 5.42354 7.39207 5.07823 7.98627C5.07263 7.99592 5.06705 8.00557 5.06149 8.01524C4.71924 8.60989 4.15689 9.06955 3.47708 9.16226C2.77242 9.25835 2.4201 9.30639 2.13807 9.44108C1.64076 9.6786 1.2635 10.1108 1.09535 10.6356C1 10.9333 1 11.2889 1 12C1 12.7112 1 13.0668 1.09535 13.3644C1.2635 13.8893 1.64076 14.3215 2.13807 14.559C2.4201 14.6937 2.77242 14.7417 3.47708 14.8378C4.1569 14.9305 4.71924 15.3902 5.06149 15.9848C5.06705 15.9945 5.07264 16.0042 5.07824 16.0138C5.42354 16.608 5.541 17.326 5.28094 17.9621C5.01183 18.6204 4.87728 18.9496 4.85291 19.2612C4.80995 19.8106 4.99561 20.3534 5.36607 20.7615C5.57616 20.9929 5.8841 21.1707 6.5 21.5262C7.11589 21.8818 7.42384 22.0596 7.72928 22.1259C8.26788 22.2427 8.8308 22.132 9.28515 21.8201C9.54281 21.6432 9.76058 21.3621 10.1961 20.7999C10.6168 20.2569 11.2967 19.9986 11.9837 20C11.9891 20 11.9946 20 12 20C12.0054 20 12.0107 20 12.0161 20C12.7031 19.9987 13.3831 20.2569 13.8039 20.8001C14.2394 21.3623 14.4572 21.6434 14.7148 21.8203C15.1692 22.1322 15.7321 22.2428 16.2707 22.126C16.5762 22.0598 16.8841 21.882 17.5 21.5264C18.1159 21.1708 18.4238 20.993 18.6339 20.7616C19.0044 20.3536 19.19 19.8108 19.1471 19.2613C19.1227 18.9497 18.9882 18.6206 18.719 17.9623C18.459 17.3261 18.5764 16.608 18.9218 16.0138C18.9274 16.0041 18.9329 15.9945 18.9385 15.9849C19.2808 15.3902 19.8431 14.9305 20.5229 14.8378C21.2276 14.7417 21.5799 14.6937 21.8619 14.559C22.3592 14.3215 22.7365 13.8893 22.9046 13.3644C23 13.0668 23 12.7112 23 12C23 11.2889 23 10.9333 22.9046 10.6356C22.7365 10.1108 22.3592 9.6786 21.8619 9.44109C21.5799 9.30639 21.2276 9.25835 20.5229 9.16226C19.8431 9.06955 19.2808 8.60989 18.9385 8.01523C18.933 8.00557 18.9274 7.99593 18.9218 7.9863M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.6494 9.06015 11.3128 9.17071 11"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>{props.t("Settings Facebook")} </span>
                      </div>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      id="v-pills-left-home-tab"
                      style={{ cursor: "pointer" }}
                      className={classnames(
                        {
                          active: verticalActiveTabWithIcon === "4"
                        },
                        "font-primary"
                      )}
                      onClick={() => {
                        toggleVerticalIcon("4");
                      }}
                    >
                      <div className="d-flex flex-wrap gap-2">
                        <svg
                          width="15"
                          height="15"
                          style={{ marginTop: "3px" }}
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.1471 4.73876C19.19 4.18931 19.0044 3.6465 18.6339 3.23846C18.4238 3.00706 18.1159 2.82927 17.5 2.47368C16.8841 2.11809 16.5762 1.9403 16.2707 1.87406C15.7321 1.75725 15.1692 1.86787 14.7148 2.1798C14.4572 2.3567 14.2394 2.6378 13.8039 3.2C13.3831 3.74315 12.7031 4.0014 12.0161 4.00005C12.0107 4.00004 12.0054 4.00004 12 4.00004C11.9946 4.00004 11.9891 4.00004 11.9837 4.00005C11.2967 4.00142 10.6168 3.74321 10.1961 3.20015C9.76058 2.63795 9.54281 2.35684 9.28515 2.17995C8.8308 1.86802 8.26788 1.7574 7.72928 1.87421C7.42384 1.94045 7.11589 2.11824 6.5 2.47383C5.8841 2.82942 5.57615 3.00721 5.36607 3.23861C4.99561 3.64664 4.80995 4.18946 4.85291 4.7389C4.87727 5.05049 5.01183 5.37963 5.28093 6.0379C5.54099 6.67405 5.42354 7.39207 5.07823 7.98627C5.07263 7.99592 5.06705 8.00557 5.06149 8.01524C4.71924 8.60989 4.15689 9.06955 3.47708 9.16226C2.77242 9.25835 2.4201 9.30639 2.13807 9.44108C1.64076 9.6786 1.2635 10.1108 1.09535 10.6356C1 10.9333 1 11.2889 1 12C1 12.7112 1 13.0668 1.09535 13.3644C1.2635 13.8893 1.64076 14.3215 2.13807 14.559C2.4201 14.6937 2.77242 14.7417 3.47708 14.8378C4.1569 14.9305 4.71924 15.3902 5.06149 15.9848C5.06705 15.9945 5.07264 16.0042 5.07824 16.0138C5.42354 16.608 5.541 17.326 5.28094 17.9621C5.01183 18.6204 4.87728 18.9496 4.85291 19.2612C4.80995 19.8106 4.99561 20.3534 5.36607 20.7615C5.57616 20.9929 5.8841 21.1707 6.5 21.5262C7.11589 21.8818 7.42384 22.0596 7.72928 22.1259C8.26788 22.2427 8.8308 22.132 9.28515 21.8201C9.54281 21.6432 9.76058 21.3621 10.1961 20.7999C10.6168 20.2569 11.2967 19.9986 11.9837 20C11.9891 20 11.9946 20 12 20C12.0054 20 12.0107 20 12.0161 20C12.7031 19.9987 13.3831 20.2569 13.8039 20.8001C14.2394 21.3623 14.4572 21.6434 14.7148 21.8203C15.1692 22.1322 15.7321 22.2428 16.2707 22.126C16.5762 22.0598 16.8841 21.882 17.5 21.5264C18.1159 21.1708 18.4238 20.993 18.6339 20.7616C19.0044 20.3536 19.19 19.8108 19.1471 19.2613C19.1227 18.9497 18.9882 18.6206 18.719 17.9623C18.459 17.3261 18.5764 16.608 18.9218 16.0138C18.9274 16.0041 18.9329 15.9945 18.9385 15.9849C19.2808 15.3902 19.8431 14.9305 20.5229 14.8378C21.2276 14.7417 21.5799 14.6937 21.8619 14.559C22.3592 14.3215 22.7365 13.8893 22.9046 13.3644C23 13.0668 23 12.7112 23 12C23 11.2889 23 10.9333 22.9046 10.6356C22.7365 10.1108 22.3592 9.6786 21.8619 9.44109C21.5799 9.30639 21.2276 9.25835 20.5229 9.16226C19.8431 9.06955 19.2808 8.60989 18.9385 8.01523C18.933 8.00557 18.9274 7.99593 18.9218 7.9863M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.6494 9.06015 11.3128 9.17071 11"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <span>{props.t("Settings WhatsApp")}</span>
                      </div>
                    </NavLink>
                  </NavItem> 
                </Nav>
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <Row style={{ marginTop: "45px" }}>
          <Col xs="12" xxl={12} xl={12}>
            <div>
              <div className="">
                {/* <div className="page-content"> */}
                <Container
                  fluid={true}
                  style={{ padding: "0px", height: "100%" }}
                >
                  {/* <Breadcrumbs title="Email" breadcrumbItem="Inbox" /> */}
                  {/* <!-- Begin page --> */}
                  <div id="layout-wrapper" style={{ height: "100%" }}>
                    {/* @@include("partials/menu.html", {"title": "Inbox"}) */}
                    {/*   
      <!-- ============================================================== -->
      <!-- Start right Content here -->
      <!-- ============================================================== --> */}

                    <div className="" style={{ height: "100%" }}>
                      <div
                        className="cols-container d-flex"
                        style={{
                          backgroundColor: "#f1f1f1",
                          height: "100%"
                        }}
                      >
                        {/* SideBar */}
                        <Col
                          lg={"auto"}
                          className="inbox-menu col-xl-auto"
                          style={{
                            height: "100%",
                            overflowY: "auto",
                            minWidth: "200px"
                          }}
                        >
                          <div className="" style={{ height: "100%" }}>
                            {/* <div className="card">
          <div className="card-body"> */}
                            {/* <Row className="" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
        <Col xl={10}>
          <div className="column-title">BOITE DE RÉCEPTION</div>
        </Col>
        <Col xl={2} className="d-flex justify-content-end">
          <Link to="">
            <i
              className="bx bx-search "
              style={{
                marginLeft: "8px",
                color: "#222222",
                fontSize: "18px",
                marginTop: "3px",
              }}
            ></i>
          </Link>
        </Col>
      </Row> */}

                            {/* <button className="compose-mail-button d-flex align-items-center">
                      <span>
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.4 14.104C6.98933 14.104 6.672 13.992 6.448 13.768C6.224 13.5253 6.112 13.1987 6.112 12.788V8.196H1.604C1.212 8.196 0.904 8.09333 0.68 7.888C0.456 7.664 0.344 7.356 0.344 6.964C0.344 6.572 0.456 6.27333 0.68 6.068C0.904 5.844 1.212 5.732 1.604 5.732H6.112V1.28C6.112 0.869333 6.224 0.551999 6.448 0.327999C6.672 0.103999 6.99867 -0.00800037 7.428 -0.00800037C7.83867 -0.00800037 8.14667 0.103999 8.352 0.327999C8.576 0.551999 8.688 0.869333 8.688 1.28V5.732H13.196C13.6067 5.732 13.9147 5.844 14.12 6.068C14.344 6.27333 14.456 6.572 14.456 6.964C14.456 7.356 14.344 7.664 14.12 7.888C13.9147 8.09333 13.6067 8.196 13.196 8.196H8.688V12.788C8.688 13.1987 8.576 13.5253 8.352 13.768C8.14667 13.992 7.82933 14.104 7.4 14.104Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                      Nouv. Message
                    </button> */}

                            <div className=" p-0 overflow-hidden shadow-none">
                              <div
                                className="mail-list"
                                style={{ marginLeft: "15px" }}
                              >
                                <div className="mail-list-title mt-4 w-100 d-flex justify-content-between">
                                  {props.t("Messages")}
                                </div>

                                <div
                                  className={`${
                                    !origin && !filter && !tags
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin(undefined);
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations();
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      preserveAspectRatio="none"
                                    >
                                      <path
                                        fill="currentColor"
                                        d="M6.942 19q-.728 0-1.22-.462q-.491-.463-.491-1.153V8.846L3.106 6.323Q3 6.193 2.96 6.068q-.04-.124-.04-.26q0-.304.217-.556T3.727 5h15.562q.728 0 1.22.463q.491.462.491 1.153v10.769q0 .69-.491 1.153q-.492.462-1.22.462zm4.608-4.808h4.816q.213 0 .356-.143q.144-.143.144-.357t-.144-.356t-.357-.144h-5.96q-.366 0-.494.324q-.128.325.135.569l2.196 2.08q.14.14.344.14q.205 0 .345-.14q.16-.16.16-.373t-.16-.353zm2.9-4.384H9.616q-.214 0-.357.143t-.143.357t.143.357t.357.143h5.959q.367 0 .495-.324t-.135-.568l-2.177-2.081q-.14-.14-.344-.14t-.345.14q-.16.16-.16.373t.16.354z"
                                      />
                                    </svg>

                                    <div
                                      className="d-flex ms-1"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            !origin && !filter && !tags
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t("All")}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    origin === "email" ? "meta-menu-active" : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin("email");
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("email");
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <EmailFilled />

                                    <div
                                      className="d-flex ms-1"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            origin === "email"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          E-mail
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    origin === "shopify"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin("shopify");
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("shopify");
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <IcTwotoneWechat />

                                    <div
                                      className="d-flex ms-1"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            origin === "shopify"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          Chat Shopify
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    origin === "facebook_post"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin("facebook_post");
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("facebook_post");
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <HugeiconsComment width="22" height="22" />

                                    <div
                                      className="d-flex ms-1"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            origin === "facebook_post"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t("Commentaires")}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    origin === "whatsapp"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin("whatsapp");
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("whatsapp");
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="me-1"
                                      width="22"
                                      height="22"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="currentColor"
                                        d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                                      />
                                    </svg>

                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            origin === "whatsapp"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          WhatsApp
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    origin === "messenger"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin("messenger");
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("messenger");
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="22"
                                      height="22"
                                      viewBox="0 0 24 24"
                                      className="me-1"
                                    >
                                      <path
                                        fill="currentColor"
                                        d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7S17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63"
                                      />
                                    </svg>
                                    {/* <i className={`mdi mdi-messenger me-1`} style={{ fontSize: "18px" }} /> */}

                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            origin === "messenger"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          Messenger
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    origin === "instagram"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    //  cursor: loading ? "not-allowed" : "pointer",
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetOrigin("instagram");
                                    onSetFilter(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("instagram");
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="me-1"
                                      width="22"
                                      height="22"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        fill="currentColor"
                                        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
                                      />
                                    </svg>
                                    {/* <i className={`mdi mdi-instagram me-1`} style={{ fontSize: "17px" }} /> */}

                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            origin === "instagram"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          Instagram
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    filter === "treated"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetFilter("treated");
                                    onSetOrigin(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("1");
                                    fetchConversations("email", "treated");
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("Treated")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            filter === "treated"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(getBoxLocalName("Treated"))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    filter === "untreated"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetFilter("untreated");
                                    onSetOrigin(undefined);
                                    onSetTags(undefined);
                                    toggleConvIcon("1");
                                    fetchConversations("email", "untreated");
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("Untreated")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            filter === "untreated"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(
                                            getBoxLocalName("Untreated")
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* 
                                <div
                                  className={`${
                                    selectRS === "sent"
                                      ? "meta-menu-active"
                                      : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSelectRS("sent");
                                    onSelectFilter(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations("sent", true, undefined);
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("Sent")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            selectRS === "sent"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(getBoxLocalName("Sent"))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div> */}

                                <div
                                  className={`${
                                    tags === "starred" ? "meta-menu-active" : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetTags("starred");
                                    onSetFilter(undefined);
                                    onSetOrigin(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations(
                                      undefined,
                                      undefined,
                                      "starred"
                                    );
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("starred")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            tags === "starred"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(getBoxLocalName("Starred"))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    tags === "archive" ? "meta-menu-active" : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetTags("archive");
                                    onSetFilter(undefined);
                                    onSetOrigin(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations(
                                      undefined,
                                      undefined,
                                      "archive"
                                    );
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("archive")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            tags === "archive"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(getBoxLocalName("Archive"))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    tags === "draft" ? "meta-menu-active" : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetTags("draft");
                                    onSetFilter(undefined);
                                    onSetOrigin(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations(
                                      undefined,
                                      undefined,
                                      "draft"
                                    );
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("draft")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            tags === "draft"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(getBoxLocalName("Drafts"))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  className={`${
                                    tags === "junk" ? "meta-menu-active" : ""
                                  }`}
                                  style={{
                                    cursor: "pointer",
                                    marginTop: "10px"
                                  }}
                                  onClick={() => {
                                    onSetTags("junk");
                                    onSetFilter(undefined);
                                    onSetOrigin(undefined);
                                    toggleConvIcon("3");
                                    fetchConversations(
                                      undefined,
                                      undefined,
                                      "junk"
                                    );
                                    if (isSearch) {
                                      setRecherche("");
                                      setIsSearch(false);
                                    }
                                  }}
                                >
                                  <div className="d-flex">
                                    {getMailboxIcon("junk")}
                                    <div
                                      className="d-flex"
                                      style={{ width: "100%" }}
                                    >
                                      <div className="mt-0">
                                        <p
                                          className={`email-menu-title font-primary ${
                                            tags === "junk"
                                              ? "meta-menu-active"
                                              : ""
                                          }`}
                                        >
                                          {props.t(getBoxLocalName("Junk"))}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div>
                              <Modal
                                backdrop={"static"}
                                keyboard={false}
                                isOpen={create_message_modal_visibility}
                                toggle={() => {
                                  onMessageCreateModalVisibility();
                                }}
                                centered
                                id="firstmodal"
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={onMessageCreateModalVisibility}
                                >
                                  <h5
                                    className="modal-title font-primary"
                                    id="myModalLabel"
                                  >
                                    {props.t("Nouveau message")}
                                  </h5>
                                </ModalHeader>
                                <ModalBody className="modal-body">
                                  <EmailRedact
                                    create_message_modal_visibility={
                                      create_message_modal_visibility
                                    }
                                    setCreateMessageModalVisibility={
                                      setCreateMessageModalVisibility
                                    }
                                    setToastMessage={setToastMessage}
                                    toggleToast={toggleToast}
                                    toEmail={to_email}
                                  />
                                </ModalBody>
                              </Modal>
                            </div>
                          </div>
                        </Col>

                        <div
                          className="d-flex flex-grow-1 h-100"
                          style={{ flexDirection: "column" }}
                        >
                          <div className="d-flex flex-row flex-grow-1 h-100">
                            <div
                              // xl={3}
                              ref={parentDivRef}
                              className="inbox-mails-conatiner"
                              style={{
                                height: "100%",
                                overflowY: "auto",
                                width: "390px"
                              }}
                            >
                              <div>
                                <FormGroup className="mb-1 ms-1 mt-2">
                                  <InputGroup>
                                    <InputGroupText
                                      style={{
                                        border: "none"
                                      }}
                                    >
                                      <svg
                                        width="18"
                                        height="18"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M21 21L18.4953 18.4953C18.1033 18.1033 17.9073 17.9073 17.7092 17.8311C17.5121 17.7553 17.3684 17.7425 17.161 17.7825C16.9527 17.8226 16.6814 18.0117 16.1387 18.3897C14.6817 19.4048 12.9104 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 12.2414 19.7487 13.4241 19.2941 14.5"
                                          stroke="#2F384C"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                        />
                                      </svg>
                                    </InputGroupText>
                                    <Input
                                      className="ps-2 py-1 pe-0"
                                      placeholder="Search..."
                                      style={{
                                        color: "black",
                                        border: "none",
                                        backgroundColor: "#eff2f7",
                                        fontSize: "12px"
                                      }}
                                      // disabled={loading}
                                      value={recherche}
                                      onChange={(e) => {
                                        setRecherche(e.target.value);
                                        setIsSearch(false);
                                      }}
                                      // onKeyDown={(event) => {
                                      //   const input = recherche
                                      //     .replace(/<div>|<br.*?>/gi, "\n")
                                      //     .replace(/<\/div>/g, "")
                                      //     .trim();
                                      //   console.log({
                                      //     input: recherche.length
                                      //   });
                                      // if (recherche.length === 1) {
                                      //   if (isSearch) {
                                      //     closeMessageView();
                                      //     dispatch(fetchMailsRedux(localStorage.getItem("companyId"), getBoxFromUrl(), 1, pageSize, []));
                                      //   }
                                      // } else if (!loading && event.key === "Enter" && input.length > 0) {
                                      //   dispatch(searchMailsRedux(recherche, localStorage.getItem("companyId"), getBoxFromUrl()));
                                      // }
                                      // }}
                                    />
                                    <InputGroupText
                                      style={{
                                        border: "none",
                                        borderRadius: "10px",
                                        marginLeft: "5px",
                                        cursor: "pointer"
                                      }}
                                      onClick={async () => {
                                        if (isSearch === false) {
                                          setIsSearch(!isSearch);
                                          const input = recherche
                                            .replace(/<div>|<br.*?>/gi, "\n")
                                            .replace(/<\/div>/g, "")
                                            .trim();
                                          console.log({
                                            input: recherche.length
                                          });
                                          if (recherche.length >= 1) {
                                            setIsSearchLoading(true);
                                            setRecherche(input);
                                            onSetOrigin(undefined);
                                            onSetFilter(undefined);

                                            await fetchConversations(
                                              undefined,
                                              undefined,
                                              undefined,
                                              input
                                            );
                                            //   if (isSearch) {
                                            //     closeMessageView();
                                            //     dispatch(fetchMailsRedux(localStorage.getItem("companyId"), getBoxFromUrl(), 1, pageSize, []));
                                            //   }
                                            // } else if (!loading && event.key === "Enter" && input.length > 0) {
                                            //   dispatch(searchMailsRedux(recherche, localStorage.getItem("companyId"), getBoxFromUrl()));
                                            setIsSearchLoading(false);
                                          }
                                        } else {
                                          setRecherche("");
                                          setIsSearch(false);
                                          onSetFilter(undefined);
                                          fetchConversations(
                                            origin,
                                            filter,
                                            tags,
                                            recherche
                                          );
                                        }
                                      }}
                                    >
                                      {isSearchLoading === true ? (
                                        <Spinner
                                          className="me-1"
                                          style={{
                                            height: "15px",
                                            width: "15px"
                                          }}
                                          animation="border"
                                        />
                                      ) : isSearch === true ? (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="currentColor"
                                            d="m12 12.708l-5.246 5.246q-.14.14-.344.15t-.364-.15t-.16-.354t.16-.354L11.292 12L6.046 6.754q-.14-.14-.15-.344t.15-.364t.354-.16t.354.16L12 11.292l5.246-5.246q.14-.14.345-.15q.203-.01.363.15t.16.354t-.16.354L12.708 12l5.246 5.246q.14.14.15.345q.01.203-.15.363t-.354.16t-.354-.16z"
                                          />
                                        </svg>
                                      ) : (
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                        >
                                          <path
                                            fill="none"
                                            stroke="#2F384C"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="1.5"
                                            d="M20 18V6m-4 6H4m8-4s4 2.946 4 4s-4 4-4 4"
                                            color="currentColor"
                                          />
                                        </svg>
                                      )}
                                    </InputGroupText>
                                  </InputGroup>
                                </FormGroup>
                                <div className="settings-menu">
                                  <Nav
                                    pills
                                    className="flex-row"
                                    style={{
                                      height: "fit-content",
                                      width: "fill-parent"
                                    }}
                                  >
                                    {!filter ? (
                                      <>
                                        <NavItem style={{ width: "100px" }}>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "3"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("3");
                                              tags
                                                ? fetchConversations(
                                                    undefined,
                                                    undefined,
                                                    tags
                                                  )
                                                : fetchConversations(origin);
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap gap-2"
                                              style={{
                                                color:
                                                  convTabWithIcon === "3"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <span>{props.t("All")}</span>

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "3"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "3"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalAll}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>

                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "1"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("1");
                                              fetchConversations(
                                                origin,
                                                "treated",
                                                tags
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap gap-2"
                                              style={{
                                                color:
                                                  convTabWithIcon === "1"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <span>
                                                {props.t(
                                                  getBoxLocalName("Treated")
                                                )}
                                              </span>

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "1"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "1"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalTreated}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "2"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("2");
                                              fetchConversations(
                                                tags ? undefined : origin,
                                                "untreated",
                                                origin ? undefined : tags
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap gap-2"
                                              style={{
                                                color:
                                                  convTabWithIcon === "2"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <span>
                                                {props.t(
                                                  getBoxLocalName("Untreated")
                                                )}
                                              </span>

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "2"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "2"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalUntreated}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>
                                      </>
                                    ) : (
                                      <>
                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "1"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("1");

                                              fetchConversations(
                                                "email",
                                                filter
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap"
                                              style={{
                                                color:
                                                  convTabWithIcon === "1"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <EmailFilled />

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "1"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "1"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalEmail}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "2"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("2");

                                              fetchConversations(
                                                "shopify",
                                                filter
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap"
                                              style={{
                                                color:
                                                  convTabWithIcon === "2"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <IcTwotoneWechat />
                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "2"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "2"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalShopify}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "3"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("3");

                                              fetchConversations(
                                                "whatsapp",
                                                filter
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap"
                                              style={{
                                                color:
                                                  convTabWithIcon === "3"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="me-1"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                                                />
                                              </svg>

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "3"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "3"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalWhatsapp}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>
                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "4"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("4");

                                              fetchConversations(
                                                "messenger",
                                                filter
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap"
                                              style={{
                                                color:
                                                  convTabWithIcon === "4"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 24 24"
                                                className="me-1"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7S17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63"
                                                />
                                              </svg>

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "4"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "4"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalMessenger}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>

                                        <NavItem>
                                          <NavLink
                                            id="v-pills-left-home-tab"
                                            style={{ cursor: "pointer" }}
                                            className={classnames(
                                              {
                                                active: convTabWithIcon === "5"
                                              },
                                              "font-primary"
                                            )}
                                            onClick={() => {
                                              toggleConvIcon("5");

                                              fetchConversations(
                                                "instagram",
                                                filter
                                              );
                                            }}
                                          >
                                            <div
                                              className="d-flex flex-wrap"
                                              style={{
                                                color:
                                                  convTabWithIcon === "5"
                                                    ? "#2f5cff"
                                                    : null
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="me-1"
                                                width="22"
                                                height="22"
                                                viewBox="0 0 24 24"
                                              >
                                                <path
                                                  fill="currentColor"
                                                  d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
                                                />
                                              </svg>

                                              <span
                                                style={{
                                                  height: "18px",
                                                  width: "18px",
                                                  textAlign: "center",
                                                  borderRadius: "5px",
                                                  color:
                                                    convTabWithIcon === "5"
                                                      ? "white"
                                                      : null,
                                                  backgroundColor:
                                                    convTabWithIcon === "5"
                                                      ? "#2f5cff"
                                                      : "#eff2f7",
                                                  fontSize: "12px"
                                                }}
                                              >
                                                {totalInstagram}
                                              </span>
                                            </div>
                                          </NavLink>
                                        </NavItem>
                                      </>
                                    )}
                                  </Nav>
                                </div>

                                <ul
                                  style={{
                                    height: "80vh",
                                    padding: "0 12px"
                                  }}
                                >
                                  {((state && state.id && !origin) ||
                                    (isSearch && !loading)) && (
                                    <Row
                                      className="py-2 d-flex justify-content-center simple-text"
                                      style={{
                                        backgroundColor: "#ffde7e",
                                        color: "black",
                                        cursor: !loading
                                          ? "pointer"
                                          : "default",
                                        userSelect: "none"
                                      }}
                                      onClick={() => {
                                        if (!loading) {
                                          if (state && state.id && !origin) {
                                            navigate("/messages", {
                                              replace: true,
                                              state: undefined
                                            });
                                          }
                                          setRecherche("");
                                          closeMessageView();
                                          setIsSearch(false);
                                          onSetFilter(undefined);
                                          fetchConversations();
                                        }
                                      }}
                                    >
                                      {actionLoading ? (
                                        <div className="d-flex justify-content-center align-items-center">
                                          {props.t("Filtrage")}
                                          <span
                                            className="spinner-border ms-1 spinner-border-sm font-primary"
                                            role="status"
                                            aria-hidden="true"
                                            style={{
                                              height: "14px",
                                              width: "14px"
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        <div className="d-flex justify-content-center align-items-center simple-text">
                                          <span>
                                            {props.t("Retirer le filtrage")}
                                          </span>
                                          <CrossOutlined
                                            height={20}
                                            style={{ marginTop: "2px" }}
                                          />
                                        </div>
                                      )}
                                    </Row>
                                  )}

                                  {conversationsList &&
                                  conversationsList.length > 0 ? (
                                    fb_selected_pages &&
                                    fb_selected_pages.length &&
                                    origin === "facebook_post" ? (
                                      conversationsList.map(
                                        (message, index) => (
                                          <MetaPostComponent
                                            key={index}
                                            index={index}
                                            messages={conversationsList}
                                            the_folder={getBoxFromUrl()}
                                            message={message}
                                            messageToDelete={messageToDelete}
                                            setMessageToDelete={
                                              setMessageToDelete
                                            }
                                            selectedMessage={selectedConv}
                                            multiSelectedMessage={
                                              multiSelectedMessage
                                            }
                                            setMultiSelectedMessage={
                                              setMultiSelectedMessage
                                            }
                                            goToMessageReadView={
                                              goToMessageReadView
                                            }
                                            setSelectedMessageNext={
                                              setSelectedConvNext
                                            }
                                            setSelectedMessageNextIndex={
                                              setSelectedConvNextIndex
                                            }
                                            actionConv={actionConv}
                                            actionLoading={actionLoading}
                                            setType={setType}
                                            togModalDossierVisibility={
                                              togModalDossierVisibility
                                            }
                                            setShowReadEmailView={
                                              setShowReadEmailView
                                            }
                                            setStartCountdown={
                                              setStartCountdown
                                            }
                                            messagesTagsList={messagesTagsList}
                                            setMessagesTagsList={
                                              setMessagesTagsList
                                            }
                                            messagesStateList={
                                              messagesStateList
                                            }
                                            setMessagesStateList={
                                              setMessagesStateList
                                            }
                                            stringToColour={stringToColour}
                                            formaterDate={formaterDate}
                                            messageInfos={messageInfos}
                                            setMessageInfos={setMessageInfos}
                                            alertList={alertList}
                                            setAlertList={setAlertList}
                                            fetchMessageOrders={
                                              fetchMessageOrders
                                            }
                                            tag={tags}
                                          />
                                        )
                                      )
                                    ) : (
                                      conversationsList.map(
                                        (message, index) => (
                                          <MetaConversationComponent
                                            key={index}
                                            index={index}
                                            messages={conversationsList}
                                            the_folder={getBoxFromUrl()}
                                            message={message}
                                            messageToDelete={messageToDelete}
                                            setMessageToDelete={
                                              setMessageToDelete
                                            }
                                            selectedMessage={selectedConv}
                                            multiSelectedMessage={
                                              multiSelectedMessage
                                            }
                                            setMultiSelectedMessage={
                                              setMultiSelectedMessage
                                            }
                                            goToMessageReadView={
                                              goToMessageReadView
                                            }
                                            setSelectedMessageNext={
                                              setSelectedConvNext
                                            }
                                            setSelectedMessageNextIndex={
                                              setSelectedConvNextIndex
                                            }
                                            actionConv={actionConv}
                                            setType={setType}
                                            togModalDossierVisibility={
                                              togModalDossierVisibility
                                            }
                                            setShowReadEmailView={
                                              setShowReadEmailView
                                            }
                                            setStartCountdown={
                                              setStartCountdown
                                            }
                                            messagesTagsList={messagesTagsList}
                                            setMessagesTagsList={
                                              setMessagesTagsList
                                            }
                                            messagesStateList={
                                              messagesStateList
                                            }
                                            setMessagesStateList={
                                              setMessagesStateList
                                            }
                                            stringToColour={stringToColour}
                                            formaterDate={formaterDate}
                                            messageInfos={messageInfos}
                                            setMessageInfos={setMessageInfos}
                                            alertList={alertList}
                                            setAlertList={setAlertList}
                                            fetchMessageOrders={
                                              fetchMessageOrders
                                            }
                                            tag={tags}
                                          />
                                        )
                                      )
                                    )
                                  ) : convsLoading === true ||
                                    (origin === "facebook_post" && loading) ? (
                                    <div
                                      className="simple-text font-primary"
                                      style={{
                                        textAlign: "center",
                                        padding: "5em",
                                        fontSize: "14px"
                                      }}
                                    >
                                      {props.t("Chargement")}...
                                    </div>
                                  ) : conversationsList &&
                                    conversationsList.length === 0 ? (
                                    <div
                                      className="simple-text font-primary"
                                      style={{
                                        textAlign: "center",
                                        padding: "5em",
                                        fontSize: "12px"
                                      }}
                                    >
                                      <p>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth="1.5"
                                          stroke="currentColor"
                                          width="30"
                                          height="30"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M7.5 11.25h.008v.008H7.5v-.008zm4.5 0h.008v.008H12v-.008zm4.5 0h.008v.008H16.5v-.008z"
                                          />
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M2.25 12c0-4.97 4.478-9 10-9s10 4.03 10 9-4.478 9-10 9c-1.323 0-2.577-.177-3.75-.51L3 21l.75-4.05A9.935 9.935 0 0 1 2.25 12z"
                                          />
                                        </svg>
                                      </p>
                                      {isSearch
                                        ? props.t(
                                            "Aucun message ne correspond à votre recherche"
                                          )
                                        : props.t(
                                            "Synibox attend votre premier message pour traitement"
                                          )}
                                    </div>
                                  ) : (
                                    <div
                                      className="simple-text font-primary"
                                      style={{
                                        textAlign: "center",
                                        padding: "5em",
                                        fontSize: "14px"
                                      }}
                                    >
                                      {props.t("Vide")}
                                    </div>
                                  )}
                                  <div
                                    className="mb-5"
                                    style={{
                                      textAlign: "center"
                                    }}
                                  >
                                    {isRefreshLoading &&
                                      conversationsList &&
                                      conversationsList.length > 0 && (
                                        <div style={{ textAlign: "center" }}>
                                          {props.t("Chargement")}...
                                        </div>
                                      )}
                                  </div>
                                </ul>
                              </div>

                              {/* end mail 1 */}
                              {/* <Row className="justify-content-end">
                            <Col xl={9}>
                              {totalMails > 0 ? <Row className="my-4">
                                <div className="col-7">
                                  Affichage {((currentPage === 1 ? currentPage : (currentPage * pageSize) - pageSize))} - {totalPage === currentPage ? totalMails : currentPage * pageSize} sur {totalMails}
                                </div>
                                <div className="col-5">
                                  <div className="btn-group float-end">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-success waves-effect"
                                      onClick={() => handlePageChange(currentPage - 1)}
                                      disabled={currentPage === 1}
                                    >
                                      <i className="fa fa-chevron-left"></i>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-success waves-effect"
                                      onClick={() => handlePageChange(currentPage + 1)}
                                      disabled={totalPage == currentPage}
                                    >
                                      <i className="fa fa-chevron-right"></i>
                                    </button>
                                  </div>
                                </div>
                              </Row>
                                : null}
                            </Col>
                          </Row> */}
                              {/* </div>  */}
                            </div>
                            <div
                              className="d-flex flex-row flex-1"
                              style={{
                                flex: "1 1 0%",
                                position: "relative",
                                height: "100%"
                              }}
                            >
                              <Col
                                // xl={!isColumnVisible ? 7 : 5}
                                className="inbox-conversation-stream d-flex flex-column"
                                style={{
                                  padding: "0 20px 0 20px",
                                  backgroundColor: "#ffffff",
                                  flex: "none",
                                  width: isColumnVisible ? "70%" : "100%",
                                  minHeight: "93vh"
                                }}
                              >
                                {/* <div>
                                        {showReadEmailView && (
                                          <div>
                                            <Row className="email-menu-bar">
                                              <Col
                                                xl={5}
                                                xxl={7}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                  // width: "auto",
                                                  padding: "0",
                                                  marginRight: "24px"
                                                }}>
                                                {selectedMessage ? (
                                                  <div className="d-flex flex-column">
                                                    <div className="message-subject font-primary" style={{ whiteSpace: "pre-wrap" }}>
                                                      {selectedMessage.user_name}
                                                    </div>
                                                    <div className="simple-text font-primary message-headers">
                                                      {selectedMessage.origin === "whatsapp" ? (
                                                        <span style={{ fontSize: "14px" }}>
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="me-1"
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 24 24">
                                                            <path
                                                              fill="currentColor"
                                                              d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                                                            />
                                                          </svg>
                                                          Synibox WhatsApp
                                                        </span>
                                                      ) : selectedMessage.origin === "messenger" ? (
                                                        <span style={{ fontSize: "14px" }}>
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 24 24"
                                                            className="me-1">
                                                            <path
                                                              fill="currentColor"
                                                              d="M12 2C6.36 2 2 6.13 2 11.7c0 2.91 1.19 5.44 3.14 7.17c.16.13.26.35.27.57l.05 1.78c.04.57.61.94 1.13.71l1.98-.87c.17-.06.36-.09.53-.06c.9.27 1.9.4 2.9.4c5.64 0 10-4.13 10-9.7S17.64 2 12 2m6 7.46l-2.93 4.67c-.47.73-1.47.92-2.17.37l-2.34-1.73a.6.6 0 0 0-.72 0l-3.16 2.4c-.42.33-.97-.17-.68-.63l2.93-4.67c.47-.73 1.47-.92 2.17-.4l2.34 1.76a.6.6 0 0 0 .72 0l3.16-2.4c.42-.33.97.17.68.63"
                                                            />
                                                          </svg>
                                                          Synibox Messenger
                                                        </span>
                                                      ) : selectedMessage.origin === "instagram" ? (
                                                        <span style={{ fontSize: "14px" }}>
                                                          <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="me-1"
                                                            width="18"
                                                            height="18"
                                                            viewBox="0 0 24 24">
                                                            <path
                                                              fill="currentColor"
                                                              d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4zm9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8A1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5a5 5 0 0 1-5 5a5 5 0 0 1-5-5a5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3a3 3 0 0 0 3 3a3 3 0 0 0 3-3a3 3 0 0 0-3-3"
                                                            />
                                                          </svg>
                                                          Synibox Instagram
                                                        </span>
                                                      ) : (
                                                        <span></span>
                                                      )}{" "}
                                                      <span
                                                        className="me-3 simple-text font-primary"
                                                        style={{
                                                          color: "#5E44FE",
                                                          cursor: "pointer",
                                                          fontSize: "14px"
                                                        }}
                                                        onClick={() => {
                                                          // setToEmail(selectedMessage.user_email);
                                                          // onMessageCreateModalVisibility();
                                                        }}>
                                                        {props.t("Close details")}
                                                      </span>
                                                    </div>
                                                  </div>
                                                ) : (
                                                  <div className="message-subject font-primary">Aucun message </div>
                                                )}
                                              </Col>
                                              <Col className="d-flex align-items-center justify-content-end p-0" style={{ width: "fit-content" }}>
                                                {showReadEmailView ? (
                                                  <div className="me-2">
                                                    <Dropdown
                                                      isOpen={btnprimary1}
                                                      toggle={() => setBtnprimary1(!btnprimary1)}
                                                      style={{
                                                        padding: "0px 8px",
                                                        marginTop: "4px"
                                                      }}>
                                                      <DropdownToggle
                                                        tag="button"
                                                        // className={}
                                                        style={{
                                                          marginBottom: "8px",
                                                          padding: "0",
                                                          backgroundColor: "transparent",
                                                          border: "none",
                                                          borderRadius: "5px"
                                                        }}>
                                                        <svg
                                                          width="21"
                                                          height="21"
                                                          viewBox="0 0 24 24"
                                                          fill="none"
                                                          xmlns="http://www.w3.org/2000/svg">
                                                          <path
                                                            d="M13 21.0001H21M9.99999 14.9996H6.99999M21 14.9996H14M9 9.00006H21M13 2.99982H3M21 2.99982H17"
                                                            stroke="#FF7049"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                          />
                                                        </svg>
                                                      </DropdownToggle>
                                                      <DropdownMenu>
                                                        <DropdownItem
                                                          className="font-primary simple-text"
                                                          onClick={() => {
                                                            setType("copy");
                                                            togModalDossierVisibility();
                                                          }}>
                                                          {props.t("Copier vers")}
                                                        </DropdownItem>
                                                        <DropdownItem
                                                          className="font-primary simple-text"
                                                          onClick={() => {
                                                            setType("move");
                                                            togModalDossierVisibility();
                                                          }}>
                                                          {props.t("Déplacer vers")}
                                                        </DropdownItem>
                                                        <DropdownItem
                                                          className="font-primary simple-text"
                                                          onClick={() => {
                                                            setMessageToDelete([selectedMessage.$id]);
                                                            setShowReadEmailView(false);
                                                            setStartCountdown(true);
                                                          }}>
                                                          {props.t("Supprimer")}
                                                        </DropdownItem>
                                                      </DropdownMenu>
                                                    </Dropdown>
                                                  </div>
                                                ) : (
                                                  <div></div>
                                                )}
                                                {!isColumnVisible && (
                                                  <i
                                                    onClick={showColumn}
                                                    className="mdi mdi-dock-left ms-3"
                                                    style={{
                                                      cursor: "pointer",
                                                      fontSize: " 14px"
                                                    }}></i>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        )}
                                      </div> */}

                                {no_configured_mailbox && origin === "email" ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_maaia"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t(
                                          "Veuillez connecter votre boîte e-mail du service client"
                                        )}
                                      </p>
                                      <button
                                        type="button"
                                        className="view-button-no-mail "
                                        style={{
                                          backgroundColor: "#563bff",
                                          width: "auto"
                                        }}
                                        onClick={() => {
                                          navigate(`/settings`, {
                                            replace: false,
                                            state: {
                                              tab: "email",
                                              modal: ""
                                            }
                                          });
                                        }}
                                      >
                                        {props.t("Ajouter")}
                                      </button>
                                    </div>
                                  </div>
                                ) : isShopifyConnected === false &&
                                  origin === "shopify" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t(
                                          "Veuillez connecter votre e-commerce Shopify"
                                        )}
                                      </p>
                                      <button
                                        type="button"
                                        className="view-button-no-mail "
                                        style={{
                                          backgroundColor: "#563bff",
                                          width: "auto"
                                        }}
                                        onClick={() => {
                                          navigate(`/settings`, {
                                            replace: false
                                          });
                                        }}
                                      >
                                        {props.t("Ajouter")}
                                      </button>
                                    </div>
                                  </div>
                                ) : process.env.REACT_APP_MAAIA_ENV ===
                                    "production" && origin === "whatsapp" ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t("Bientôt disponible")}
                                      </p>
                                    </div>
                                  </div>
                                ) : isWhConnected === false &&
                                  origin === "whatsapp" ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t(
                                          "Veuillez connecter votre compte WhatsApp Business"
                                        )}
                                      </p>
                                      <button
                                        type="button"
                                        className="view-button-no-mail "
                                        style={{
                                          backgroundColor: "#563bff",
                                          width: "auto"
                                        }}
                                        onClick={() => {
                                          navigate(`/settings`, {
                                            replace: false,
                                            state: {
                                              tab: "whatsapp",
                                              modal: ""
                                            }
                                          });
                                        }}
                                      >
                                        {props.t("Ajouter")}
                                      </button>
                                    </div>
                                  </div>
                                ) : process.env.REACT_APP_MAAIA_ENV ===
                                    "production" && origin === "messenger" ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t("Bientôt disponible")}
                                      </p>
                                    </div>
                                  </div>
                                ) : isFbConnected === false &&
                                  (origin === "messenger" ||
                                    origin === "facebook_post") ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t(
                                          "Veuillez connecter votre page Facebook"
                                        )}
                                      </p>
                                      <button
                                        type="button"
                                        className="view-button-no-mail "
                                        style={{
                                          backgroundColor: "#563bff",
                                          width: "auto"
                                        }}
                                        onClick={() => {
                                          navigate(`/settings`, {
                                            replace: false,
                                            state: {
                                              tab: "facebook",
                                              modal: ""
                                            }
                                          });
                                        }}
                                      >
                                        {props.t("Ajouter")}
                                      </button>
                                    </div>
                                  </div>
                                ) : process.env.REACT_APP_MAAIA_ENV ===
                                    "production" && origin === "instagram" ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t("Bientôt disponible")}
                                      </p>
                                    </div>
                                  </div>
                                ) : isInstagramConnected === false &&
                                  origin === "instagram" ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t(
                                          "Veuillez connecter votre page Instagram"
                                        )}
                                      </p>
                                      <button
                                        type="button"
                                        className="view-button-no-mail "
                                        style={{
                                          backgroundColor: "#563bff",
                                          width: "auto"
                                        }}
                                        onClick={() => {
                                          navigate(`/settings`, {
                                            replace: false,
                                            state: {
                                              tab: "facebook",
                                              modal: ""
                                            }
                                          });
                                        }}
                                      >
                                        {props.t("Ajouter")}
                                      </button>
                                    </div>
                                  </div>
                                ) : process.env.REACT_APP_MAAIA_ENV ===
                                    "production" &&
                                  origin === "facebook_post" ? (
                                  <div
                                    className="text-center"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <div className="text-center">
                                      <img
                                        src={logo_smartas_1}
                                        height={"40px"}
                                        width={"160px"}
                                        alt="logo_synibox"
                                      />
                                      <p
                                        className="font-primary mt-2"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {props.t("Bientôt disponible")}
                                      </p>
                                    </div>
                                  </div>
                                ) : showReadEmailView && selectedConv ? (
                                  <ReadMessage
                                    key={selectedConv.$id}
                                    showReadEmailView={showReadEmailView}
                                    conv={selectedConv}
                                    all_messages={conversationsList}
                                    folder={getBoxFromUrl()}
                                    client_data={client_data}
                                    incrementAttrByValue={incrementAttrByValue}
                                    fetchMessageOrders={fetchMessageOrders}
                                    setMessagesStateList={setMessagesStateList}
                                    messageInfos={messageInfos}
                                    incrementAttr={incrementAttr}
                                    sentMessage={sentMessage}
                                    isColumnVisible={isColumnVisible}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      marginTop: "35%"
                                    }}
                                  >
                                    <img
                                      src={logo_smartas_1}
                                      height={"40px"}
                                      width={"160px"}
                                      alt="logo_maaia"
                                    />
                                    {/* <img src={logo_synibox_2} height={"40x"} width={"40px"} /> */}
                                  </div>
                                )}
                              </Col>

                              {isColumnVisible === true && (
                                <Col
                                  // xl={2}
                                  className="detail-bar"
                                  style={{
                                    width: "30%",
                                    position: "absolute",
                                    right: "0 ",
                                    top: "0",
                                    height: "100%",
                                    overflow: "auto"
                                  }}
                                >
                                  <div className="email-menu-bar d-flex">
                                    <p
                                      className="column-title font-primary"
                                      style={{ fontSize: "12px" }}
                                    >
                                      {props.t("Détails")}
                                    </p>
                                    <Col className="d-flex justify-content-end">
                                      <span
                                        style={{ cursor: "pointer" }}
                                        className="detail-bar-menu-icon"
                                        onClick={showColumn}
                                      >
                                        <svg
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M17.3276 17.8933C16.9957 18.2251 16.6488 18.3911 16.2867 18.3911C15.9096 18.376 15.5551 18.2025 15.2233 17.8706L11.5124 14.1597L7.86934 17.8028C7.55256 18.1195 7.22069 18.2855 6.87374 18.3006C6.5117 18.3006 6.17229 18.1422 5.8555 17.8254C5.53872 17.5086 5.38787 17.1767 5.40295 16.8298C5.40295 16.4677 5.56135 16.1283 5.87813 15.8116L9.52114 12.1685L5.92339 8.57078C5.59152 8.23891 5.42558 7.89195 5.42558 7.52992C5.42558 7.16788 5.59906 6.81338 5.94601 6.46643C6.27788 6.13456 6.61729 5.97617 6.96425 5.99125C7.32628 5.99125 7.67324 6.15719 8.00511 6.48906L11.6029 10.0868L15.2459 6.4438C15.5777 6.11193 15.9172 5.95354 16.2641 5.96862C16.6111 5.95354 16.9429 6.10439 17.2597 6.42117C17.5765 6.73796 17.7349 7.07737 17.7349 7.43941C17.7349 7.77127 17.569 8.10314 17.2371 8.43501L13.5941 12.078L17.305 15.7889C17.6368 16.1208 17.8103 16.4753 17.8254 16.8524C17.8405 17.1994 17.6746 17.5463 17.3276 17.8933Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                    </Col>
                                  </div>
                                  <div className="email-menu-bar-line"> </div>
                                  {selectedConv && (
                                    <div
                                      className="d-flex align-items-center mb-4"
                                      style={{ flexDirection: "column" }}
                                    >
                                      <Badge
                                        className={`avatarBadge rounded-circle align-middle me-2 mb-2 font-primary avatarBadge_regular`}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          flexShrink: "0",
                                          height: "30px !important",
                                          width: "30px !important",
                                          fontSize: " 14px",
                                          padding: "6px"
                                        }}
                                      >
                                        {(
                                          selectedConv.from ??
                                          selectedConv.user_name ??
                                          "A"
                                        )
                                          .split(" ")
                                          .map((part) =>
                                            part.charAt(0).toUpperCase()
                                          )
                                          .join("")
                                          .slice(0, 2)}
                                      </Badge>
                                      <div className="message-subject font-primary">
                                        {selectedConv.user_name ?? "Unknown"}
                                      </div>
                                      <div
                                        className="font-primary"
                                        style={{
                                          fontSize: "14px",
                                          color: "#563bff",
                                          justifyContent: "center"
                                        }}
                                      >
                                        {selectedConv.origin === "email" ||
                                        selectedConv.origin === "shopify" ? (
                                          <a
                                            href={
                                              "mailto:" + selectedConv.user_id
                                            }
                                          >
                                            <EmailFilled
                                              width={14}
                                              height={14}
                                            />{" "}
                                            {selectedConv.user_id}
                                          </a>
                                        ) : selectedConv.origin ===
                                          "whatsapp" ? (
                                          <a
                                            href={"tel:" + selectedConv.user_id}
                                          >
                                            <CallFilled
                                              width={14}
                                              height={14}
                                            />{" "}
                                            {selectedConv.user_id}
                                          </a>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      {selectedConv ? (
                                        <span
                                          className="font-primary"
                                          style={{
                                            fontSize: "14px",
                                            color: "#505d69"
                                          }}
                                        >
                                          {" "}
                                          {formatWHDate(
                                            props,
                                            selectedConv.timestamp_last_message,
                                            true,
                                            selectedConv.timestamp_last_message
                                              .length < 13
                                              ? true
                                              : false
                                          )}
                                        </span>
                                      ) : (
                                        <span> </span>
                                      )}
                                      <div>
                                        <div className={`mt-1`}>
                                          {messageInfos[selectedConv.$id] &&
                                          messageInfos[selectedConv.$id]
                                            .client_sentiment === "neutral" ? (
                                            <img
                                              src={neutral}
                                              style={{ width: "20px" }}
                                              alt=""
                                            />
                                          ) : messageInfos[selectedConv.$id] &&
                                            messageInfos[selectedConv.$id]
                                              .client_sentiment === "happy" ? (
                                            <img
                                              src={love}
                                              style={{ width: "20px" }}
                                              alt=""
                                            />
                                          ) : messageInfos[selectedConv.$id] &&
                                            messageInfos[selectedConv.$id]
                                              .client_sentiment === "angry" ? (
                                            <img
                                              src={hate}
                                              style={{ width: "20px" }}
                                              alt=""
                                            />
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <div
                                    className="accordion accordion-flush"
                                    id="accordionFlushExample"
                                  >
                                    <hr
                                      className="m-0"
                                      style={{ borderTop: "none" }}
                                    />
                                    {selectedConv &&
                                      messageOrderInfos &&
                                      messageOrderInfos[selectedConv.$id] &&
                                      messageOrderInfos[selectedConv.$id]
                                        .length > 0 && (
                                        <div className="accordion-item">
                                          <h2
                                            className="accordion-header d-flex"
                                            id="headingFlushOne"
                                            style={{ position: "relative" }}
                                          >
                                            <button
                                              className={classnames(
                                                "accordion-button",
                                                "font-size-16",
                                                {
                                                  collapsed:
                                                    !detailsAccordion.infos
                                                }
                                              )}
                                              type="button"
                                              onClick={() =>
                                                onToggleDetailsAccordion(
                                                  !detailsAccordion.infos,
                                                  "infos"
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                fontWeight: "500"
                                              }}
                                            >
                                              {props.t("Informations")}
                                              {/* <span
                                                    className="font-size-10 ms-auto"
                                                    style={{
                                                      position: "absolute",
                                                      right: "20px",
                                                      top: "6px"
                                                    }}>
                                                    {detailsAccordion.infos ? "Fermer" : "Ouvrir"}
                                                  </span> */}
                                            </button>
                                          </h2>
                                          <Collapse
                                            isOpen={detailsAccordion.infos}
                                            className="accordion-collapse"
                                          >
                                            <div className="accordion-body">
                                              <div>
                                                {messageOrderInfos[
                                                  selectedConv.$id
                                                ].map(
                                                  (messageOrderInfo, idx) => (
                                                    <div
                                                      key={idx}
                                                      className={`${
                                                        idx > 0
                                                          ? "mt-3"
                                                          : "mt-0"
                                                      } ${
                                                        idx ===
                                                        messageOrderInfos[
                                                          selectedConv.$id
                                                        ].length -
                                                          1
                                                          ? "mb-4"
                                                          : ""
                                                      } ms-xxl-2`}
                                                    >
                                                      <div
                                                        className="d-flex align-items-center mb-2"
                                                        style={{
                                                          marginTop: "-10px",
                                                          paddingTop: "8px",
                                                          flexWrap: "wrap"
                                                        }}
                                                      >
                                                        <h5
                                                          className="font-primary d-flex gap-2 mb-0 me-xxl-3"
                                                          style={{
                                                            fontSize: "12px",
                                                            fontWeight: "bold"
                                                          }}
                                                        >
                                                          {props.t("order")}
                                                          <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={`https://${client_data?.shopify_store_url}/admin/orders/${messageOrderInfo.id}`}
                                                            className="d-flex gap-1"
                                                            style={{
                                                              color: "#5E44FE"
                                                            }}
                                                          >
                                                            {
                                                              messageOrderInfo.name
                                                            }
                                                            <ExternalLinkDuocolor
                                                              style={{
                                                                height: "14px"
                                                              }}
                                                            />
                                                          </a>
                                                        </h5>
                                                        <img
                                                          // src={messageOrderInfo.name === "#1030" ? logo_shopify : logo_prestashop}
                                                          src={logo_shopify}
                                                          style={{
                                                            height: "24px"
                                                          }}
                                                          alt="logo_cms"
                                                        />
                                                      </div>

                                                      <div
                                                        className="mb-1 d-flex align-items-center"
                                                        style={{
                                                          flexWrap: "wrap"
                                                        }}
                                                      >
                                                        <p
                                                          className="font-primary mb-1"
                                                          style={{
                                                            fontWeight: "bold",
                                                            fontSize: "12px"
                                                          }}
                                                        >
                                                          {props.t("Status")}
                                                        </p>
                                                        <div className="font-primary mb-0 d-flex gap-1 ms-xl-auto">
                                                          <div
                                                            className="badge d-flex align-items-center py-1 px-2"
                                                            style={{
                                                              borderRadius:
                                                                "10px",
                                                              backgroundColor:
                                                                getColors(
                                                                  messageOrderInfo.financial_status
                                                                )
                                                                  .backgroundColor,
                                                              color: getColors(
                                                                messageOrderInfo.financial_status
                                                              ).color,
                                                              fontSize: "10px"
                                                            }}
                                                          >
                                                            <DollarDuocolor
                                                              height="10"
                                                              className="me-1"
                                                            />
                                                            {props.t(
                                                              messageOrderInfo.financial_status
                                                            )}
                                                          </div>
                                                          <div
                                                            className="badge d-flex align-items-center py-1 px-2"
                                                            style={{
                                                              borderRadius:
                                                                "10px",
                                                              backgroundColor:
                                                                getColors(
                                                                  messageOrderInfo.fulfillment_status
                                                                )
                                                                  .backgroundColor,
                                                              color: getColors(
                                                                messageOrderInfo.fulfillment_status
                                                              ).color,
                                                              fontSize: "10px"
                                                            }}
                                                          >
                                                            {messageOrderInfo.fulfillment_status ===
                                                            "UNFULFILLED" ? (
                                                              <CrossOutlined
                                                                height="10"
                                                                className="me-1"
                                                              />
                                                            ) : (
                                                              <CheckCircleMono
                                                                height="10"
                                                                className="me-1"
                                                              />
                                                            )}
                                                            {props.t(
                                                              messageOrderInfo.fulfillment_status
                                                            )}
                                                          </div>
                                                        </div>
                                                      </div>

                                                      <div
                                                        style={{
                                                          marginTop: "12px",
                                                          border:
                                                            "1.5px solid rgba(94, 68, 254, 0.2)",
                                                          borderRadius: "8px",
                                                          marginBottom: "12px"
                                                        }}
                                                      >
                                                        {messageOrderInfo.line_items
                                                          .slice(0, 3)
                                                          .map(
                                                            (lineItem, idx) => (
                                                              <div
                                                                key={idx}
                                                                className="px-2 pt-3"
                                                              >
                                                                <div
                                                                  style={{
                                                                    display:
                                                                      "flex",
                                                                    gap: "12px"
                                                                  }}
                                                                >
                                                                  <img
                                                                    width={50}
                                                                    height={50}
                                                                    className="me-1"
                                                                    style={{
                                                                      borderRadius:
                                                                        "5px",
                                                                      border:
                                                                        "1px solid rgba(94, 68, 254, 0.3)",
                                                                      flexShrink: 0
                                                                    }}
                                                                    src={
                                                                      lineItem.image_url ??
                                                                      "https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-product-1_large.png?v=1530129292"
                                                                    }
                                                                    alt={
                                                                      lineItem.name
                                                                    }
                                                                  />
                                                                  <div
                                                                    style={{
                                                                      flex: 1,
                                                                      minWidth: 0
                                                                    }}
                                                                  >
                                                                    <div
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        justifyContent:
                                                                          "space-between",
                                                                        alignItems:
                                                                          "flex-start",
                                                                        marginBottom:
                                                                          "4px"
                                                                      }}
                                                                    >
                                                                      <div
                                                                        style={{
                                                                          fontSize:
                                                                            "12px",
                                                                          textTransform:
                                                                            "capitalize",
                                                                          color:
                                                                            "rgba(94, 68, 254)",
                                                                          fontWeight:
                                                                            "bold",
                                                                          lineHeight:
                                                                            "1.2",
                                                                          maxHeight:
                                                                            "2.4em",
                                                                          overflow:
                                                                            "hidden",
                                                                          textOverflow:
                                                                            "ellipsis",
                                                                          display:
                                                                            "-webkit-box",
                                                                          WebkitLineClamp: 2,
                                                                          WebkitBoxOrient:
                                                                            "vertical",
                                                                          wordBreak:
                                                                            "break-word",
                                                                          flex: 1,
                                                                          marginRight:
                                                                            "8px"
                                                                        }}
                                                                        title={lineItem.name.toLowerCase()}
                                                                      >
                                                                        {lineItem.name.toLowerCase()}
                                                                      </div>
                                                                      <div
                                                                        style={{
                                                                          fontSize:
                                                                            "12px",
                                                                          fontWeight:
                                                                            "bold",
                                                                          whiteSpace:
                                                                            "nowrap",
                                                                          flexShrink: 0
                                                                        }}
                                                                      >
                                                                        {`${
                                                                          messageOrderInfo.currency ===
                                                                          "EUR"
                                                                            ? "€"
                                                                            : "$"
                                                                        }${parseFloat(
                                                                          lineItem.price
                                                                        ).toFixed(
                                                                          2
                                                                        )}`}
                                                                      </div>
                                                                    </div>

                                                                    <div className="mt-2">
                                                                      <div className="d-flex gap-1">
                                                                        <div
                                                                          style={{
                                                                            fontSize:
                                                                              "12px",
                                                                            fontWeight:
                                                                              "bold"
                                                                          }}
                                                                        >{`${props.t(
                                                                          "SKU"
                                                                        )}:`}</div>
                                                                        <div
                                                                          style={{
                                                                            fontSize:
                                                                              "12px"
                                                                          }}
                                                                        >
                                                                          {
                                                                            lineItem.sku
                                                                          }
                                                                        </div>
                                                                      </div>
                                                                      <div className="d-flex gap-1">
                                                                        <div
                                                                          style={{
                                                                            fontSize:
                                                                              "12px",
                                                                            fontWeight:
                                                                              "bold"
                                                                          }}
                                                                        >{`${props.t(
                                                                          "quantity"
                                                                        )}:`}</div>
                                                                        <div
                                                                          style={{
                                                                            fontSize:
                                                                              "12px"
                                                                          }}
                                                                        >
                                                                          {
                                                                            lineItem.quantity
                                                                          }
                                                                        </div>
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            )
                                                          )}
                                                        <div className="d-flex justify-content-between align-items-end ms-2 me-2 mb-3">
                                                          <a
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            href={`https://${client_data.shopify_store_url}/admin/orders/${messageOrderInfo.id}`}
                                                            className="d-flex gap-1"
                                                            style={{
                                                              color: "#5E44FE",
                                                              fontSize: "12px",
                                                              fontWeight: "bold"
                                                            }}
                                                          >
                                                            {messageOrderInfo
                                                              .line_items
                                                              .length > 2
                                                              ? props.t(
                                                                  "Voir tous les produits"
                                                                )
                                                              : props.t(
                                                                  "Voir la commande"
                                                                )}
                                                            <ExternalLinkDuocolor
                                                              style={{
                                                                height: "14px"
                                                              }}
                                                            />
                                                          </a>

                                                          <div>
                                                            <div
                                                              className="badge d-flex align-items-center py-1 px-2 ms-auto"
                                                              style={{
                                                                borderRadius:
                                                                  "10px",
                                                                backgroundColor:
                                                                  "#5e44fe",
                                                                color: "white",
                                                                fontSize:
                                                                  "10px",
                                                                width:
                                                                  "fit-content"
                                                              }}
                                                            >
                                                              <TruckFilled
                                                                height="10"
                                                                className="me-1"
                                                              />
                                                              {`${
                                                                messageOrderInfo.currency ===
                                                                "EUR"
                                                                  ? "€"
                                                                  : "$"
                                                              }${messageOrderInfo.shipping_lines
                                                                .reduce(
                                                                  (
                                                                    total,
                                                                    shipping_line
                                                                  ) => {
                                                                    return (
                                                                      total +
                                                                        parseFloat(
                                                                          shipping_line.discounted_price
                                                                        ) || 0
                                                                    );
                                                                  },
                                                                  0
                                                                )
                                                                .toFixed(2)}`}
                                                            </div>
                                                            <div className="d-flex gap-1">
                                                              <div
                                                                style={{
                                                                  fontSize:
                                                                    "12px"
                                                                }}
                                                              >{`${props.t(
                                                                "Total"
                                                              )}:`}</div>
                                                              <div
                                                                style={{
                                                                  fontSize:
                                                                    "12px",
                                                                  fontWeight:
                                                                    "bold"
                                                                }}
                                                              >
                                                                {`${
                                                                  messageOrderInfo.currency ===
                                                                  "EUR"
                                                                    ? "€"
                                                                    : "$"
                                                                }${
                                                                  messageOrderInfo.total_price
                                                                }`}
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="d-flex justify-content-between">
                                                        <div
                                                          className="d-flex"
                                                          style={{
                                                            flexDirection:
                                                              "column"
                                                          }}
                                                        >
                                                          <div
                                                            className="font-primary mb-2"
                                                            style={{
                                                              fontWeight:
                                                                "bold",
                                                              fontSize: "12px"
                                                            }}
                                                          >
                                                            {props.t(
                                                              "Adress (Shipping)"
                                                            )}
                                                          </div>
                                                          <div className="font-size-12">
                                                            <div
                                                              className="mb-0"
                                                              style={{
                                                                fontWeight:
                                                                  "bold"
                                                              }}
                                                            >{`${messageOrderInfo.billing_address.first_name} ${messageOrderInfo.billing_address.last_name}`}</div>
                                                            {
                                                              messageOrderInfo
                                                                .billing_address
                                                                .address1
                                                            }
                                                            <br />{" "}
                                                            {`${
                                                              messageOrderInfo
                                                                .billing_address
                                                                .city
                                                            }, ${
                                                              messageOrderInfo
                                                                .billing_address
                                                                .province_code
                                                                ? `${messageOrderInfo.billing_address.province_code} ${messageOrderInfo.billing_address.zip}`
                                                                : `${messageOrderInfo.billing_address.zip}`
                                                            }`}
                                                            <br />{" "}
                                                            {
                                                              messageOrderInfo
                                                                .billing_address
                                                                .country
                                                            }
                                                          </div>
                                                        </div>
                                                        {/* <div
                                        className="d-flex"
                                        style={{
                                          flexDirection: "column",
                                        }}>
                                        <div className="font-primary mb-2" style={{ fontWeight: "bold", fontSize: "12px" }}>
                                          {props.t("Payment Details")}
                                        </div>
                                        <div className="font-size-12">
                                          <div className="d-flex gap-1">
                                            Payment via <div style={{ fontWeight: "bold" }}>Stripe</div>
                                          </div>
                                          <div className="d-flex gap-1">
                                            Mastercard <div style={{ fontWeight: "bold" }}>6789</div>
                                          </div>
                                          13 May 2024, 09:22 AM
                                        </div>
                                      </div> */}
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          </Collapse>
                                        </div>
                                      )}

                                    {alertList &&
                                    selectedConv &&
                                    alertList[selectedConv.$id] &&
                                    alertList[selectedConv.$id].length > 0 ? (
                                      <div
                                        className="accordion-item"
                                        style={{
                                          maxHeight: "60vh",
                                          overflow: "scroll"
                                        }}
                                      >
                                        <div
                                          className="accordion-header"
                                          id="headingFlushTwo"
                                        >
                                          <button
                                            className={classnames(
                                              "accordion-button",
                                              "font-size-14 d-flex align-items-center justify-content-between gap-1",
                                              {
                                                collapsed:
                                                  !detailsAccordion.alerts
                                              }
                                            )}
                                            type="button"
                                            onClick={() =>
                                              onToggleDetailsAccordion(
                                                !detailsAccordion.alerts,
                                                "alerts"
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              fontWeight: "500"
                                            }}
                                          >
                                            <div
                                              style={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center"
                                              }}
                                            >
                                              <img
                                                src={synibox_icon_state_pink}
                                                alt="synibox_icon_state_pink"
                                                style={{
                                                  width: "auto",
                                                  height: "24px"
                                                }}
                                              />
                                              {props.t("Attentions Requises")}
                                              {/* <span className="font-size-10 ms-auto">{detailsAccordion.alerts ? "Fermer" : "Ouvrir"}</span> */}
                                            </div>
                                          </button>
                                        </div>

                                        <Collapse
                                          isOpen={detailsAccordion.alerts}
                                          className="accordion-collapse"
                                        >
                                          <div className="accordion-body">
                                            {alertList[selectedConv.$id].map(
                                              (alert, index) => (
                                                <div
                                                  key={index}
                                                  className={`font-primary font-size-12 mb-2 ${
                                                    index ===
                                                    alertList[selectedConv.$id]
                                                      .length -
                                                      1
                                                      ? "mb-4"
                                                      : ""
                                                  }`}
                                                  style={{
                                                    maxWidth: "fit-content",
                                                    fontWeight: "bold",
                                                    color: "black"
                                                  }}
                                                >
                                                  {`${formatDate(
                                                    props,
                                                    alert.$createdAt,
                                                    true
                                                  )} : `}
                                                  <span
                                                    style={{
                                                      fontWeight: "normal",
                                                      fontSize: "12px"
                                                    }}
                                                  >
                                                    {getLanguageVersion(
                                                      alert.message
                                                    )}
                                                  </span>
                                                  {alert.type ===
                                                    "missing_data" && (
                                                    <div className="row">
                                                      <div
                                                        className="col-auto font-primary"
                                                        style={{
                                                          background: "#563BFF",
                                                          marginTop: "10px",
                                                          marginLeft: "20px",
                                                          marginRight: "20px",
                                                          paddingTop: "5px",
                                                          paddingBottom: "5px",
                                                          borderRadius: "10px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          color: "white",
                                                          gap: "8px",
                                                          cursor: "pointer"
                                                        }}
                                                        onClick={() => {
                                                          onSeletectAlert(
                                                            alert
                                                          );
                                                          tog_list(alert);
                                                        }}
                                                      >
                                                        {props.t("Valider")}
                                                      </div>
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </Collapse>
                                      </div>
                                    ) : (
                                      messageInfos &&
                                      selectedConv &&
                                      messageInfos[selectedConv.$id] &&
                                      (messageInfos[selectedConv.$id]
                                        .failure_reason.length > 0 ||
                                        (messageInfos[selectedConv.$id]
                                          .dedicated_team_action_needed &&
                                          messageInfos[selectedConv.$id]
                                            .dedicated_team_action_needed
                                            .length > 0)) && (
                                        <div
                                          className="accordion-item"
                                          style={{
                                            maxHeight: "60vh",
                                            overflow: "scroll"
                                          }}
                                        >
                                          {messageInfos[selectedConv.$id]
                                            .dedicated_team_action_needed &&
                                          messageInfos[selectedConv.$id]
                                            .dedicated_team_action_needed
                                            .length > 0 ? (
                                            <h2
                                              className="accordion-header"
                                              id="headingFlushTwo"
                                              style={{
                                                position: "relative"
                                              }}
                                            >
                                              <button
                                                className={classnames(
                                                  "accordion-button",
                                                  "font-size-16 d-flex align-items-center gap-1",
                                                  {
                                                    collapsed:
                                                      !detailsAccordion.alerts
                                                  }
                                                )}
                                                type="button"
                                                onClick={() =>
                                                  onToggleDetailsAccordion(
                                                    !detailsAccordion.alerts,
                                                    "alerts"
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  fontWeight: "500"
                                                }}
                                              >
                                                <img
                                                  src={synibix_icon_buble_chat}
                                                  alt="synibix_icon_buble_chat"
                                                  style={{
                                                    width: "auto",
                                                    height: "24px"
                                                  }}
                                                />
                                                {props.t("Attentions Requises")}
                                                {/* <span
                                                      className="font-size-10 ms-auto"
                                                      style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "6px"
                                                      }}>
                                                      {detailsAccordion.alerts ? "Fermer" : "Ouvrir"}
                                                    </span> */}
                                              </button>
                                            </h2>
                                          ) : (
                                            <h2
                                              className="accordion-header"
                                              id="headingFlushTwo"
                                              style={{
                                                position: "relative"
                                              }}
                                            >
                                              <button
                                                className={classnames(
                                                  "accordion-button",
                                                  "font-size-16 d-flex align-items-center gap-1",
                                                  {
                                                    collapsed:
                                                      !detailsAccordion.alerts
                                                  }
                                                )}
                                                type="button"
                                                onClick={() =>
                                                  onToggleDetailsAccordion(
                                                    !detailsAccordion.alerts,
                                                    "alerts"
                                                  )
                                                }
                                                style={{
                                                  cursor: "pointer",
                                                  fontWeight: "500"
                                                }}
                                              >
                                                <img
                                                  src={
                                                    messageInfos[
                                                      selectedConv.$id
                                                    ].process_state ===
                                                    "Treated"
                                                      ? maaiaIconInfoPurple
                                                      : maaiaIconInfoPink
                                                  }
                                                  alt="logo_smartas_1"
                                                  style={{
                                                    width: "auto",
                                                    height: "24px"
                                                  }}
                                                />
                                                {props.t(
                                                  messageInfos[selectedConv.$id]
                                                    .process_state
                                                )}
                                                {/* <span
                                                      className="font-size-10 ms-auto"
                                                      style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "6px"
                                                      }}>
                                                      {detailsAccordion.alerts ? "Fermer" : "Ouvrir"}
                                                    </span> */}
                                              </button>
                                            </h2>
                                          )}

                                          <Collapse
                                            isOpen={detailsAccordion.alerts}
                                            className="accordion-collapse"
                                          >
                                            <div className="accordion-body">
                                              <div
                                                style={{
                                                  maxWidth: "fit-content",
                                                  fontWeight: "bold",
                                                  color: "black"
                                                }}
                                              >
                                                {messageInfos[selectedConv.$id]
                                                  .dedicated_team_action_needed
                                                  .length > 0
                                                  ? messageInfos[
                                                      selectedConv.$id
                                                    ].dedicated_team_action_needed.map(
                                                      (dedicated) => (
                                                        <div
                                                          style={{
                                                            display:
                                                              "inline-flex",
                                                            gap: "5px",
                                                            marginBottom: "5px"
                                                          }}
                                                        >
                                                          <span
                                                            style={{
                                                              whiteSpace:
                                                                "nowrap",
                                                              color: "red",
                                                              cursor: "pointer"
                                                            }}
                                                          >
                                                            {svgs.info_icon}
                                                          </span>
                                                          <span
                                                            style={{
                                                              marginLeft: "5px",
                                                              fontWeight:
                                                                "normal",
                                                              fontSize: "12px"
                                                            }}
                                                          >
                                                            <b
                                                              style={{
                                                                fontWeight:
                                                                  "bold",
                                                                fontSize:
                                                                  "12px",
                                                                color: "black"
                                                              }}
                                                            >{`${
                                                              formatDateHours(
                                                                props,
                                                                getDedicatedDate(
                                                                  dedicated
                                                                ),
                                                                true,
                                                                true,
                                                                true
                                                              ) ?? ""
                                                            } ${
                                                              getDedicatedDate(
                                                                dedicated
                                                              )
                                                                ? ": "
                                                                : ""
                                                            }`}</b>
                                                            {getLanguageVersion(
                                                              dedicated
                                                            )}
                                                          </span>
                                                        </div>
                                                      )
                                                    )
                                                  : messageInfos[
                                                      selectedConv.$id
                                                    ].failure_reason.length >
                                                      0 &&
                                                    messageInfos[
                                                      selectedConv.$id
                                                    ].failure_reason.map(
                                                      (failure) => (
                                                        <div
                                                          style={{
                                                            display: "flex",
                                                            gap: "5px"
                                                          }}
                                                        >
                                                          {/* {`${formatDate(
                                                              props,
                                                              messageInfos[
                                                                selectedConv.$id
                                                              ].$createdAt,
                                                              true
                                                            )} : `} */}
                                                          <span
                                                            style={{
                                                              color: "red",
                                                              cursor: "pointer"
                                                            }}
                                                          >
                                                            {svgs.info_icon}
                                                          </span>
                                                          <span
                                                            style={{
                                                              fontWeight:
                                                                "normal",
                                                              fontSize: "12px"
                                                            }}
                                                          >
                                                            {getLanguageVersion(
                                                              failure
                                                            )}
                                                          </span>
                                                        </div>
                                                      )
                                                    )}
                                              </div>
                                              {/* {!messageInfos[selectedMessage.$id].dedicated_team_action_needed &&
                                        messageInfos[selectedMessage.$id].failure_reason && (
                                          <div className="row">
                                            <div
                                              className="col-auto font-primary"
                                              style={{
                                                background: "#563BFF",
                                                marginTop: "10px",
                                                marginLeft: "20px",
                                                marginRight: "20px",
                                                paddingTop: "5px",
                                                paddingBottom: "5px",
                                                borderRadius: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                color: "white",
                                                gap: "8px",
                                                cursor: "pointer"
                                              }}
                                              onClick={() => {
                                             deleteEmailProcessData(selectedMessage.$id);
                                              }}>
                                              {props.t("Traiter à nouveau")}
                                            </div>
                                          </div>
                                        )} */}
                                            </div>
                                          </Collapse>
                                        </div>
                                      )
                                    )}

                                    {selectedConv &&
                                      messagesTagsList[selectedConv.$id] &&
                                      messagesTagsList[selectedConv.$id]
                                        .length > 0 && (
                                        <div className="accordion-item">
                                          <h2
                                            className="accordion-header"
                                            id="headingFlushThree"
                                            style={{ position: "relative" }}
                                          >
                                            <button
                                              className={classnames(
                                                "accordion-button",
                                                "fw-medium font-size-16",
                                                {
                                                  collapsed:
                                                    !detailsAccordion.tags
                                                }
                                              )}
                                              type="button"
                                              onClick={() =>
                                                onToggleDetailsAccordion(
                                                  !detailsAccordion.tags,
                                                  "tags"
                                                )
                                              }
                                              style={{
                                                cursor: "pointer",
                                                fontWeight: "500"
                                              }}
                                            >
                                              {props.t("Catégories")}
                                              {/* <span
                                                  className="font-size-10 ms-auto"
                                                  style={{
                                                    position: "absolute",
                                                    right: "20px",
                                                    top: "6px"
                                                  }}>
                                                  {detailsAccordion.tags ? "Fermer" : "Ouvrir"}
                                                </span> */}
                                            </button>
                                          </h2>
                                          <Collapse
                                            isOpen={detailsAccordion.tags}
                                            className="accordion-collapse"
                                          >
                                            <div className="accordion-body">
                                              <div
                                                className="d-flex gap-1"
                                                style={{
                                                  flexWrap: "wrap"
                                                }}
                                              >
                                                {messagesTagsList[
                                                  selectedConv.$id
                                                ].map((reason, index) => (
                                                  <div
                                                    key={index}
                                                    className={`badge font-primary`}
                                                    style={{
                                                      backgroundColor: `${stringToColour(
                                                        reason
                                                      )}25`,
                                                      color:
                                                        stringToColour(reason),
                                                      display: "flex",
                                                      padding: "4px",
                                                      maxWidth: "fit-content"
                                                    }}
                                                  >
                                                    {props.t(reason)}
                                                  </div>
                                                ))}
                                              </div>
                                            </div>
                                          </Collapse>
                                        </div>
                                      )}
                                  </div>
                                </Col>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* <Col xl={3} className="mb-4 mb-xl-0 pe-1">
                    <div className="email-leftbar">
                      <div className="card">
                        <div className="card-body">
                          <div className="d-grid">
                            <Link
                              to="/compose-email"
                              className="btn btn-danger waves-effect waves-light w-100"
                            >
                           <i className="mdi mdi-plus me-2"></i>  
                              Nouveau message
                            </Link>
                          </div>

                          <div className="card p-0 overflow-hidden mt-4 shadow-none">
                            <div className="mail-list">
                              <div
                                onClick={() => goToMessageReadView(undefined)}
                                style={{ cursor: "pointer" }}
                                className="active bg-soft-primary p-3"
                              >
                                <div className="d-flex align-items-center">
                                  <i className="mdi mdi-email-outline font-size-20 align-middle me-3"></i>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-0">
                                      Tous
                                    </h5>
                                    <span className="text-muted font-size-13 text-truncate">
                                      Tous les messages
                                    </span>
                                  </div>
                                  <div className="flex-shrink-0">
                                    <div className="float-end">
                                      <span className="bg-primary badge">
                                        18
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <a href="#" className="border-bottom">
                                <div className="d-flex align-items-center">
                                  <i className="mdi mdi-star-outline font-size-20 align-middle me-3"></i>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-0">
                                      Marqués
                                    </h5>
                                    <span className="text-muted font-size-13 text-truncate">
                                      Vos messages marqués
                                    </span>
                                  </div>
                                  <div className="flex-shrink-0"></div>
                                </div>
                              </a>

                                                       <a href="#" className="border-bottom">
                            <div className="d-flex align-items-center">
                              <i className="mdi mdi-diamond-stone font-size-20 align-middle me-3"></i>
                              <div className="flex-grow-1">
                                <h5 className="font-size-14 mb-0">Important</h5>
                                <span className="text-muted font-size-13 text-truncate">
                                  Selected messages
                                </span>
                              </div>
                              <div className="flex-shrink-0"></div>
                            </div>
                          </a> 

                              <a href="#" className="border-bottom">
                                <div className="d-flex align-items-center">
                                  <i className="mdi mdi-file-outline font-size-20 align-middle me-3"></i>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-0">
                                      Brouillon
                                    </h5>
                                    <span className="text-muted font-size-13 text-truncate"></span>
                                  </div>
                                  <div className="flex-shrink-0"></div>
                                </div>
                              </a>

                              <a href="#" className="border-bottom">
                                <div className="d-flex align-items-center">
                                  <i className="mdi mdi-email-check-outline font-size-20 align-middle me-3"></i>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-0">
                                      Envoyés
                                    </h5>
                                    <span className="text-muted font-size-13 text-truncate"></span>
                                  </div>
                                  <div className="flex-shrink-0">
                                    <div className="float-end">
                                      <span className="bg-success badge">
                                        08
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </a>
                              <a href="#">
                                <div className="d-flex align-items-center">
                                  <i className="mdi mdi-trash-can-outline font-size-20 align-middle me-3"></i>
                                  <div className="flex-grow-1">
                                    <h5 className="font-size-14 mb-0">
                                      Supprimés
                                    </h5>
                                    <span className="text-muted font-size-13 text-truncate"></span>
                                  </div>
                                  <div className="flex-shrink-0"></div>
                                </div>
                              </a>
                            </div>
                          </div>

                                        <h5 className="mt-3 font-size-15 text-uppercase">Labels</h5>

                      <div className="card p-0 overflow-hidden mt-3 shadow-none">
                        <div className="mail-list">
                          <a href="#" className="border-bottom">
                            <span className="mdi mdi-arrow-right-drop-circle text-info float-end"></span>
                            Theme Support
                          </a>
                          <a href="#" className="border-bottom">
                            <span className="mdi mdi-arrow-right-drop-circle text-warning float-end"></span>
                            Freelance
                          </a>
                          <a href="#" className="border-bottom">
                            <span className="mdi mdi-arrow-right-drop-circle text-primary float-end"></span>
                            Social
                          </a>
                          <a href="#" className="border-bottom">
                            <span className="mdi mdi-arrow-right-drop-circle text-danger float-end"></span>
                            Friends
                          </a>
                          <a href="#">
                            <span className="mdi mdi-arrow-right-drop-circle text-success float-end"></span>
                            Family
                          </a>
                        </div>
                      </div>

                      <h5 className="mt-3 font-size-15 text-uppercase">Chat</h5>

                      <div className="card p-0 overflow-hidden mt-3 mb-1 shadow-none">
                        <div className="mail-list">
                          <a
                            href="javascript: void(0);"
                            className="d-flex align-items-start border-bottom"
                          >
                            <img
                              className="flex-shrink-0 me-3 rounded-circle"
                              src={avatar_2}
                              alt="Generic placeholder image"
                              height="36"
                            ></img>
                            <div className="flex-grow-1 chat-user-box">
                              <p className="user-title m-0">Scott Median</p>
                              <p className="text-muted mb-0">Hello</p>
                            </div>
                          </a>

                          <a
                            href="javascript: void(0);"
                            className="d-flex align-items-start border-bottom"
                          >
                            <img
                              className="flex-shrink-0 me-3 rounded-circle"
                              src={avatar_3}
                              alt="Generic placeholder image"
                              height="36"
                            ></img>
                            <div className="flex-grow-1 chat-user-box">
                              <p className="user-title m-0">Julian Rosa</p>
                              <p className="text-muted mb-0">
                                What about our next..
                              </p>
                            </div>
                          </a>

                          <a
                            href="javascript: void(0);"
                            className="d-flex align-items-start border-bottom"
                          >
                            <img
                              className="flex-shrink-0 me-3 rounded-circle"
                              src={avatar_4}
                              alt="Generic placeholder image"
                              height="36"
                            ></img>
                            <div className="flex-grow-1 chat-user-box">
                              <p className="user-title m-0">David Medina</p>
                              <p className="text-muted mb-0">
                                Yeah everything is fine
                              </p>
                            </div>
                          </a>

                          <a
                            href="javascript: void(0);"
                            className="d-flex align-items-start border-bottom"
                          >
                            <img
                              className="flex-shrink-0 me-3 rounded-circle"
                              src={avatar_6}
                              alt="Generic placeholder image"
                              height="36"
                            ></img>
                            <div className="flex-grow-1 chat-user-box">
                              <p className="user-title m-0">Jay Baker</p>
                              <p className="text-muted mb-0">Wow that's great</p>
                            </div>
                          </a>
                        </div>
                      </div> 
                        </div>
                      </div>
                    </div>
                  </Col> */}

                        {/*  <!-- Right Sidebar --> */}

                        {/* <!-- end Col-9 --> */}
                      </div>
                    </div>
                    {/* <!-- End row --> */}

                    {/* <!-- container-fluid --> */}

                    {/* <!-- End Page-content --> */}

                    {/* <!-- Modal --> */}
                    <div
                      className="modal fade"
                      id="composemodal"
                      tabIndex="-1"
                      role="dialog"
                      aria-labelledby="composemodalTitle"
                      aria-hidden="true"
                    >
                      <div
                        className="modal-dialog modal-dialog-centered"
                        role="document"
                      >
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5
                              className="modal-title font-primary"
                              id="composemodalTitle"
                            >
                              New Message
                            </h5>
                            <button
                              type="button"
                              className="btn-close"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                            ></button>
                          </div>
                          <div className="modal-body">
                            <form>
                              <div className="mb-3">
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="To"
                                ></input>
                              </div>

                              <div className="mb-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Subject"
                                ></input>
                              </div>
                              <div className="mb-3">
                                <div id="email-editor"></div>
                              </div>
                            </form>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-secondary font-primary"
                              data-bs-dismiss="modal"
                            >
                              Close
                            </button>
                            <button type="button" className="btn btn-primary">
                              Send{" "}
                              <i className="fab fa-telegram-plane ms-1 font-primary"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* @@include("partials/footer.html") */}
                  </div>
                  {/* <!-- end main content--> */}

                  {/*  <!-- END layout-wrapper --> */}

                  {/* @@include("partials/right-sidebar.html")

                   @@include("partials/vendor-scripts.html") */}

                  {/*  <!-- ckeditor --> */}
                  <script src="assets/libs/@ckeditor/ckeditor5-build-classic/build/ckeditor.js"></script>

                  {/* <!-- email editor init --> */}
                  <script src="assets/js/pages/email-editor.init.js"></script>

                  <script src="assets/js/app.js"></script>

                  {/* </body> */}

                  {/* </html> */}
                </Container>

                <div>
                  <Modal
                    isOpen={modal_backdrop}
                    toggle={() => {
                      togModalVisibility();
                    }}
                    id="firstmodal"
                  >
                    <div className="modal-header">
                      <h5 className="modal-title" id="myModalLabel">
                        Succès
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                          setModalVisibility(false);
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p className="font-primary">Votre message est envoyé !</p>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light "
                        style={{ fontSize: "16px" }}
                        onClick={() => {
                          setModalVisibility();
                        }}
                      >
                        Okay
                      </button>
                    </div>
                  </Modal>
                </div>
                {startCountdown && (
                  <div
                    className="position-fixed p-3"
                    style={{
                      zIndex: "9999999",
                      bottom: "10px",
                      left: "35px"
                    }}
                  >
                    <CustomToast
                      isOpen={startCountdown}
                      toggle={() => {
                        stopDeletionCountdown();
                      }}
                      message={{
                        title: props.t("Message"),
                        body: (
                          <div className="mt-2">
                            <Button
                              className="font-primary simple-text me-2"
                              onClick={() => {
                                stopDeletionCountdown();
                              }}
                              style={{
                                fontSize: "14px",
                                borderRadius: "12px"
                              }}
                            >
                              {props.t("Annuler la suppression")}
                            </Button>
                            {decompte}s
                          </div>
                        ),
                        key: "danger"
                      }}
                    />
                  </div>
                )}

                <Modal
                  isOpen={moveToModal}
                  toggle={tog_Modal}
                  centered
                  className=""
                  style={{ maxWidth: "30%" }}
                >
                  <ModalBody>
                    <Button
                      className="close_button"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        padding: "0px",
                        float: "right"
                      }}
                      onClick={() => {
                        tog_Modal();
                      }}
                    >
                      {svgs.close_icon}
                    </Button>
                    <h1
                      className="modal_title"
                      style={{ marginTop: "4%", marginBottom: "4%" }}
                    >
                      {props.t("Attention")}
                    </h1>
                    <Row
                      className="mb-3"
                      style={{ paddingLeft: "5%", paddingRight: "5%" }}
                    >
                      <p className="text-center font-primary simple-text">
                        {props.t("moving_alert_msg")}
                      </p>
                    </Row>
                    <Row
                      className="mb-2 d-flex justify-content-center gap-3"
                      style={{ paddingLeft: "5%", paddingRight: "5%" }}
                    >
                      <Button
                        style={{
                          padding: "8px 10px",
                          borderRadius: "10px",
                          fontWeight: "600",
                          backgroundColor: "#563bff",
                          boxShadow:
                            "0px 16.20517px 37.81205px 0px rgba(255, 112, 73, 0.2)",
                          border: "none"
                        }}
                        className="col-3 font-primary simple-text"
                        onClick={() => {
                          // selectedAction(
                          //   multiSelectedMessage.length > 0
                          //     ? multiSelectedMessage
                          //     : [selectedMessage.messageId],
                          //   getBoxFromUrl(),
                          //   folder.name
                          // );
                        }}
                      >
                        {props.t("Oui")}
                      </Button>
                      <Button
                        className="col-3 font-primary simple-text"
                        style={{
                          padding: "8px 10px",
                          borderRadius: "10px",
                          border: "none",
                          fontWeight: "600"
                        }}
                        onClick={() => {
                          tog_Modal();
                        }}
                      >
                        {props.t("Annuler")}
                      </Button>
                    </Row>
                  </ModalBody>
                </Modal>

                <div>
                  <Modal
                    isOpen={modal_dossier}
                    toggle={() => {
                      togModalDossierVisibility();
                    }}
                    id="firstmodal"
                  >
                    <div className="modal-header">
                      <h5
                        className="modal-title font-primary"
                        id="myModalLabel"
                      >
                        {props.t("Dossiers")}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                          togModalDossierVisibility(false);
                        }}
                      >
                        {/* <span aria-hidden="true">&times;</span> */}
                      </button>
                    </div>
                    <div className="modal-body">
                      {["Junk", "Draft", "Archive"].map((folder, index) => (
                        <div key={index}>
                          <Row
                            // onClick={() => {
                            //   selectedAction(
                            //     selectedMessage.messageId,
                            //     the_folder,
                            //     folder.name
                            //   );
                            // }}
                            onClick={() => {
                              // if (type === "move") {
                              //   togModalDossierVisibility();
                              //   tog_Modal(folder);
                              // }
                              togModalDossierVisibility();
                              actionConv(
                                selectedConv,
                                folder.toLocaleLowerCase(),
                                false
                              );
                            }}
                            key={index}
                            className="mb-2"
                            style={{
                              borderBottom: "solid",
                              borderBottomWidth: "1px",
                              paddingBottom: "14px",
                              paddingTop: "10px",
                              borderColor: "#80808029"
                            }}
                          >
                            <div style={{ cursor: "pointer" }} className="">
                              <div key={index} className={``}>
                                {props.t(getBoxLocalName(folder))}
                                <br />
                              </div>
                            </div>
                          </Row>
                        </div>
                      ))}
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={() => {
                          togModalDossierVisibility();
                        }}
                      >
                        {props.t("Annuler")}
                      </button>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
            {/* <TabContent
              activeTab={verticalActiveTabWithIcon}
              className="text-muted mt-md-0"
            > */}
            {/* <TabPane tabId="1">
                

                 {!loading && wh_comptes && wh_comptes.length > 0 && (
                <div>
                  <Card
                    className="user-card font-primary"
                    style={{
                      borderLeft: "5px solid #563BFF",
                      marginBottom: "15px",
                      borderRadius: "10px",
                      boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.1)",
                      paddingTop: "6px",
                      paddingRight: "29px",
                      paddingBottom: "10px",
                      paddingLeft: "16px"
                    }}>
                    <CardBody className="p-0">
                      <Row>
                        <Col md={4} className="d-flex align-items-center">
                          <div className="d-flex align-items-end gap-2">
                            <div className="d-flex align-items-baseline gap-2">
                              <div
                                className="agent-name font-primary"
                                style={{
                                  width: "fit-content",
                                  color: "#1E222C",
                                  fontSize: "14px",
                                  fontStyle: "normal",
                                  fontWeight: "500",
                                  lineHeight: "38.454px",
                                  position: "relative"
                                }}>
                                <Dropdown
                                  isOpen={visibleDropdown}
                                  toggle={() => {
                                    setVisibleDropdown(!visibleDropdown);
                                  }}>
                                  <DropdownToggle
                                    tag="button"
                                    className="form-control p-0 m-0"
                                    style={{
                                      textTransform: "capitalize",
                                      border: "none",
                                      backgroundColor: "transparent",
                                      margin: "0",
                                      padding: "0"
                                    }}>
                                    {"Select visible"}
                                    <i className="ms-2 mdi mdi-chevron-down" />
                                  </DropdownToggle>
                                  <DropdownMenu className="dropdown-menu-lg-end">
                                    <DropdownItem onClick={() => {}}>v1</DropdownItem>
                                    <DropdownItem onClick={() => {}}>v2</DropdownItem>
                                    <DropdownItem onClick={() => {}}>v3</DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col md={2} className="align-items-center">
                          <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "16px" }}>
                            <div style={{ display: "flex", alignItems: "center", cursor: "pointer", marginRight: "5px" }}>
                              <span>Filtre</span>
                              <Dropdown
                                isOpen={isFilterDropdown}
                                toggle={() => {
                                  setIsFilterDropdown(!isFilterDropdown);
                                }}>
                                <DropdownToggle
                                  tag="button"
                                  className="form-control py-0 p-0 m-0"
                                  style={{
                                    textTransform: "capitalize",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    margin: "0",
                                    padding: "0"
                                  }}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                    <path
                                      fill="currentColor"
                                      d="M11 20q-.425 0-.712-.288T10 19v-6L4.2 5.6q-.375-.5-.112-1.05T5 4h14q.65 0 .913.55T19.8 5.6L14 13v6q0 .425-.288.713T13 20zm1-7.7L16.95 6h-9.9zm0 0"
                                    />
                                  </svg>
                                  <i className="ms-2 mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg-end">
                                  <DropdownItem onClick={() => {}}>f1</DropdownItem>
                                  <DropdownItem onClick={() => {}}>f2</DropdownItem>
                                  <DropdownItem onClick={() => {}}>f3</DropdownItem>
                                </DropdownMenu>
                              </Dropdown>
                            </div>

                            <div style={{ cursor: "pointer" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                <g fill="currentColor">
                                  <g fill-opacity=".3">
                                    <path d="M7.5 2.286a1 1 0 0 0-1 1v12a1 1 0 1 0 2 0v-12a1 1 0 0 0-1-1" />
                                    <path d="M8.207 2.579a1 1 0 0 0-1.414 0l-3.5 3.5a1 1 0 0 0 1.414 1.414L7.5 4.7l2.793 2.793a1 1 0 1 0 1.414-1.414z" />
                                  </g>
                                  <path d="M16.5 22.286a1 1 0 0 0 1-1v-12a1 1 0 1 0-2 0v12a1 1 0 0 0 1 1" />
                                  <path d="M15.793 21.993a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0-1.414-1.414L16.5 19.872l-2.793-2.793a1 1 0 0 0-1.414 1.414z" />
                                </g>
                              </svg>
                            </div>

                            <div style={{ cursor: "pointer" }}>
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                  d="M21 21L18.4953 18.4953C18.1033 18.1033 17.9073 17.9073 17.7092 17.8311C17.5121 17.7553 17.3684 17.7425 17.161 17.7825C16.9527 17.8226 16.6814 18.0117 16.1387 18.3897C14.6817 19.4048 12.9104 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 12.2414 19.7487 13.4241 19.2941 14.5"
                                  stroke="#2F384C"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                              </svg>
                            </div>

                            <div style={{ cursor: "pointer" }}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                                <path
                                  fill="currentColor"
                                  d="M20.92 15.62a1.2 1.2 0 0 0-.21-.33l-3-3a1 1 0 0 0-1.42 1.42l1.3 1.29H12a1 1 0 0 0 0 2h5.59l-1.3 1.29a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0l3-3a.9.9 0 0 0 .21-.33a1 1 0 0 0 0-.76M14 20H6a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h5v3a3 3 0 0 0 3 3h4a1 1 0 0 0 .92-.62a1 1 0 0 0-.21-1.09l-6-6a1 1 0 0 0-.28-.19h-.09l-.28-.1H6a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a1 1 0 0 0 0-2M13 5.41L15.59 8H14a1 1 0 0 1-1-1Z"
                                />
                              </svg>
                            </div>
                          </div>
                        </Col>
                        {wh_selected_comptes && wh_selected_comptes.length > 0 && (
                          <Col md={2} className="align-items-center ms-auto">
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "16px" }}>
                              <Dropdown
                                isOpen={selectedWHCompteDropdown}
                                toggle={() => {
                                  setselectedWHCompteDropdown(!selectedWHCompteDropdown);
                                }}>
                                <DropdownToggle
                                  tag="button"
                                  className="form-control p-0 m-0"
                                  style={{
                                    textTransform: "capitalize",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    margin: "0",
                                    padding: "0"
                                  }}>
                                  <i className="mdi mdi-facebook me-1" style={{ fontSize: "18px" }} />
                                  {wh_selected_compte ? wh_selected_compte.verified_name : "Select Page"}
                                  <i className="ms-2 mdi mdi-chevron-down" />
                                </DropdownToggle>

                                <DropdownMenu className="dropdown-menu-lg-end">
                                  {wh_selected_comptes.map((compte) => (
                                    <DropdownItem
                                      key={compte.id}
                                      onClick={() => {
                                        setWHSelectedCompte(compte);
                                      }}>
                                      {compte.verified_name}
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </div>
                          </Col>
                        )}
                      </Row>
                    </CardBody>
                  </Card>

                  {messageList.length === 0 && (
                    <div style={{ margintTop: "50px" }} className="text-center mt-5">
                      {props.t("Aucun message traité")}
                    </div>
                  )}

                  {messageList.map((message, i) => (
                    <Card
                      className="user-card font-primary"
                      style={{
                        borderLeft: "5px solid #563BFF",
                        marginBottom: "15px",
                        borderRadius: "10px",
                        boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.1)",
                        paddingTop: "6px",
                        paddingRight: "29px",
                        paddingBottom: "10px",
                        paddingLeft: "16px"
                      }}>
                      <CardBody className="p-0">
                        <Row>
                          <Col md={5} className="d-flex align-items-center">
                            <div className="row">
                              <div className="col-md-5" style={{ borderRadius: "20px" }}>
                                <img src={errorSm} alt="" />
                              </div>
                              <div className="col-md-7 flex-row align-items-center mt-3">
                                <div>{message.text}</div>
                                <div className="simple-text font-primary" style={{ fontSize: "14px" }}>
                                  {formatWABDate(message.timestamp)}
                                </div>
                                <div>
                                  <i className="mdi mdi-whatsapp me-1" style={{ fontSize: "18px" }} />
                                  {message.from}
                                </div>
                              </div>
                            </div>
                          </Col>
                          <Col md={5} className="d-flex align-items-center">
                            <div className="simple-text font-primary">
                              <div>{props.t("La réponse de Synibox est ici et ici et là.")}</div>
                            </div>
                          </Col>
                          <Col className="d-flex justify-content-end col-md-full">
                            <div className="d-flex">
                              {commentActions[i] && commentActions[i].loading ? (
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                              ) : (
                                <Dropdown
                                  isOpen={commentActions[i] && commentActions[i].state}
                                  toggle={() => {
                                    setCommentActions((prevState) => ({
                                      ...prevState,
                                      [i]: prevState[i]
                                        ? {
                                            state: !prevState[i].state,
                                            loading: prevState[i].loading
                                          }
                                        : { state: true, loading: false }
                                    }));
                                  }}
                                  style={{
                                    display: "flex"
                                  }}>
                                  <DropdownToggle
                                    tag="button"
                                    className={`btn email-menu-dropdown email-menu-dropdown-active                                      `}
                                    style={{
                                      border: "none",
                                      padding: "0",
                                      marginRight: "10px"
                                    }}>
                                    <svg width="27" height="7" viewBox="0 0 27 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <g id="Group 1000002886">
                                        <circle id="Ellipse 1029" cx="3" cy="3.24402" r="3" fill="#563BFF" />
                                        <circle id="Ellipse 1031" cx="13.4277" cy="3.24402" r="3" fill="#563BFF" />
                                        <circle id="Ellipse 1030" cx="23.5723" cy="3.24402" r="3" fill="#563BFF" />
                                      </g>
                                    </svg>
                                  </DropdownToggle>
                                  <DropdownMenu
                                    style={{
                                      marginTop: "-30px"
                                    }}>
                                    <DropdownItem
                                      onClick={() => {
                                        //   onEmployeeToUpdateChanged(employee);
                                        //   decodeAuthozations([...employee.autorizations, ...employee.contact_reasons], employee);
                                        //   tog_updateEmployeeModal();
                                      }}>
                                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                          d="M21 21L18.4953 18.4953C18.1033 18.1033 17.9073 17.9073 17.7092 17.8311C17.5121 17.7553 17.3684 17.7425 17.161 17.7825C16.9527 17.8226 16.6814 18.0117 16.1387 18.3897C14.6817 19.4048 12.9104 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 12.2414 19.7487 13.4241 19.2941 14.5"
                                          stroke="#2F384C"
                                          strokeWidth="1.5"
                                          strokeLinecap="round"
                                        />
                                      </svg>{" "}
                                      {props.t("Rechercher")}
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </CardBody>
                    </Card>
                  ))}
                </div>
              )}
              </TabPane> */}
            {/* <TabPane tabId="2">
                 <Commentaire
                  fb_selected_pages={fb_selected_pages}
                  fb_selected_page={fb_selected_page}
                  loading={loading}
                  setFBSelectedPage={setFBSelectedPage}
                  setFBSelectedPages={setFBSelectedPages}
                /> 
              </TabPane> */}
            {/* <TabPane tabId="3">
                <FacebookSettings
                  fb_selected_page={fb_selected_page}
                  fb_selected_pages={fb_selected_pages}
                  isFbConnected={isFbConnected}
                  loading={loading}
                  fb_pages={fb_pages}
                  setIsFbConnected={setIsFbConnected}
                  setFBSelectedPage={setFBSelectedPage}
                  setFBSelectedPages={setFBSelectedPages}
                  setFBPages={setFBPages}
                />
              </TabPane> */}
            {/* <TabPane tabId="4">
                {isGlobalLoading === true ? (
                  <div style={{ textAlign: "center", fontSize: "14px" }}>
                    <Spinner className="me-1" style={{ height: "15px", width: "15px" }} animation="border" />
                    {props.t("Chargement") + "..."}
                  </div>
                ) : (
                  <div className="mt-3">
                    {isWhConnected === undefined ? (
                      <div style={{ textAlign: "center", fontSize: "14px" }}>
                        <Spinner className="me-1" style={{ height: "15px", width: "15px" }} animation="border" />
                        {props.t("Chargement") + "..."}
                      </div>
                    ) : (
                      <div className="row mx-auto col-xxl-9 col-xl-11">
                        <div
                          style={{
                            border: "1px solid",
                            borderColor: "#E9ECEF",
                            borderRadius: "10px",
                            padding: "20px",
                            margin: "0 auto"
                          }}>
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "18px",
                              color: isWhConnected === true ? "black" : "#8590a5"
                            }}>
                            1. {props.t("Authentifiez")}
                          </div>
                          {isWhConnected === true ? (
                            <div>
                              <div className="mt-2">
                                {props.t("Connexion effectuée")}{" "}
                                <span style={{ color: "#563BFF" }}>
                                  <CheckCircleRounded width={24} height={24} />
                                </span>
                              </div>
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  marginTop: "10px",
                                  border: "1px solid",
                                  borderColor: "#E9ECEF",
                                  borderRadius: "10px",
                                  padding: "5px 10px 5px 10px",
                                  cursor: "pointer",
                                  width: "fit-content",
                                  backgroundColor: "#f6f6f6"
                                }}
                                onClick={() => {
                                  handleLogout();
                                }}>
                                <CrossOutlined width={22} height={22} style={{ color: "red" }} /> {props.t("Déconnexion")}
                                {isLogoutLoading && (
                                  <span className="spinner-border spinner-border-sm ms-2 font-primary" role="status" aria-hidden="true" />
                                )}
                              </div>
                            </div>
                          ) : (
                            <div>
                              <div
                                className="d-flex align-items-center"
                                style={{
                                  border: "1px solid",
                                  borderColor: "#E9ECEF",
                                  borderRadius: "10px",
                                  marginTop: "10px",
                                  padding: "5px 10px 5px 10px",
                                  cursor: "pointer",
                                  width: "fit-content"
                                }}
                                onClick={() => {
                                  handleLogin();
                                }}>
                                <i className="mdi mdi-whatsapp me-1" style={{ fontSize: "22px", color: "#563BFF" }} /> {props.t("Authentification")}
                                {isLoginLoading && (
                                  <span className="spinner-border spinner-border-sm ms-2 font-primary" role="status" aria-hidden="true" />
                                )}
                              </div>
                            </div>
                          )}
                        </div>

                        <div
                          style={{
                            border: "1px solid",
                            borderColor: "#E9ECEF",
                            borderRadius: "10px",
                            padding: "20px",
                            marginTop: "40px",
                            color: isWhConnected === true ? "black" : "#8590a5"
                          }}>
                          <div
                            style={{
                              fontWeight: "600",
                              marginBottom: "10px",
                              fontSize: "18px"
                            }}>
                            2. {props.t("Comptes WhatsApp Connectés")}
                          </div>
                          <div>
                            {wh_comptes && wh_comptes.length > 0 ? (
                              <div
                                className="d-flex ps-4"
                                style={{
                                  flexDirection: "column",
                                  width: "80%"
                                }}>
                                {wh_comptes.map((compte) => (
                                  <Card
                                    className="user-card font-primary"
                                    style={{
                                      borderLeft: "5px solid #563BFF",
                                      marginTop: "10px",
                                      marginBottom: "12px",
                                      borderRadius: "10px",
                                      boxShadow: "0px 6px 10px 1px rgba(53, 22, 252, 0.1)",
                                      paddingTop: "6px",
                                      paddingRight: "29px",
                                      paddingBottom: "10px",
                                      paddingLeft: "16px",
                                      color: "black"
                                    }}>
                                    <CardBody className="p-0">
                                      <Row>
                                        <Col md={5} className="d-flex align-items-center" style={{ fontWeight: "600" }}>
                                          {compte.verified_name}
                                        </Col>
                                        <Col md={5} className="d-flex align-items-center" style={{ fontWeight: "600" }}>
                                          {compte.display_phone_number}
                                        </Col>
                                        <Col md={2} className="align-items-center">
                                          <button
                                            onClick={(e) => {
                                              // handleRemoveWHCompte(compte.id);
                                            }}
                                            className="p-0"
                                            style={{
                                              background: "none",
                                              border: "none",
                                              color: "#F10944",
                                              float: "inline-end"
                                            }}>
                                            {deleteLoading[compte.id] ? (
                                              <span className="spinner-border spinner-border-sm ms-2 font-primary" role="status" aria-hidden="true" />
                                            ) : (
                                              <CrossOutlined width={20} height={20} />
                                            )}
                                          </button>
                                        </Col>
                                      </Row>
                                    </CardBody>
                                  </Card>
                                ))}
                              </div>
                            ) : (
                              <div className="text-center">{props.t("Vide")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </TabPane> */}
            {/* </TabContent> */}
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(MessagesPage);
